<template>
  <div id="covid-map" class="covid-map-travel">
    <div class="site-toggles">
      <v-sheet class="toolbar py-1 px-3" dense color="#607d8b6b" dark prominent width="100%">
        <v-row no-gutters>
          <v-col class="d-flex align-center" :cols="12" md="auto">
            <label>From:</label>
            <v-autocomplete dense v-model="searchFrom" :loading="loading"
              :clearable="true"
              :disabled="loading" :items="allLocations"
              :no-data-text="loading ? 'Loading...' : 'No data available'"
              flat solo light hide-details prepend-inner-icon="search"
              item-text="value" :item-value="v => v"
              label="Travel from country..." class="search mx-2"
              full-width :menu-props="{ openOnClick: false }">
              <template v-slot:selection="data">
                {{data.item.value}}
              </template>
              <template v-slot:item="data">
                <template v-if="data.item && data.item.substring">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.value"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.levelName"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
            <label>To:</label>
            <v-autocomplete dense v-model="searchTo" :loading="loading"
              :clearable="true"
              :disabled="loading" :items="allLocations"
              :no-data-text="loading ? 'Loading...' : 'No data available'"
              flat solo light hide-details prepend-inner-icon="search"
              item-text="value" :item-value="v => v"
              label="Travel to country..." class="search ml-2"
              full-width :menu-props="{ openOnClick: false }">
              <template v-slot:selection="data">
                {{data.item.value}}
              </template>
              <template v-slot:item="data">
                <template v-if="data.item && data.item.substring">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.value"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.levelName"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- <v-spacer></v-spacer>
          <v-col class="d-flex align-center justify-center py-1" :cols="12" sm="auto">
            <v-btn-toggle class="mode-toggle" :class="$vuetify.breakpoint.xsOnly ? 'mt-1' : 'mr-3'" v-model="mode" mandatory :multiple="false" 
              dark dense background-color="">
              <v-btn value="travel" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Travel
              </v-btn> 
             <v-btn value="active" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Active
              </v-btn>
              <v-btn value="total" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Total
              </v-btn>
              <v-btn value="trend" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Trend
              </v-btn>
              <v-btn value="deaths" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Deaths
              </v-btn>
            </v-btn-toggle>
          </v-col> -->
          <!-- <v-col :cols="12" sm="auto" class="d-flex align-center py-1 justify-center">
          
          </v-col> -->
        </v-row>

      </v-sheet>
     
    </div>

    

    <div class="map-frame-wrapper">
      <div class="map-frame">
        <span class="only-hint" v-if="showHint && !loading">
          Click on where you are now. We will show you where you can go next.
        </span>
        <div class="map-bottom">

          <a @click="reset()" id="zoomOutBtn" class="zoom-out-btn">
            <i class="material-icons">zoom_out</i>
          </a>
          <span class="hint info-source">
            {{ "Info from >25,000 sources (incl WHO cases & government)" }}
            <span v-if="latestDate">as of {{latestDate}}.</span>
          </span>
        </div>
      </div>
      <div class="loading-map">
        <div class="flashing">

          <h1>Loading...</h1>
          Crunching info from every country. Please wait while the map loads.
        </div>

        
        <section class="main-instructions">
          <br /><br /><br />

          CLICK COUNTRIES TO EXPLORE<br />
          SEE UPDATES ON CASES & GOVERNMENT DECISIONS<br />
          <!-- FIND THE CLOSEST TESTING SITES & CLINICAL RESEARCH SITES<br /> -->
          SIGN UP FOR NOTIFICATIONS FOR CHANGES IN YOUR AREA<br />
          TAP ON BLUE TEXT & BOXES FOR MORE INFORMATION <br />
        </section>
      </div>
    </div>
    <div class="controls">
      <a class="play-btn" @click="animatemap()">
        <i class="material-icons">play_arrow</i>
      </a>
      <span class="ranges">
        <input
          type="range"
          min="21"
          max="365"
          value="19"
          step="1"
          class="slider"
          id="myRange-top"
          @change="setToDay($event.target.value)"
        />
        <input
          type="range"
          min="21"
          max="365"
          value="19"
          step="1"
          class="slider"
          id="myRange"
        />
      </span>
      <span id="date"></span>
    </div>

    <v-btn class="mt-2" fav dark small color="primary" @click="fullReset">
      <v-icon>cached</v-icon>
    </v-btn>


      <v-expansion-panels v-model="profilePanel" accordion class="accordion" id="profilesAccordion">
        <v-expansion-panel class="card state-profile" v-show="profile.showState">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseState"
              aria-expanded="true"
              aria-controls="collapseState"
            >
              <span class="name">State</span>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseState">

            <div class="card-body">
              
              <div class="group public" v-if="mode == 'travel' && travelMode != 'both'">
                <h5>Travel</h5>
                <div class="groupChart"></div>
                <div class="main mb-3 travel-restrictions">
                  <v-row>
                    <v-col :cols="12" :sm="6" class="mb-2 py-0" v-for="filter in travelRestrictionFilters" :key="filter.name">
                      <v-checkbox class="checkbox-filter my-0" v-model="filter.value" :label="filter.display" color="" false-value="unknown" true-value="Yes" hide-details>
                      </v-checkbox>
                      <!-- <v-btn-toggle class="pl-3 mr-1" v-model="filter.value" dense>
                        <v-btn :color="filter.value == 'Yes' ? filter.yesColor + ' lighten-4' : filter.yesColor + ' lighten-5'" x-small value="Yes">
                          Yes
                        </v-btn>
                        <v-btn x-small value="unknown">
                        </v-btn>
                        <v-btn :color="filter.value == 'No' ? filter.noColor + ' lighten-4' : filter.noColor + ' lighten-5'" x-small value="No">
                          No
                        </v-btn>
                      </v-btn-toggle>
                      <span>{{filter.display}}</span> -->
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col :cols="12" :sm="6" class="mb-2 py-0" v-for="(filter, ix) in countryCharacteristicFilters" :key="ix">
                      <v-checkbox class="checkbox-filter my-0" v-model="filter.value" :label="filter.display" color="" false-value="unknown" true-value="Yes" hide-details>
                      </v-checkbox>
                      <!-- <v-btn-toggle class="pl-3 mr-1" v-model="filter.value" dense>
                        <v-btn :color="filter.value == 'Yes' ? filter.yesColor + ' lighten-4' : filter.yesColor + ' lighten-5'" x-small value="Yes">
                          Yes
                        </v-btn>
                        <v-btn x-small value="unknown">
                        </v-btn>
                        <v-btn :color="filter.value == 'No' ? filter.noColor + ' lighten-4' : filter.noColor + ' lighten-5'" x-small value="No">
                          No
                        </v-btn>
                      </v-btn-toggle>
                      <span>{{filter.display}}</span> -->
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col :cols="12" :sm="4">
                      <h6 class="px-0 mb-3">Open {{travelMode}}</h6>
                      <div class="mb-2"  v-for="(g, ix) in filteredTravelRestrictionsByRegion" :key="ix">
                        <label :class="'grey--text'" v-if="g.countries.filter(d => d.level == 'open').length">{{g.region}}</label>
                        
                        <div class="ml-1" v-for="s in g.countries.filter(d => d.level == 'open')" :key="s.state">
                          <i :class="s.level" class="material-icons mr-1">lens</i>
                          <span>{{s.state}}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col :cols="12" :sm="4">
                      <h6 class="px-0 mb-3">Restricted {{travelMode}}</h6>
                      <div class="mb-2" v-for="(g, ix) in filteredTravelRestrictionsByRegion" :key="ix">
                        <label :class="'grey--text'" v-if="g.countries.filter(d => d.level == 'restricted').length">{{g.region}}</label>
                        
                        <div class="ml-1" v-for="s in g.countries.filter(d => d.level == 'restricted')" :key="s.state">
                          <i :class="s.level" class="material-icons mr-1">lens</i>
                          <span>{{s.state}}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col :cols="12" :sm="4">
                      <h6 class="px-0 mb-3">Closed {{travelMode}}</h6>
                      <div class="mb-2"  v-for="(g, ix) in filteredTravelRestrictionsByRegion" :key="ix">
                        <label :class="'grey--text'" v-if="g.countries.filter(d => d.level == 'closed').length">{{g.region}}</label>
                        
                        <div class="ml-1" v-for="s in g.countries.filter(d => d.level == 'closed')" :key="s.state">
                          <i :class="s.level" class="material-icons mr-1">lens</i>
                          <span>{{s.state}}</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-card class="elevation-1">
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-text-field class="search-box" rounded filled dense v-model="travelSearch" append-icon="search" label="Search here for a specific country" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table dense :headers="travelTableHeaders" 
                      :items="filteredTravelRestrictions" show-expand
                      :search="travelSearch" item-key="state" class="my-2">
                      <template v-slot:item.regionStatusSortIx="{ item }">
                        <i :class="item.level" class="material-icons mr-1">lens</i>
                      </template>
                      <template v-slot:item.state="{ item }">
                        <span class="no-br">
                          <i :class="item.level" class="material-icons mr-1">lens</i>
                          {{item.state}}
                        </span>
                      </template>
                      <!-- <template v-slot:item.details.description="{ item }">
                        <span :class="item.showDescription ? 'show-description' : 'hide-description'" v-html="item.details.description" @click="item.showDescription = !item.showDescription">
                        </span>
                      </template> -->
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="py-3 px-4">
                          <span v-html="item.details.description"></span>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
                <!-- <div class="box fieldHideable icon-box">
                  <div class="icon" title="Party Size">
                    <i class="material-icons">people_alt</i>
                    <span id="field-publicPartySize">50 or less</span>
                  </div>
                  <div class="icon" title="Social Distancing">
                    <i class="material-icons">sync_alt</i>
                    <span id="field-publicSocialDistancing">6 ft</span>
                  </div>
                </div> -->
              </div>
              
              <div class="group public">
                <h5>Cases</h5>
                <div class="main mb-3">
              
                  <label class="ma-0">
                    <i class="cases-icon mr-1"></i>
                    <span class="cases"></span>
                  </label>

                  <div class="stateCasesChartWrapper">
                    <div class="stateCasesChart" id="stateCasesChart1"></div>
                  </div>
                  <div class="stateCasesChartWrapper">
                    <div class="stateCasesChart" id="stateCasesChart2"></div>
                  </div>
                </div>
                
              </div>
              <div v-if="mode != 'travel'">


                <h5 class="mt-4 banner">State Mandate Status</h5>

                <div class="summary">
                  <span id="field-executiveSummary"></span>
                </div>
                <h6 class="mt-4">Country</h6>
                <div id="reopeningStatusChartWrapper">
                  <div id="reopeningStatusChart"></div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a href="link" class="link-travelLink" id="field-travelSource"
                      >Source</a
                    >
                  </div>
                  <h5>Travel</h5>
                  <div class="groupChart"></div>

                  <div class="main">
                    <div>
                      <label>Initial Shut Down: </label>
                      <span id="field-travelShutdown"></span>
                    </div>
                    <div>
                      <label>International Flights: </label>
                      <span id="field-travelInternationalFlights"></span>
                    </div>
                    <div>
                      <label>Domestic Flights: </label>
                      <span id="field-travelDomesticFlights"></span>
                    </div>
                    <div>
                      <label>Land Border Crossing: </label>
                      <span id="field-travelLandBorderCrossing"></span>
                    </div>
                    <div>
                      <label>Intra-country travel (Citizens): </label>
                      <span id="field-travelIntraCountryTravel"></span>
                    </div>
                    <div>
                      <label>Tourism: </label>
                      <span id="field-travelTourism"></span>
                    </div>

                    <div>
                      <label>Negative COVID 19 Test (Tourism): </label>
                      <span id="field-travelNegativeCovidTest"></span>
                    </div>
                    <div>
                      <label>Quarantine: </label>
                      <span id="field-travelQuarantine"></span>
                    </div>
                  </div>
                  <div class="box fieldHideable">
                    <div>
                      <label>If Sick: </label>
                      <span id="field-travelIfSick"></span>
                    </div>
                    <div>
                      <label>Vulnerable: </label>
                      <span id="field-travelVulnerable"></span>
                    </div>
                  </div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a href="link" class="link-peopleLink" id="field-peopleSource"
                      >Source</a
                    >
                  </div>
                  <h5>People</h5>
                  <div class="groupChart"></div>
                  <div class="main">
                    <div>
                      <label>Stay Home: </label>
                      <span id="field-peopleStayAtHome">Required</span>
                    </div>
                    <div>
                      <label>Face Covering: </label>
                      <span id="field-peopleMasks">Required</span>
                    </div>
                    <div>
                      <label>Curfew: </label>
                      <span id="field-peopleCurfew"></span>
                    </div>
                  </div>
                  <div class="box fieldHideable">
                    <div>
                      <label>If Sick: </label>
                      <span id="field-peopleIfSick">Required</span>
                    </div>
                    <div>
                      <label>Vulnerable: </label>
                      <span id="field-peopleVulnerable"></span>
                    </div>
                  </div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a
                      href="link"
                      class="link-gatheringLink"
                      id="field-gatheringSource"
                      >Source</a
                    >
                  </div>
                  <h5>
                    Social Gatherings<span id="special-gatheringOpen"
                      >: Not Permitted</span
                    >
                  </h5>
                  <div class="groupChart"></div>
                  <div class="main fieldHideable">
                    <div>
                      <label>Face Covering: </label>
                      <span id="field-gatheringMasks"></span>
                    </div>
                  </div>
                  <div class="box fieldHideable icon-box">
                    <div class="icon" title="Party Size">
                      <i class="material-icons">people_alt</i>
                      <span id="field-gatheringPartySize">6 ft</span>
                    </div>
                    <div class="icon" title="Social Distancing">
                      <i class="material-icons">sync_alt</i>
                      <span id="field-gatheringSocialDistancing">50 or less</span>
                    </div>
                  </div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a
                      href="link"
                      class="link-medicalLink"
                      id="field-medicalSource"
                      >Source</a
                    >
                  </div>
                  <h5>
                    Elective Medical<span id="special-medicalOpen"
                      >: Not Permitted</span
                    >
                  </h5>
                  <div class="groupChart"></div>
                  <div class="main">
                    <div>
                      <label>Procedure: </label>
                      <span id="field-medicalOvernightStays">Not Permitted</span>
                    </div>
                    <div>
                      <label>Stay Overnight: </label>
                      <span id="field-medicalProcedures">Permitted</span>
                    </div>
                  </div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a
                      href="link"
                      class="link-schoolsLink"
                      id="field-schoolsSource"
                      >Source</a
                    >
                  </div>
                  <h5>Schools<span id="special-schoolsOpen">: Closed</span></h5>
                  <div class="groupChart"></div>
                  <div class="main"></div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a
                      href="link"
                      class="link-childcareLink"
                      id="field-childcareSource"
                      >Source</a
                    >
                  </div>
                  <h5>
                    Childcare<span id="special-childcareOpen">: Closed</span>
                  </h5>
                  <div class="groupChart"></div>
                  <div class="main">
                    <table class="requirements">
                      <tr>
                        <th></th>
                        <th>Customers</th>
                        <th>Employees</th>
                      </tr>
                      <tr>
                        <td><label>Face Covering</label></td>
                        <td id="field-childcareMasksCust"></td>
                        <td id="field-childcareMasksEm"></td>
                      </tr>
                      <tr>
                        <td><label>Screening</label></td>
                        <td id="field-childcareScreeningCust"></td>
                        <td id="field-childcareScreeningEm"></td>
                      </tr>
                    </table>
                  </div>
                  <div class="box fieldHideable icon-box">
                    <div class="icon" title="Social Distancing">
                      <i class="material-icons">sync_alt</i>
                      <span id="field-childcareSocialDistancing">6 ft</span>
                    </div>
                    <div class="icon percent" title="Occupancy">
                      <i class="material-icons">contacts</i>
                      <span id="field-childcareOccupacy">50%</span>
                    </div>
                  </div>
                </div>
                <div class="group public">
                  <div class="source">
                    For more information:
                    <a href="link" class="link-publicLink" id="field-publicSource"
                      >Source</a
                    >
                  </div>
                  <h5>Public Rec. Areas</h5>
                  <div class="groupChart"></div>
                  <div class="main">
                    <div>
                      <label>Negative COVID Test: </label>
                      <span id="field-publicNegativeCovidTest"></span>
                    </div>
                  </div>
                  <div class="main mb-3">
                    <!-- <div class="openClose" id="openClose-publicOpenPlaygrounds">
                      <i class="material-icons">lens</i>
                      <span>Playgrounds</span>
                    </div> -->
                    <div class="openClose" id="openClose-publicOpenStateParks">
                      <i class="material-icons">lens</i>
                      <span>State Parks</span>
                    </div>
                    <!-- <div
                      class="openClose"
                      id="openClose-publicOpenParkFacilities"
                    >
                      <i class="material-icons">lens</i>
                      <span>Park Facilities</span>
                    </div> -->
                    <div class="openClose" id="openClose-publicOpenBeaches">
                      <i class="material-icons">lens</i>
                      <span>Beaches</span>
                    </div>
                    <!-- <div class="openClose" id="openClose-publicOpenBoating">
                      <i class="material-icons">lens</i>
                      <span>Boating</span>
                    </div>
                    <div
                      class="openClose"
                      id="openClose-publicOpenHuntingFishing"
                    >
                      <i class="material-icons">lens</i>
                      <span>Hunting / Fishing</span>
                    </div>
                    <div class="openClose" id="openClose-publicOpenCampgrounds">
                      <i class="material-icons">lens</i>
                      <span>Campgrounds</span>
                    </div>
                    <div class="openClose" id="openClose-publicOpenTennisCourts">
                      <i class="material-icons">lens</i>
                      <span>Tennis Courts</span>
                    </div>
                    <div class="openClose" id="openClose-publicOpenGolfCourses">
                      <i class="material-icons">lens</i>
                      <span>Golf Courses</span>
                    </div> -->
                  </div>
                  <div class="box fieldHideable icon-box">
                    <!-- <div class="icon" title="Party Size">
                      <i class="material-icons">people_alt</i>
                      <span id="field-publicPartySize">50 or less</span>
                    </div> -->
                    <div class="icon" title="Social Distancing">
                      <i class="material-icons">sync_alt</i>
                      <span id="field-publicSocialDistancing">6 ft</span>
                    </div>
                  </div>
                </div>
                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a href="link" class="link-peopleLink" id="field-peopleSource"
                      >Source</a
                    >
                  </div>
                  <h5>Businesses</h5>
                  <div class="groupChart"></div>

                  <div class="main">
                    <table class="requirements fieldHideable">
                      <tr>
                        <th></th>
                        <th>Customers</th>
                        <th>Employees</th>
                      </tr>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>
                              Retail
                            </h6>
                            <a
                              class="link-retailLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-retailSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-retailOccupacy">50%</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-retailMasksCust"></td>
                          <td id="field-retailMasksEm"></td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-retailScreenCust"></td>
                          <td id="field-retailScreenEmp"></td>
                        </tr> -->
                      </tbody>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>Dine-In Restaurants</h6>
                            <a
                              class="link-restaurantsLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <!-- <div class="icon" title="Party Size">
                                <i class="material-icons">people_alt</i>
                                <span id="field-restaurantsPartySize">6 ft</span>
                              </div> -->
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-restaurantsSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-restaurantsOccupacy">50%</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-restaurantsMasksCust"></td>
                          <td id="field-restaurantsMasksEm"></td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-restaurantsScreeningCust"></td>
                          <td id="field-restaurantsScreeningEm"></td>
                        </tr> -->
                      </tbody>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>Nightclubs and Bars</h6>
                            <a
                              class="link-barsLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <!-- <div class="icon" title="Party Size">
                                <i class="material-icons">people_alt</i>
                                <span id="field-barsPartySize">6 ft</span>
                              </div> -->
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-barsSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-barsOccupacy">50%</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-barsMasksCust"></td>
                          <td id="field-barsMasksEm"></td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-barsScreeningCust"></td>
                          <td id="field-barsScreeningEm"></td>
                        </tr> -->
                      </tbody>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>Entertainment Venues</h6>
                            <a
                              class="link-entretainmentLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <!-- <div class="icon" title="Party Size">
                                <i class="material-icons">people_alt</i>
                                <span id="field-entretainmentPartySize"
                                  >6 ft</span
                                >
                              </div> -->
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-entretainmentSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-entretainmentOccupacy">50%</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-entretainmentMasksCust"></td>
                          <td id="field-entretainmentMasksEm"></td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-entretainmentScreeningCust"></td>
                          <td id="field-entretainmentScreeningEm"></td>
                        </tr> -->
                      </tbody>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>Athletic Facilities</h6>
                            <a
                              class="link-gymsLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-gymsSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-gymsOccupacy">50%</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-gymsMasksCust"></td>
                          <td id="field-gymsMasksEm"></td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-gymsScreeningCust"></td>
                          <td id="field-gymsScreeningEm"></td>
                        </tr> -->
                      </tbody>
                      <tbody class="fieldHideable">
                        <tr>
                          <th class="text-left header" colspan="3">
                            <h6>Close-Contact Biz (eg, salons)</h6>
                            <a
                              class="link-closeContactBizLink more-info"
                              href=""
                              target="_blank"
                              title="More information"
                            >
                              <i class="material-icons">information</i>
                            </a>
                            <div class="fieldHideable icon-box">
                              <div class="icon" title="Social Distancing">
                                <i class="material-icons">sync_alt</i>
                                <span id="field-closeContactBizSocialDistancing"
                                  >50 or less</span
                                >
                              </div>
                              <div class="icon percent" title="Occupancy">
                                <i class="material-icons">contacts</i>
                                <span id="field-closeContactBizOccupacy"
                                  >50%</span
                                >
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <label>Face Covering</label>
                          </td>
                          <td id="field-closeContactBizMasksCust">
                            Required
                          </td>
                          <td id="field-closeContactBizMasksEm">
                            Required
                          </td>
                        </tr>
                        <!-- <tr>
                          <td class="text-right">
                            <label>Screening</label>
                          </td>
                          <td id="field-closeContactBizScreeningCust">
                            Required
                          </td>
                          <td id="field-closeContactBizScreeningEm">
                            Required
                          </td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                  <div class="prohibited mt-2 fieldHideable">
                    <label class="header">Venue Details</label>
                    <div class="fieldHideable">
                      <label>Live Music in Restaurants: </label>
                      <span id="field-bizProhibitedDineInEntretainment"></span>
                    </div>
                    <div class="fieldHideable">
                      <label>Gyms:</label>
                      <div class="fieldHideable pl-3">
                        <label>Indoor Pools: </label>
                        <span
                          id="field-bizProhibitedAthleticFacilitiesPools"
                        ></span>
                      </div>
                      <div class="fieldHideable pl-3">
                        <label>Spas: </label>
                        <span
                          id="field-bizProhibitedAthleticFacilitiesSpas"
                        ></span>
                      </div>
                      <div class="fieldHideable pl-3">
                        <label>Showers: </label>
                        <span
                          id="field-bizProhibitedAthleticFacilitiesShowers"
                        ></span>
                      </div>
                      <div class="fieldHideable pl-3">
                        <label>Saunas: </label>
                        <span
                          id="field-bizProhibitedAthleticFacilitiesSaunas"
                        ></span>
                      </div>
                      <div class="fieldHideable pl-3">
                        <label>Indoor group classes: </label>
                        <span
                          id="field-bizProhibitedAthleticFacilitiesIndoorGroupClasses"
                        ></span>
                      </div>
                      <div class="fieldHideable pl-3">
                        <label>Close-Contact Sports: </label
                        >
                        <span
                          id="field-bizProhibitedAthleticFacilitiesCloseContactAthletics"
                        ></span>
                      </div>
                      <!-- <div class="fieldHideable">
                        <label>Close-Contact Biz (Can remove masks for services):</label>
                        <span id="field-bizProhibitedCloseContactBizRemovalOMasks"></span>
                      </div> -->
                    </div>
                  </div>
                </div>

                <div class="group fieldHideable">
                  <div class="source">
                    For more information:
                    <a
                      href="link"
                      class="link-worshipLink"
                      id="field-worshipSource"
                      >Source</a
                    >
                  </div>
                  <h5>
                    Worship
                  </h5>
                  <div class="groupChart"></div>
                  <div class="main fieldHideable">
                    <div>
                      <label>Face Covering: </label>
                      <span id="field-worshipMasks"></span>
                    </div>
                  </div>
                  <div class="box fieldHideable icon-box">
                    <!-- <div class="icon" title="Party Size">
                      <i class="material-icons">people_alt</i>
                      <span id="field-worshipPartySize">6 ft</span>
                    </div> -->
                    <div class="icon" title="Social Distancing">
                      <i class="material-icons">sync_alt</i>
                      <span id="field-worshipSocialDistancing">50 or less</span>
                    </div>
                    <div class="icon percent" title="Occupancy">
                      <i class="material-icons">contacts</i>
                      <span id="field-worshipOccupacy">50%</span>
                    </div>
                  </div>
                </div>
              </div>
              <table id="reopeningTable" class="sites-table stripped"></table>
              <!-- <table>
                <tr>
                  <th>Status</th>
                  <th>As of 5/9/2020</th>
                  <th>Restrictions and Exceptions</th>
                </tr>
              </table> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card county-profile" v-show="profile.showCounty">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseCounty"
              aria-expanded="false"
              aria-controls="collapseCounty"
            >
              <span class="name">County</span>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseCounty">
            <div class="card-body">
              <label class="ma-0">
                <i class="cases-icon"></i>
                <span class="cases"></span>
              </label>
              <label class="ma-0">
                <i class="test-site-icon material-icons">lens</i>
                <span class="numTestSites"></span>
              </label>
              <label class="ma-0">
                <i class="trial-site-icon material-icons">lens</i>
                <span class="numTrialSites"></span>
              </label>
              <div id="countyCasesChartWrapper">
                <div id="countyCasesChart"></div>
              </div>

              <h5 class="mt-3 test-sites-banner banner">
                Test Sites
              </h5>
              <div class="test-sites-toggles criteria-toggles flex-wrap">
                <div class="group">
                  <div class="criteria-toggle needAppointment">
                    <i class="material-icons">event_available</i>
                    Appointment needed
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle prescriptionRequired">
                    <i class="material-icons">list_alt</i>
                    Prescription/referral required
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle antibodyTest">
                    <i class="material-icons">science</i>
                    Antibody
                  </div>
                </div>
              </div>
              <table id="testSitesTable" class="sites-table stripped"></table>
              <h5 class="mt-3 clinical-trials-banner banner">
                Clinical Trials
              </h5>
              <div class="criteria-trials-toggles criteria-toggles flex-wrap">
                <div class="group">
                  <div class="criteria-toggle mustBeCovidPositive">
                    <i class="material-icons">coronavirus</i>
                    Must be COVID-positive
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle hasCompensation">
                    <i class="material-icons">attach_money</i>
                    Has compensation
                  </div>
                </div>
              </div>
              <table id="trialSitesTable" class="sites-table stripped"></table>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card test-site-profile" v-show="profile.showTestSites">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseTestSite"
              aria-expanded="false"
              aria-controls="collapseTestSite"
            >
              Test Site
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseTestSite">
            <div class="card-body">
              <div class="site-info"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card trial-site-profile" v-show="profile.showClinicalTrials">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseTrialSite"
              aria-expanded="false"
              aria-controls="collapseTrialSite"
            >
              Clinical Trial
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseTrialSite">
            <div class="card-body">
              <div class="site-info"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import _ from "lodash"
import moment from "moment"
import * as topojson from "topojson-client"
import $ from "jquery"
import countryMappings from '../country-mappings'
import countryRegions from '../country-regions'

// TODO: pass cookies function to file
function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  value = JSON.stringify(value)
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  let value = null
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) { 
      value = c.substring(nameEQ.length,c.length)
      break
    }
  }
  try {
    value = JSON.parse(value)
  } catch {
    console.log(`Cannot parse cookie value ${value}`)
  }
  return value;
}
function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function scaleEaseQuadInOut(domain, range) {

  return d3.scaleLinear()
      .domain(domain)
      .range(range)
      .interpolate(easeInterpolate(d3.easeQuadInOut))


  function easeInterpolate(ease) {
    return function(a, b) {
      var i = d3.interpolate(a, b)
      return function(t) {
        return i(ease(t))
      }
    }
  }
}


let green = "#329c00"
let red = "#e20000"
let yellow = "#f9df00"
let gray = "#999999"

let lineColor = "hsl(0, 100%, 54%)"
let dotColorHover = "hsl(358, 81%, 39%)"
let casesColor = "hsl(11, 94%, 65%)"
let casesColorHover = "hsl(2, 74%, 51%)"
let casesComparedColor = "hsl(231, 94%, 65%)"
let casesComparedColorHover = "hsl(222, 74%, 51%)"

var margin = { top: 20, right: 20, bottom: 30, left: 90 },
  width = 850 - margin.left - margin.right,
  height = 300 - margin.top - margin.bottom
var timeoutId = null
var projection = d3.geoStereographic()
    .scale(width)
    .translate([width, height * 1.4])
    .rotate([-100, -20])
    .clipAngle(180 - 1e-4)
    // .clipExtent([[0, 0], [width, height]])
    .precision(0.2)
var path = d3.geoPath().projection(projection)
var zoom = d3.zoom()
  .translateExtent([[35,-95-25], [780+130, 590+95-45]])

let formatNoDecimal = d3.format(",.0f")
let format = d3.format(",")

var viewBox = {
  minX: 31,
  minY: 6,
  width: 866,
  height: 500
}

var mapCounties = null
var mapStates = null
// var mapCountyTitles = null
var mapTestSites = null
var mapClinicalTrials = null

var testSitesShown = true
var clinicalTrialsShown = true

let testSitesDotColor = "#89c0d7"
// let clinicalTrialsDotColor = "#da87da"
let clinicalTrialsDotColor = "#73d473"
let stateStroke = "hsl(208, 89%, 51%)"
let countyStroke = "hsl(208, 89%, 51%)"
let countyColor = "rgb(255,245,240)"

let stateCodes = [
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "District of Columbia", code: "DC" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" },
  { name: "Montana", code: "MT" },
  { name: "Nebraska", code: "NE" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" },
  { name: "American Samoa", code: "AS" },
  { name: "Guam", code: "GU" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Micronesia", code: "FM" },
  { name: "Northern Marianas", code: "MP" },
  { name: "Palau", code: "PW" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Virgin Islands", code: "VI" }
]

let sum = (a, b) => a + b

let mainData = {
  getStateMinMax: (() => {
    let x
    return () => {
      if (!x) {
        x = mainData.stateMinMaxFn()
      }
      return x
    }
  })()
}

let testSiteTooltipHtml = d => `
<a class='siteName' href="${d.Website}">${d["Name of Facility"]}</a> <br/>
<label>Contact:</label>
<span>${d.Phone || ""}</span> <br/>
`
let clinicalTooltipHtml = d => `
<a class='siteName' href="${d["Link"]}">${d["Trial Name"]}</a> <br/>
<label>Contact:</label>
<span>${d["Contact Number (1)"]}</span><br/>
`

let testSiteProfileHtml = d => `
<a class='siteName' href="${d.Website}">${d["Name of Facility"]}</a> <br/>
<table class="site-details stripped">
  <tr><th>State</th><td>${d.stateName || ""}</td></tr>
  <tr><th>County</th><td>${d.County || ""}</td></tr>
  <tr><th>City</th><td>${d.Municipality || ""}</td></tr>
  <tr><th>Status</th><td>${d.Status || ""}</td></tr>
  <tr><th>Owner Type</th><td>${d["Owner Type"] || ""}</td></tr>
  <tr><th>Phone</th><td>${d.Phone || ""}</td></tr>
  <tr><th>Open Hours</th><td>${d["Operational Hours"] || ""}</td></tr>
  <tr><th>Comments</th><td>${d.Comments || ""}</td></tr>
  <tr><th>Instructions</th><td>${d.Instructions || ""}</td></tr>
  <tr><th>Drive-through</th><td>${d["Drive-through"] || ""}</td></tr>
  <tr><th>Appointment Only</th><td>${d["Appointment Only"] || ""}</td></tr>
  <tr><th>Referral Required</th><td>${d["Referral Required"] || ""}</td></tr>
  <tr><th>Call first</th><td>${d["Call first"] || ""}</td></tr>
  <tr><th>Virtual/Telehealth Screening</th><td>${d[
    "Virtual/Telehealth Screening"
  ] || ""}</td></tr>
</table>
`
let clinicalProfileHtml = d => `
<a class='siteName' href="${d["Link"]}">${d["Trial Name"]}</a> <br/>
<table class="site-details">
  <tr><th>State</th><td>${d["State"] || "-"}</td></tr>
  <tr><th>County</th><td>${d["County"] || "-"}</td></tr>
  <tr><th>City</th><td>${d["City"] || "-"}</td></tr>
  <tr><th>Trial Name</th><td>${d["Trial Name"] || "-"}</td></tr>
  <tr><th>Link</th><td>${d["Link"] || "-"}</td></tr>
  <tr><th>Age</th><td>${d["Age"] || "-"}</td></tr>
  <tr><th>Sex</th><td>${d["Sex"] || "-"}</td></tr>
  <tr><th>Healthy Volunteers</th><td>${d["Healthy Volunteers"] || "-"}</td></tr>
  <tr><th>Volunteer can be a PUI for COVID-19</th><td>${
    d["Volunteer can be a PUI for COVID-19"] || "-"
  }</td></tr>
  <tr><th>Volunteer can have a positive COVID-19 test</th><td>${
    d["Volunteer can have a positive COVID-19 test"] || "-"
  }</td></tr>
  <tr><th>Volunteer can have ARDS Associated with COVID-19</th><td>${
    d["Volunteer can have ARDS Associated with COVID-19"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be hospitalized</th><td>${
    d["Volunteer can be hospitalized"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be on a ventilator</th><td>${
    d["Volunteer can be on a ventilator"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be pregnant/ breastfeeding at any point during the study</th><td>${
    d["Volunteer can be pregnant/ breastfeeding at any point during the study"] || "-" || "-"
  }</td></tr>
  <tr><th>Autoimmune disorder</th><td>${d["Autoimmune disorder"] || "-"}</td></tr>
  <tr><th>Known allergies to components of the vaccine or drugs used in clinical trial (i.e., hydroxychloroquine, chloroquine, or amodiaquine)</th><td>${
    d[
      "Known allergies to components of the vaccine or drugs used in clinical trial (i.e., hydroxychloroquine, chloroquine, or amodiaquine)"
    ] || "-"
  }</td></tr>
  <tr><th>Negative Serology for HIV, HCV, HbsAg</th><td>${
    d["Negative Serology for HIV, HCV, HbsAg"] || "-"
  }</td></tr>
  <tr><th>Volunteer can participate in multiple clinical trials during or within 30 days of the study duration</th><td>${
    d[
      "Volunteer can participate in multiple clinical trials during or within 30 days of the study duration"
    ] || "-"
  }</td></tr>
  <tr><th>End-organ damage or compromised (i.e., heart, kidney, eyes,  liver)</th><td>${
    d["End-organ damage or compromised (i.e., heart, kidney, eyes,  liver)"] || "-"
  }</td></tr>
  <tr><th>Enrollment</th><td>${d["Enrollment"] || "-"}</td></tr>
  <tr><th>Phase</th><td>${d["Phase"] || "-"}</td></tr>
  <tr><th>Status</th><td>${d["Status"] || "-"}</td></tr>
  <tr><th>Start Date</th><td>${moment("1900-01-01")
    .add(+d["Start Date"] - 2, "days")
    .format("MMM D, YYYY")}</td></tr>
  <tr><th>Completion Date</th><td>${moment("1900-01-01")
    .add(+d["Completion Date"] - 2, "days")
    .format("MMM D, YYYY")}</td></tr>
  <tr><th>Locations</th><td>${d["Locations"] || "-"}</td></tr>
  <tr><th>Contact Name (1)</th><td>${d["Contact Name (1)"] || "-"}</td></tr>
  <tr><th>Contact Number (1)</th><td>${d["Contact Number (1)"] || "-"}</td></tr>
  <tr><th>Contact Email (1)</th><td>${d["Contact Email (1)"] || "-"}</td></tr>
  <tr><th>NCT Number</th><td>${d["NCT Number"] || "-"}</td></tr>
  <tr><th>Sponsor/Collaborator</th><td>${d["Sponsor/Collaborator"] || "-"}</td></tr>
</table>
`

/***** ALL MATH FUNCTIONS ****/

var to_radians = Math.PI / 180;
var to_degrees = 180 / Math.PI;


// Helper function: cross product of two vectors v0&v1
function cross(v0, v1) {
    return [v0[1] * v1[2] - v0[2] * v1[1], v0[2] * v1[0] - v0[0] * v1[2], v0[0] * v1[1] - v0[1] * v1[0]];
}

//Helper function: dot product of two vectors v0&v1
function dot(v0, v1) {
    for (var i = 0, sum = 0; v0.length > i; ++i) sum += v0[i] * v1[i];
    return sum;
}

// Helper function: 
// This function converts a [lon, lat] coordinates into a [x,y,z] coordinate 
// the [x, y, z] is Cartesian, with origin at lon/lat (0,0) center of the earth
function lonlat2xyz( coord ){

	var lon = coord[0] * to_radians;
	var lat = coord[1] * to_radians;

	var x = Math.cos(lat) * Math.cos(lon);

	var y = Math.cos(lat) * Math.sin(lon);

	var z = Math.sin(lat);

	return [x, y, z];
}

// Helper function: 
// This function computes a quaternion representation for the rotation between to vectors
// https://en.wikipedia.org/wiki/Rotation_formalisms_in_three_dimensions#Euler_angles_.E2.86.94_Quaternion
function quaternion(v0, v1) {

	if (v0 && v1) {
		
	    var w = cross(v0, v1),  // vector pendicular to v0 & v1
	        w_len = Math.sqrt(dot(w, w)); // length of w     

        if (w_len == 0)
        	return;

        var theta = .5 * Math.acos(Math.max(-1, Math.min(1, dot(v0, v1)))),

	        qi  = w[2] * Math.sin(theta) / w_len,
	        qj  = - w[1] * Math.sin(theta) / w_len,
	        qk  = w[0]* Math.sin(theta) / w_len,
	        qr  = Math.cos(theta);

	    return theta && [qr, qi, qj, qk];
	}
}

// Helper function: 
// This functions converts euler angles to quaternion
// https://en.wikipedia.org/wiki/Rotation_formalisms_in_three_dimensions#Euler_angles_.E2.86.94_Quaternion
function euler2quat(e) {

	if(!e) return;
    
    var roll = .5 * e[0] * to_radians,
        pitch = .5 * e[1] * to_radians,
        yaw = .5 * e[2] * to_radians,

        sr = Math.sin(roll),
        cr = Math.cos(roll),
        sp = Math.sin(pitch),
        cp = Math.cos(pitch),
        sy = Math.sin(yaw),
        cy = Math.cos(yaw),

        qi = sr*cp*cy - cr*sp*sy,
        qj = cr*sp*cy + sr*cp*sy,
        qk = cr*cp*sy - sr*sp*cy,
        qr = cr*cp*cy + sr*sp*sy;

    return [qr, qi, qj, qk];
}

// This functions computes a quaternion multiply
// Geometrically, it means combining two quant rotations
// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/arithmetic/index.htm
function quatMultiply(q1, q2) {
	if(!q1 || !q2) return;

    var a = q1[0],
        b = q1[1],
        c = q1[2],
        d = q1[3],
        e = q2[0],
        f = q2[1],
        g = q2[2],
        h = q2[3];

    return [
     a*e - b*f - c*g - d*h,
     b*e + a*f + c*h - d*g,
     a*g - b*h + c*e + d*f,
     a*h + b*g - c*f + d*e];

}

// This function computes quaternion to euler angles
// https://en.wikipedia.org/wiki/Rotation_formalisms_in_three_dimensions#Euler_angles_.E2.86.94_Quaternion
function quat2euler(t){

	if(!t) return;

	return [ Math.atan2(2 * (t[0] * t[1] + t[2] * t[3]), 1 - 2 * (t[1] * t[1] + t[2] * t[2])) * to_degrees, 
			 Math.asin(Math.max(-1, Math.min(1, 2 * (t[0] * t[2] - t[3] * t[1])))) * to_degrees, 
			 Math.atan2(2 * (t[0] * t[3] + t[1] * t[2]), 1 - 2 * (t[2] * t[2] + t[3] * t[3])) * to_degrees
			]
}

/*  This function computes the euler angles when given two vectors, and a rotation
	This is really the only math function called with d3 code.

	v0 - starting pos in lon/lat, commonly obtained by projection.invert
	v1 - ending pos in lon/lat, commonly obtained by projection.invert
	o0 - the projection rotation in euler angles at starting pos (v0), commonly obtained by projection.rotate
*/

function eulerAngles(v0, v1, o0) {

	/*
		The math behind this:
		- first calculate the quaternion rotation between the two vectors, v0 & v1
		- then multiply this rotation onto the original rotation at v0
		- finally convert the resulted quat angle back to euler angles for d3 to rotate
	*/

	var t = quatMultiply( euler2quat(o0), quaternion(lonlat2xyz(v0), lonlat2xyz(v1) ) );
	return quat2euler(t);	
}


/**************end of math functions**********************/

// var projection = d3.geoStereographic()
// let defaultCountrySortFn = (c1, c2) => {

//   let regionOrders = [
//     'North America',
//     'Europe',
//     'Asia',
//     'Oceania',
//     'South America',
//     'Africa',
//   ]

//   let levelOrder = [
//     'open',
//     'restricted',
//     'closed',
//     'unknown',
//   ]

//   let regionIx1 = regionOrders.indexOf(c1.region)
//   if (regionIx1 == -1) regionIx1 = regionOrders.length
  
//   let regionIx2 = regionOrders.indexOf(c2.region)
//   if (regionIx2 == -1) regionIx2 = regionOrders.length


//   let levelIx1 = levelOrders.indexOf(c1.level)
//   if (levelIx1 == -1) levelIx1 = levelOrders.length

  
//   let levelIx2 = levelOrders.indexOf(c2.level)
//   if (levelIx2 == -1) levelIx2 = levelOrders.length

//   if (regionIx1 != regionIx2) {
//     return regionIx1 - regionInx2
//   } else if (levelIx1 != levelIx2) {
//     return levelIx1 - levelInx2
//   } else if (c1.state < c2.state) {
//     return -1
//   } else if (c1.state > c2.state) {
//     return 1
//   } else {
//     return 0
//   }
  
// }

let planeCreator = {

}

// TODO: pass newCenters to a file
// window.newCenters = [{"name":"India","center":[-85.72756505398995,-23.117399704333764]},{"name":"Mauritania","center":[10.103847996226865,-19.835209344250146]},{"name":"Brazil","center":[49.017692191473664,11.860443777501011]},{"name":"Mexico","center":[100.85188872492876,-22.33091752962541]},{"name":"United States of America","center":[98.23032372040669,-39.81263776322513]},{"name":"Canada","center":[99.56527880372846,-56.90780229188138]},{"name":"Bolivia","center":[64.26675654061025,16.506414931553163]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[56.45875771079095,32.42429121499264]},{"name":"Argentina","center":[64.39966596626503,32.80407833154958]},{"name":"Chile","center":[70.64073850437995,33.86964216671636]},{"name":"Ecuador","center":[78.29019781115203,1.811650577376178]},{"name":"Colombia","center":[72.95001225671129,-5.004878134592359]},{"name":"Venezuela","center":[64.81765585061913,-7.115406038337746]},{"name":"Suriname","center":[55.67143283004393,-4.466432180122615]},{"name":"Guyana","center":[58.49198595187283,-4.975278230939868]},{"name":"France","center":[53.252919003389714,-3.786640629298787]},{"name":"Cuba","center":[79.24932054336054,-22.01525847564152]},{"name":"Dominican Rep.","center":[65.35206199310923,-29.32040771062867]},{"name":"Jamaica","center":[87.0840878859925,-21.117217566068415]},{"name":"Nicaragua","center":[84.52800129191698,-17.80368543804709]},{"name":"Honduras","center":[90.0905166648137,-23.629524185478534]},{"name":"Guatemala","center":[92.18702570038398,-21.186971827914576]},{"name":"Belize","center":[86.54710564212766,-25.635305886913418]},{"name":"El Salvador","center":[90.94205259191494,-16.92651791804706]}]
// window.newCenters = [{"name":"India","center":[-85.72756505398995,-23.117399704333764]},{"name":"Mauritania","center":[-10.247129403159681,19.19515261239914]},{"name":"Brazil","center":[-51.70397977629928,-10.40689843049369]},{"name":"Mexico","center":[-101.47350992730179,23.944497458491966]},{"name":"United States of America","center":[-99.84665960308148,38.667718496952624]},{"name":"Canada","center":[-101.64352400931315,57.366037175544456]},{"name":"Bolivia","center":[-64.78782485487451,-16.647011267673008]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[56.45875771079095,32.42429121499264]},{"name":"Argentina","center":[-64.81481207139718,-29.88518275397695]},{"name":"Chile","center":[70.64073850437995,33.86964216671636]},{"name":"Ecuador","center":[78.29019781115203,1.811650577376178]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[64.81765585061913,-7.115406038337746]},{"name":"Suriname","center":[55.67143283004393,-4.466432180122615]},{"name":"Guyana","center":[58.49198595187283,-4.975278230939868]},{"name":"France","center":[-18.463434947052686,62.578355296124165]},{"name":"Cuba","center":[79.24932054336054,-22.01525847564152]},{"name":"Dominican Rep.","center":[65.35206199310923,-29.32040771062867]},{"name":"Jamaica","center":[87.0840878859925,-21.117217566068415]},{"name":"Nicaragua","center":[84.52800129191698,-17.80368543804709]},{"name":"Honduras","center":[90.0905166648137,-23.629524185478534]},{"name":"Guatemala","center":[92.18702570038398,-21.186971827914576]},{"name":"Belize","center":[86.54710564212766,-25.635305886913418]},{"name":"El Salvador","center":[90.94205259191494,-16.92651791804706]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[36.215365848123106,38.620236352973585]},{"name":"Ukraine","center":[29.897793398676598,57.04224214816785]},{"name":"United Kingdom","center":[-1.3534602476482447,53.143991081408416]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[30.47734558989441,72.11842066083103]}]
// window.newCenters = [{"name":"India","center":[-85.72756505398995,-23.117399704333764]},{"name":"Mauritania","center":[-10.247129403159681,19.19515261239914]},{"name":"Brazil","center":[-51.70397977629928,-10.40689843049369]},{"name":"Mexico","center":[-101.47350992730179,23.944497458491966]},{"name":"United States of America","center":[-99.84665960308148,38.667718496952624]},{"name":"Canada","center":[-101.64352400931315,57.366037175544456]},{"name":"Bolivia","center":[-64.78782485487451,-16.647011267673008]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[56.45875771079095,32.42429121499264]},{"name":"Argentina","center":[-64.81481207139718,-29.88518275397695]},{"name":"Chile","center":[70.64073850437995,33.86964216671636]},{"name":"Ecuador","center":[78.29019781115203,1.811650577376178]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[64.81765585061913,-7.115406038337746]},{"name":"Suriname","center":[55.67143283004393,-4.466432180122615]},{"name":"Guyana","center":[58.49198595187283,-4.975278230939868]},{"name":"France","center":[-18.463434947052686,62.578355296124165]},{"name":"Cuba","center":[79.24932054336054,-22.01525847564152]},{"name":"Dominican Rep.","center":[65.35206199310923,-29.32040771062867]},{"name":"Jamaica","center":[87.0840878859925,-21.117217566068415]},{"name":"Nicaragua","center":[84.52800129191698,-17.80368543804709]},{"name":"Honduras","center":[90.0905166648137,-23.629524185478534]},{"name":"Guatemala","center":[92.18702570038398,-21.186971827914576]},{"name":"Belize","center":[86.54710564212766,-25.635305886913418]},{"name":"El Salvador","center":[90.94205259191494,-16.92651791804706]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[36.215365848123106,38.620236352973585]},{"name":"Ukraine","center":[29.897793398676598,57.04224214816785]},{"name":"United Kingdom","center":[-1.3534602476482447,53.143991081408416]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[30.47734558989441,72.11842066083103]}]
// window.newCenters = [{"name":"India","center":[78.94289439935574,22.110971402349254]},{"name":"Mauritania","center":[-10.247129403159681,19.19515261239914]},{"name":"Brazil","center":[-52.80745492015989,-10.793408304928976]},{"name":"Mexico","center":[-101.37378737750348,22.5629906608167]},{"name":"United States of America","center":[-98.18274402791938,39.409643648593054]},{"name":"Canada","center":[-101.88149109180665,55.587084195709046]},{"name":"Bolivia","center":[-64.78782485487451,-16.647011267673008]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[56.45875771079095,32.42429121499264]},{"name":"Argentina","center":[-64.81481207139718,-29.88518275397695]},{"name":"Chile","center":[70.64073850437995,33.86964216671636]},{"name":"Ecuador","center":[78.29019781115203,1.811650577376178]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[64.81765585061913,-7.115406038337746]},{"name":"Suriname","center":[55.67143283004393,-4.466432180122615]},{"name":"Guyana","center":[58.49198595187283,-4.975278230939868]},{"name":"France","center":[-18.463434947052686,62.578355296124165]},{"name":"Cuba","center":[79.24932054336054,-22.01525847564152]},{"name":"Dominican Rep.","center":[65.35206199310923,-29.32040771062867]},{"name":"Jamaica","center":[87.0840878859925,-21.117217566068415]},{"name":"Nicaragua","center":[84.52800129191698,-17.80368543804709]},{"name":"Honduras","center":[90.0905166648137,-23.629524185478534]},{"name":"Guatemala","center":[92.18702570038398,-21.186971827914576]},{"name":"Belize","center":[86.54710564212766,-25.635305886913418]},{"name":"El Salvador","center":[90.94205259191494,-16.92651791804706]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[35.621100597900636,38.463381132556165]},{"name":"Ukraine","center":[32.34009001609571,49.118874622278305]},{"name":"United Kingdom","center":[-1.2218688069988106,52.68102485424598]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[18.99999020190816,51.605161377901695]},{"name":"Afghanistan","center":[66.0883641763327,33.56986382092676]},{"name":"Lesotho","center":[28.234469148225525,-29.67348229506997]},{"name":"China","center":[104.23593918556868,33.665925654955046]},{"name":"Russia","center":[91.02468750569128,61.923289845606966]},{"name":"Australia","center":[136.03084961305365,-24.591464532905427]},{"name":"Ethiopia","center":[40.16077940505842,7.974961147111342]},{"name":"Dem. Rep. Congo","center":[23.457638645111842,-2.1294144248509075]},{"name":"Sudan","center":[28.771196643354102,15.617410992180686]},{"name":"Chad","center":[19.178863740793382,14.60699323577048]},{"name":"Algeria","center":[2.727114856290708,28.00139945070287]},{"name":"Egypt","center":[30.40581016933791,26.192615975871906]},{"name":"Libya","center":[17.579860717434336,28.530833175941385]},{"name":"Ghana","center":[-0.7640447673029823,8.254963004036483]}]
// window.newCenters = [{"name":"India","center":[78.94289439935574,22.110971402349254]},{"name":"Mauritania","center":[-10.247129403159681,19.19515261239914]},{"name":"Brazil","center":[-52.80745492015989,-10.793408304928976]},{"name":"Mexico","center":[-101.37378737750348,22.5629906608167]},{"name":"United States of America","center":[-98.18274402791938,39.409643648593054]},{"name":"Canada","center":[-101.88149109180665,55.587084195709046]},{"name":"Bolivia","center":[-64.57882841115892,-16.876942112896437]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[-55.54179658219716,-32.53067618036966]},{"name":"Argentina","center":[-64.20757971107471,-33.14808271609247]},{"name":"Chile","center":[-71.41577004326352,-34.05052409272624]},{"name":"Ecuador","center":[-78.43302681791924,-1.368934044078716]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[-65.02586991362207,7.0353092231092935]},{"name":"Suriname","center":[-55.6891348437334,4.251769249781486]},{"name":"Guyana","center":[-58.73785897567381,4.789034506270837]},{"name":"France","center":[-18.463434947052686,62.578355296124165]},{"name":"Cuba","center":[-78.38727812623897,21.656092969409315]},{"name":"Dominican Rep.","center":[-70.21797681559475,19.06985571661082]},{"name":"Jamaica","center":[-77.19520893684567,17.98245870937305]},{"name":"Nicaragua","center":[-85.1257179452903,12.744277786372585]},{"name":"Honduras","center":[-86.53019740252043,14.682953658918386]},{"name":"Guatemala","center":[-90.43395507403838,15.586814423916179]},{"name":"Belize","center":[-88.7315544512007,17.275530514889724]},{"name":"El Salvador","center":[-88.79158625313306,13.920210255763193]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[35.621100597900636,38.463381132556165]},{"name":"Ukraine","center":[32.34009001609571,49.118874622278305]},{"name":"United Kingdom","center":[-1.2218688069988106,52.68102485424598]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[18.99999020190816,51.605161377901695]},{"name":"Afghanistan","center":[66.0883641763327,33.56986382092676]},{"name":"Lesotho","center":[28.234469148225525,-29.67348229506997]},{"name":"China","center":[104.23593918556868,33.665925654955046]},{"name":"Russia","center":[91.02468750569128,61.923289845606966]},{"name":"Australia","center":[136.03084961305365,-24.591464532905427]},{"name":"Ethiopia","center":[40.16077940505842,7.974961147111342]},{"name":"Dem. Rep. Congo","center":[23.457638645111842,-2.1294144248509075]},{"name":"Sudan","center":[28.771196643354102,15.617410992180686]},{"name":"Chad","center":[19.178863740793382,14.60699323577048]},{"name":"Algeria","center":[2.727114856290708,28.00139945070287]},{"name":"Egypt","center":[30.40581016933791,26.192615975871906]},{"name":"Libya","center":[17.579860717434336,28.530833175941385]},{"name":"Ghana","center":[-0.7640447673029823,8.254963004036483]},{"name":"Pakistan","center":[68.38457715761115,28.711682377942562]},{"name":"Paraguay","center":[-58.31066977871734,-22.84115247136726]},{"name":"Panama","center":[-80.07599472789909,8.914542356669056]},{"name":"Costa Rica","center":[-84.027053907673,10.14879073139576]},{"name":"Puerto Rico","center":[-66.32369085547407,18.368801347964368]},{"name":"Ireland","center":[-7.942516671198579,53.251683811818424]},{"name":"Iceland","center":[-17.59154176126586,64.91539832915792]},{"name":"Norway","center":[11.663094265385961,63.94339067100269]},{"name":"Finland","center":[27.05859951785041,64.35600257721175]},{"name":"Yemen","center":[48.39700270911738,16.18460778813121]},{"name":"Oman","center":[56.376496996055224,20.306937066819675]},{"name":"United Arab Emirates","center":[54.520444452639026,23.93575559823129]},{"name":"Qatar","center":[51.035417694456875,25.32102475803211]},{"name":"Kuwait","center":[47.654086015584106,29.27243750751324]},{"name":"Saudi Arabia","center":[45.298905370980464,23.3694207093665]},{"name":"Iraq","center":[43.29532181606175,32.62251897320872]},{"name":"Jordan","center":[36.40759246375308,31.429537018220138]},{"name":"Syria","center":[37.86085269187117,34.861004700182555]},{"name":"Iran","center":[53.585123998889536,32.13860085087114]},{"name":"Turkmenistan","center":[60.875379126249754,38.81364385808361]},{"name":"Uzbekistan","center":[64.97896705995197,41.73847647027865]},{"name":"Kazakhstan","center":[67.94921032728622,47.451967814425565]},{"name":"Nepal","center":[85.08368313423526,28.03219133510349]},{"name":"Bangladesh","center":[90.42403322340769,24.0046349344297]},{"name":"Myanmar","center":[96.81996924547377,21.600442946851537]},{"name":"Bhutan","center":[90.734164798968,27.361425856337554]},{"name":"Thailand","center":[101.47984154228733,15.59184180673759]}]
// window.newCenters = [{"name":"India","center":[78.94289439935574,22.110971402349254]},{"name":"Mauritania","center":[-10.602262031896345,20.31027288829407]},{"name":"Brazil","center":[-52.80745492015989,-10.793408304928976]},{"name":"Mexico","center":[-101.37378737750348,22.5629906608167]},{"name":"United States of America","center":[-98.18274402791938,39.409643648593054]},{"name":"Canada","center":[-101.88149109180665,55.587084195709046]},{"name":"Bolivia","center":[-64.57882841115892,-16.876942112896437]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[-55.54179658219716,-32.53067618036966]},{"name":"Argentina","center":[-64.20757971107471,-33.14808271609247]},{"name":"Chile","center":[-71.41577004326352,-34.05052409272624]},{"name":"Ecuador","center":[-78.43302681791924,-1.368934044078716]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[-65.02586991362207,7.0353092231092935]},{"name":"Suriname","center":[-55.6891348437334,4.251769249781486]},{"name":"Guyana","center":[-58.73785897567381,4.789034506270837]},{"name":"France","center":[3.5773532997832045,46.88015961760242]},{"name":"Cuba","center":[-78.38727812623897,21.656092969409315]},{"name":"Dominican Rep.","center":[-70.21797681559475,19.06985571661082]},{"name":"Jamaica","center":[-77.19520893684567,17.98245870937305]},{"name":"Nicaragua","center":[-85.1257179452903,12.744277786372585]},{"name":"Honduras","center":[-86.53019740252043,14.682953658918386]},{"name":"Guatemala","center":[-90.43395507403838,15.586814423916179]},{"name":"Belize","center":[-88.7315544512007,17.275530514889724]},{"name":"El Salvador","center":[-88.79158625313306,13.920210255763193]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[35.621100597900636,38.463381132556165]},{"name":"Ukraine","center":[32.34009001609571,49.118874622278305]},{"name":"United Kingdom","center":[-1.2218688069988106,52.68102485424598]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[18.99999020190816,51.605161377901695]},{"name":"Afghanistan","center":[66.0883641763327,33.56986382092676]},{"name":"Lesotho","center":[28.234469148225525,-29.67348229506997]},{"name":"China","center":[104.23593918556868,33.665925654955046]},{"name":"Russia","center":[91.02468750569128,61.923289845606966]},{"name":"Australia","center":[136.03084961305365,-24.591464532905427]},{"name":"Ethiopia","center":[40.16077940505842,7.974961147111342]},{"name":"Dem. Rep. Congo","center":[23.457638645111842,-2.1294144248509075]},{"name":"Sudan","center":[28.771196643354102,15.617410992180686]},{"name":"Chad","center":[19.178863740793382,14.60699323577048]},{"name":"Algeria","center":[2.727114856290708,28.00139945070287]},{"name":"Egypt","center":[30.40581016933791,26.192615975871906]},{"name":"Libya","center":[17.579860717434336,28.530833175941385]},{"name":"Ghana","center":[-0.7640447673029823,8.254963004036483]},{"name":"Pakistan","center":[68.38457715761115,28.711682377942562]},{"name":"Paraguay","center":[-58.31066977871734,-22.84115247136726]},{"name":"Panama","center":[-80.07599472789909,8.914542356669056]},{"name":"Costa Rica","center":[-84.027053907673,10.14879073139576]},{"name":"Puerto Rico","center":[-66.32369085547407,18.368801347964368]},{"name":"Ireland","center":[-7.942516671198579,53.251683811818424]},{"name":"Iceland","center":[-17.59154176126586,64.91539832915792]},{"name":"Norway","center":[11.663094265385961,63.94339067100269]},{"name":"Finland","center":[27.05859951785041,64.35600257721175]},{"name":"Yemen","center":[48.39700270911738,16.18460778813121]},{"name":"Oman","center":[56.376496996055224,20.306937066819675]},{"name":"United Arab Emirates","center":[54.520444452639026,23.93575559823129]},{"name":"Qatar","center":[51.035417694456875,25.32102475803211]},{"name":"Kuwait","center":[47.654086015584106,29.27243750751324]},{"name":"Saudi Arabia","center":[45.298905370980464,23.3694207093665]},{"name":"Iraq","center":[43.29532181606175,32.62251897320872]},{"name":"Jordan","center":[36.40759246375308,31.429537018220138]},{"name":"Syria","center":[37.86085269187117,34.861004700182555]},{"name":"Iran","center":[53.585123998889536,32.13860085087114]},{"name":"Turkmenistan","center":[60.875379126249754,38.81364385808361]},{"name":"Uzbekistan","center":[64.97896705995197,41.73847647027865]},{"name":"Kazakhstan","center":[67.94921032728622,47.451967814425565]},{"name":"Nepal","center":[85.08368313423526,28.03219133510349]},{"name":"Bangladesh","center":[90.42403322340769,24.0046349344297]},{"name":"Myanmar","center":[96.81996924547377,21.600442946851537]},{"name":"Bhutan","center":[90.734164798968,27.361425856337554]},{"name":"Thailand","center":[101.47984154228733,15.59184180673759]},{"name":"Mali","center":[-2.936361220564549,18.269969650610015]},{"name":"Niger","center":[7.633779737932566,16.93550182762016]},{"name":"Nigeria","center":[8.295399167279985,9.706165619797176]},{"name":"Gabon","center":[11.943566045641122,-0.19906325558232982]},{"name":"Angola","center":[17.174233282246266,-12.220753784558916]},{"name":"Namibia","center":[17.566236953839905,-21.629956727617408]},{"name":"Botswana","center":[24.434423271052147,-20.936432420401232]},{"name":"South Africa","center":[24.505750723435185,-29.021392739175987]},{"name":"Zimbabwe","center":[29.06048534117227,-17.990873171571543]},{"name":"Zambia","center":[27.056446421889746,-12.666558809668222]},{"name":"Mozambique","center":[34.42381567510142,-17.34180193598211]},{"name":"Madagascar","center":[47.109493894202295,-19.336433319481554]},{"name":"Malawi","center":[34.077121896093615,-13.711834428725268]},{"name":"eSwatini","center":[31.445733277882773,-26.355923313027215]},{"name":"Somalia","center":[45.867681653056536,4.730707309230842]},{"name":"S. Sudan","center":[30.602126177237302,7.685223561595638]},{"name":"Kenya","center":[38.29344641890443,0.9562945402680327]},{"name":"Uganda","center":[32.579613312742225,0.976914637789278]},{"name":"Somaliland","center":[46.87193224342345,10.253067500749651]},{"name":"Eritrea","center":[39.05026766669216,15.15880869662164]},{"name":"Djibouti","center":[42.45666370852447,12.07734785126439]},{"name":"Sri Lanka","center":[80.76867750653872,7.657316551234141]},{"name":"Mongolia","center":[103.65079088139545,46.551742808213845]},{"name":"Kyrgyzstan","center":[74.54715917223167,41.82052344331744]},{"name":"North Korea","center":[126.59923947871123,40.125597598151664]},{"name":"Japan","center":[138.0984996344708,36.26012394116875]},{"name":"South Korea","center":[128.11681556554822,36.983174878029786]},{"name":"Cameroon","center":[13.049133286064388,6.077042173659704]},{"name":"Côte d'Ivoire","center":[-5.3418840462042905,7.915855356412705]},{"name":"Morocco","center":[-8.600884355587686,30.43127634470372]},{"name":"Congo","center":[15.881024278910907,-0.17275496738494733]},{"name":"Guinea","center":[-10.80963108692215,10.759652105572252]},{"name":"Senegal","center":[-15.119085423757038,14.964532389646132]},{"name":"Benin","center":[2.118732611049909,9.92331578404547]},{"name":"W. Sahara","center":[-12.851735600696953,23.89398215248221]},{"name":"Burkina Faso","center":[-1.365502945498443,12.345614700083484]},{"name":"Rwanda","center":[29.897827868681187,-1.8579375802237477]},{"name":"Eq. Guinea","center":[10.383849133796794,1.9456357620638938]},{"name":"Burundi","center":[29.742519129527206,-3.2111387501276836]},{"name":"Sierra Leone","center":[-11.692340480952042,8.872183338556377]},{"name":"Liberia","center":[-9.459625802745926,6.714190685022257]},{"name":"Togo","center":[1.2908059705044654,8.76502912754503]},{"name":"Guinea-Bissau","center":[-14.987880307293118,11.895392897934403]},{"name":"Gambia","center":[-15.227348240945409,13.633632952286082]},{"name":"Tunisia","center":[9.580686169777442,33.89714760041551]},{"name":"Italy","center":[13.417101007130448,42.37527211327682]},{"name":"Azerbaijan","center":[47.56306356733524,40.30919370511534]},{"name":"Georgia","center":[44.29869079477238,42.08537977418384]},{"name":"Romania","center":[25.30789673670783,46.175331400282964]},{"name":"Belarus","center":[28.158966284493083,53.96931324333122]},{"name":"Greenland","center":[-38.84275137110486,73.86056633988471]},{"name":"Germany","center":[10.604174095528181,50.63184117098415]},{"name":"Greece","center":[22.052772340842225,39.61677051866654]},{"name":"Armenia","center":[44.593636847884646,40.47571832660651]},{"name":"Tajikistan","center":[70.65550030535674,39.02078652855969]},{"name":"Latvia","center":[25.62692301245292,56.72758663045939]},{"name":"Estonia","center":[25.520822461088255,58.48469164782234]},{"name":"Lithuania","center":[23.83294308443147,55.786528568226565]}]
// window.newCenters = [{"name":"India","center":[78.94289439935574,22.110971402349254]},{"name":"Mauritania","center":[-10.602262031896345,20.31027288829407]},{"name":"Brazil","center":[-52.80745492015989,-10.793408304928976]},{"name":"Mexico","center":[-101.37378737750348,22.5629906608167]},{"name":"United States of America","center":[-98.18274402791938,39.409643648593054]},{"name":"Canada","center":[-101.88149109180665,55.587084195709046]},{"name":"Bolivia","center":[-64.57882841115892,-16.876942112896437]},{"name":"Peru","center":[74.15778834183989,11.865715877609865]},{"name":"Uruguay","center":[-55.54179658219716,-32.53067618036966]},{"name":"Argentina","center":[-64.20757971107471,-33.14808271609247]},{"name":"Chile","center":[-71.41577004326352,-34.05052409272624]},{"name":"Ecuador","center":[-78.43302681791924,-1.368934044078716]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[-65.02586991362207,7.0353092231092935]},{"name":"Suriname","center":[-55.6891348437334,4.251769249781486]},{"name":"Guyana","center":[-58.73785897567381,4.789034506270837]},{"name":"France","center":[3.5773532997832045,46.88015961760242]},{"name":"Cuba","center":[-78.38727812623897,21.656092969409315]},{"name":"Dominican Rep.","center":[-70.21797681559475,19.06985571661082]},{"name":"Jamaica","center":[-77.19520893684567,17.98245870937305]},{"name":"Nicaragua","center":[-85.1257179452903,12.744277786372585]},{"name":"Honduras","center":[-86.53019740252043,14.682953658918386]},{"name":"Guatemala","center":[-90.43395507403838,15.586814423916179]},{"name":"Belize","center":[-88.7315544512007,17.275530514889724]},{"name":"El Salvador","center":[-88.79158625313306,13.920210255763193]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[35.621100597900636,38.463381132556165]},{"name":"Ukraine","center":[32.34009001609571,49.118874622278305]},{"name":"United Kingdom","center":[-1.2218688069988106,52.68102485424598]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[18.99999020190816,51.605161377901695]},{"name":"Afghanistan","center":[66.0883641763327,33.56986382092676]},{"name":"Lesotho","center":[28.234469148225525,-29.67348229506997]},{"name":"China","center":[104.23593918556868,33.665925654955046]},{"name":"Russia","center":[91.02468750569128,61.923289845606966]},{"name":"Australia","center":[136.03084961305365,-24.591464532905427]},{"name":"Ethiopia","center":[40.16077940505842,7.974961147111342]},{"name":"Dem. Rep. Congo","center":[23.457638645111842,-2.1294144248509075]},{"name":"Sudan","center":[28.771196643354102,15.617410992180686]},{"name":"Chad","center":[19.178863740793382,14.60699323577048]},{"name":"Algeria","center":[2.727114856290708,28.00139945070287]},{"name":"Egypt","center":[30.40581016933791,26.192615975871906]},{"name":"Libya","center":[17.579860717434336,28.530833175941385]},{"name":"Ghana","center":[-0.7640447673029823,8.254963004036483]},{"name":"Pakistan","center":[68.38457715761115,28.711682377942562]},{"name":"Paraguay","center":[-58.31066977871734,-22.84115247136726]},{"name":"Panama","center":[-80.07599472789909,8.914542356669056]},{"name":"Costa Rica","center":[-84.027053907673,10.14879073139576]},{"name":"Puerto Rico","center":[-66.32369085547407,18.368801347964368]},{"name":"Ireland","center":[-7.942516671198579,53.251683811818424]},{"name":"Iceland","center":[-17.59154176126586,64.91539832915792]},{"name":"Norway","center":[11.663094265385961,63.94339067100269]},{"name":"Finland","center":[27.05859951785041,64.35600257721175]},{"name":"Yemen","center":[48.39700270911738,16.18460778813121]},{"name":"Oman","center":[56.376496996055224,20.306937066819675]},{"name":"United Arab Emirates","center":[54.520444452639026,23.93575559823129]},{"name":"Qatar","center":[51.035417694456875,25.32102475803211]},{"name":"Kuwait","center":[47.654086015584106,29.27243750751324]},{"name":"Saudi Arabia","center":[45.298905370980464,23.3694207093665]},{"name":"Iraq","center":[43.29532181606175,32.62251897320872]},{"name":"Jordan","center":[36.40759246375308,31.429537018220138]},{"name":"Syria","center":[37.86085269187117,34.861004700182555]},{"name":"Iran","center":[53.585123998889536,32.13860085087114]},{"name":"Turkmenistan","center":[60.875379126249754,38.81364385808361]},{"name":"Uzbekistan","center":[64.97896705995197,41.73847647027865]},{"name":"Kazakhstan","center":[67.94921032728622,47.451967814425565]},{"name":"Nepal","center":[85.08368313423526,28.03219133510349]},{"name":"Bangladesh","center":[90.42403322340769,24.0046349344297]},{"name":"Myanmar","center":[96.81996924547377,21.600442946851537]},{"name":"Bhutan","center":[90.734164798968,27.361425856337554]},{"name":"Thailand","center":[101.47984154228733,15.59184180673759]},{"name":"Mali","center":[-2.936361220564549,18.269969650610015]},{"name":"Niger","center":[7.633779737932566,16.93550182762016]},{"name":"Nigeria","center":[8.295399167279985,9.706165619797176]},{"name":"Gabon","center":[11.943566045641122,-0.19906325558232982]},{"name":"Angola","center":[17.174233282246266,-12.220753784558916]},{"name":"Namibia","center":[17.566236953839905,-21.629956727617408]},{"name":"Botswana","center":[24.434423271052147,-20.936432420401232]},{"name":"South Africa","center":[24.505750723435185,-29.021392739175987]},{"name":"Zimbabwe","center":[29.06048534117227,-17.990873171571543]},{"name":"Zambia","center":[27.056446421889746,-12.666558809668222]},{"name":"Mozambique","center":[34.42381567510142,-17.34180193598211]},{"name":"Madagascar","center":[47.109493894202295,-19.336433319481554]},{"name":"Malawi","center":[34.077121896093615,-13.711834428725268]},{"name":"eSwatini","center":[31.445733277882773,-26.355923313027215]},{"name":"Somalia","center":[45.867681653056536,4.730707309230842]},{"name":"S. Sudan","center":[30.602126177237302,7.685223561595638]},{"name":"Kenya","center":[38.29344641890443,0.9562945402680327]},{"name":"Uganda","center":[32.579613312742225,0.976914637789278]},{"name":"Somaliland","center":[46.87193224342345,10.253067500749651]},{"name":"Eritrea","center":[39.05026766669216,15.15880869662164]},{"name":"Djibouti","center":[42.45666370852447,12.07734785126439]},{"name":"Sri Lanka","center":[80.76867750653872,7.657316551234141]},{"name":"Mongolia","center":[103.65079088139545,46.551742808213845]},{"name":"Kyrgyzstan","center":[74.54715917223167,41.82052344331744]},{"name":"North Korea","center":[126.59923947871123,40.125597598151664]},{"name":"Japan","center":[138.0984996344708,36.26012394116875]},{"name":"South Korea","center":[128.11681556554822,36.983174878029786]},{"name":"Cameroon","center":[13.049133286064388,6.077042173659704]},{"name":"Côte d'Ivoire","center":[-5.3418840462042905,7.915855356412705]},{"name":"Morocco","center":[-8.600884355587686,30.43127634470372]},{"name":"Congo","center":[15.881024278910907,-0.17275496738494733]},{"name":"Guinea","center":[-10.80963108692215,10.759652105572252]},{"name":"Senegal","center":[-15.119085423757038,14.964532389646132]},{"name":"Benin","center":[2.118732611049909,9.92331578404547]},{"name":"W. Sahara","center":[-12.851735600696953,23.89398215248221]},{"name":"Burkina Faso","center":[-1.365502945498443,12.345614700083484]},{"name":"Rwanda","center":[29.897827868681187,-1.8579375802237477]},{"name":"Eq. Guinea","center":[10.383849133796794,1.9456357620638938]},{"name":"Burundi","center":[29.742519129527206,-3.2111387501276836]},{"name":"Sierra Leone","center":[-11.692340480952042,8.872183338556377]},{"name":"Liberia","center":[-9.459625802745926,6.714190685022257]},{"name":"Togo","center":[1.2908059705044654,8.76502912754503]},{"name":"Guinea-Bissau","center":[-14.987880307293118,11.895392897934403]},{"name":"Gambia","center":[-15.227348240945409,13.633632952286082]},{"name":"Tunisia","center":[9.580686169777442,33.89714760041551]},{"name":"Italy","center":[13.417101007130448,42.37527211327682]},{"name":"Azerbaijan","center":[47.56306356733524,40.30919370511534]},{"name":"Georgia","center":[44.29869079477238,42.08537977418384]},{"name":"Romania","center":[25.30789673670783,46.175331400282964]},{"name":"Belarus","center":[28.158966284493083,53.96931324333122]},{"name":"Greenland","center":[-38.84275137110486,73.86056633988471]},{"name":"Germany","center":[10.604174095528181,50.63184117098415]},{"name":"Greece","center":[22.052772340842225,39.61677051866654]},{"name":"Armenia","center":[44.593636847884646,40.47571832660651]},{"name":"Tajikistan","center":[70.65550030535674,39.02078652855969]},{"name":"Latvia","center":[25.62692301245292,56.72758663045939]},{"name":"Estonia","center":[25.520822461088255,58.48469164782234]},{"name":"Lithuania","center":[23.83294308443147,55.786528568226565]},{"name":"Haiti","center":[-72.30814235062157,19.242338291394233]},{"name":"Bahamas","center":[-77.95899104789085,24.830480044281376]},{"name":"Trinidad and Tobago","center":[-61.2643875973443,10.626827825874699]},{"name":"Bulgaria","center":[25.394317368849197,42.543247370856996]},{"name":"Denmark","center":[9.406794460839567,56.486515302726744]},{"name":"Serbia","center":[20.15660391289339,44.378809861782116]},{"name":"Hungary","center":[18.854434211886286,47.336587085545155]},{"name":"Czechia","center":[15.939716110677196,49.82031924587873]},{"name":"Macedonia","center":[21.713176900156647,41.74386242952517]},{"name":"Albania","center":[19.814930539683147,41.295067681002394]},{"name":"Austria","center":[14.171060088815821,47.474325302238924]},{"name":"Netherlands","center":[5.27924770328248,52.38789096277578]},{"name":"Switzerland","center":[8.01018917384573,46.95882856076562]},{"name":"Belgium","center":[4.695762532241822,50.79343158828387]},{"name":"Bosnia and Herz.","center":[17.382756614350708,44.43180091714874]},{"name":"Moldova","center":[28.906032916158694,47.225508296908814]},{"name":"Slovakia","center":[19.201908819153584,48.6037086393279]},{"name":"Croatia","center":[16.840986727667726,45.925107831169036]},{"name":"Slovenia","center":[14.955846788348286,46.163340424986544]},{"name":"Kosovo","center":[20.771354466495758,42.64000551553397]},{"name":"Montenegro","center":[19.178934121860774,43.05440634858748]},{"name":"Luxembourg","center":[5.645591990036005,49.91870050816771]},{"name":"Israel","center":[34.99655477098343,31.769772888609737]},{"name":"Cyprus","center":[33.08727204904391,34.857895952550365]},{"name":"Lebanon","center":[35.84296973209073,33.96903930105601]},{"name":"Palestine","center":[35.32808317293147,32.06765532729324]},{"name":"Cambodia","center":[104.49985577695853,12.964841583886525]},{"name":"N. Cyprus","center":[33.81382014238606,35.479653001488394]},{"name":"Malaysia","center":[102.32785473980451,4.5091883469652085]},{"name":"Indonesia","center":[101.8004618362005,-0.411853434578213]},{"name":"Laos","center":[102.83661579588336,19.444316034353758]},{"name":"Vietnam","center":[105.62952822648408,20.721608943441918]},{"name":"Papua New Guinea","center":[143.58671107696375,-5.458817292187553]},{"name":"New Zealand","center":[172.96632744193658,-41.91015972547873]},{"name":"Antarctica","center":[64.973932224384,-86.0187484343511]},{"name":"Philippines","center":[120.67235865905069,15.702428278745298]},{"name":"Taiwan","center":[120.84736747019046,23.828115618058124]},{"name":"Brunei","center":[115.12828945164591,4.831842973496584]},{"name":"Timor-Leste","center":[126.14049596975887,-8.951684175690332]},{"name":"New Caledonia","center":[165.20364364650874,-21.10954826196775]},{"name":"Fiji","center":[177.8589522576259,-17.765960439606204]},{"name":"Vanuatu","center":[167.0180348680037,-15.379112872080281]},{"name":"Solomon Is.","center":[160.20986954975112,-9.608674024297745]},{"name":"Falkland Is.","center":[-59.56924416736293,-51.6444860010277]}]
window.newCenters = [{"name":"India","center":[78.94289439935574,22.110971402349254]},{"name":"Mauritania","center":[-10.602262031896345,20.31027288829407]},{"name":"Brazil","center":[-52.80745492015989,-10.793408304928976]},{"name":"Mexico","center":[-101.37378737750348,22.5629906608167]},{"name":"United States of America","center":[-98.18274402791938,39.409643648593054]},{"name":"Canada","center":[-101.88149109180665,55.587084195709046]},{"name":"Bolivia","center":[-64.92395191267069,-16.529511802258643]},{"name":"Peru","center":[-75.29673819202081,-9.136978292196059]},{"name":"Uruguay","center":[-55.54179658219716,-32.53067618036966]},{"name":"Argentina","center":[-64.20757971107471,-33.14808271609247]},{"name":"Chile","center":[-71.41577004326352,-34.05052409272624]},{"name":"Ecuador","center":[-78.43302681791924,-1.368934044078716]},{"name":"Colombia","center":[-72.19513436355604,3.6749686647050344]},{"name":"Venezuela","center":[-65.02586991362207,7.0353092231092935]},{"name":"Suriname","center":[-55.6891348437334,4.251769249781486]},{"name":"Guyana","center":[-58.73785897567381,4.789034506270837]},{"name":"France","center":[3.5773532997832045,46.88015961760242]},{"name":"Cuba","center":[-78.38727812623897,21.656092969409315]},{"name":"Dominican Rep.","center":[-70.21797681559475,19.06985571661082]},{"name":"Jamaica","center":[-77.19520893684567,17.98245870937305]},{"name":"Nicaragua","center":[-85.1257179452903,12.744277786372585]},{"name":"Honduras","center":[-86.53019740252043,14.682953658918386]},{"name":"Guatemala","center":[-90.43395507403838,15.586814423916179]},{"name":"Belize","center":[-88.7315544512007,17.275530514889724]},{"name":"El Salvador","center":[-88.79158625313306,13.920210255763193]},{"name":"Central African Rep.","center":[20.758563660106088,7.241366228351479]},{"name":"Tanzania","center":[35.62088683821782,-7.4569545973753515]},{"name":"Turkey","center":[35.621100597900636,38.463381132556165]},{"name":"Ukraine","center":[32.34009001609571,49.118874622278305]},{"name":"United Kingdom","center":[-1.2218688069988106,52.68102485424598]},{"name":"Portugal","center":[-8.1184749189246,39.771753501850164]},{"name":"Spain","center":[-2.9392256799076413,40.35798687787688]},{"name":"Sweden","center":[15.5984951001163,60.745241442336415]},{"name":"Poland","center":[18.99999020190816,51.605161377901695]},{"name":"Afghanistan","center":[66.0883641763327,33.56986382092676]},{"name":"Lesotho","center":[28.234469148225525,-29.67348229506997]},{"name":"China","center":[104.23593918556868,33.665925654955046]},{"name":"Russia","center":[91.02468750569128,61.923289845606966]},{"name":"Australia","center":[136.03084961305365,-24.591464532905427]},{"name":"Ethiopia","center":[40.16077940505842,7.974961147111342]},{"name":"Dem. Rep. Congo","center":[23.457638645111842,-2.1294144248509075]},{"name":"Sudan","center":[28.771196643354102,15.617410992180686]},{"name":"Chad","center":[19.178863740793382,14.60699323577048]},{"name":"Algeria","center":[2.727114856290708,28.00139945070287]},{"name":"Egypt","center":[30.40581016933791,26.192615975871906]},{"name":"Libya","center":[17.579860717434336,28.530833175941385]},{"name":"Ghana","center":[-0.7640447673029823,8.254963004036483]},{"name":"Pakistan","center":[68.38457715761115,28.711682377942562]},{"name":"Paraguay","center":[-58.31066977871734,-22.84115247136726]},{"name":"Panama","center":[-80.07599472789909,8.914542356669056]},{"name":"Costa Rica","center":[-84.027053907673,10.14879073139576]},{"name":"Puerto Rico","center":[-66.32369085547407,18.368801347964368]},{"name":"Ireland","center":[-7.942516671198579,53.251683811818424]},{"name":"Iceland","center":[-17.59154176126586,64.91539832915792]},{"name":"Norway","center":[11.663094265385961,63.94339067100269]},{"name":"Finland","center":[27.05859951785041,64.35600257721175]},{"name":"Yemen","center":[48.39700270911738,16.18460778813121]},{"name":"Oman","center":[56.376496996055224,20.306937066819675]},{"name":"United Arab Emirates","center":[54.520444452639026,23.93575559823129]},{"name":"Qatar","center":[51.035417694456875,25.32102475803211]},{"name":"Kuwait","center":[47.654086015584106,29.27243750751324]},{"name":"Saudi Arabia","center":[45.298905370980464,23.3694207093665]},{"name":"Iraq","center":[43.29532181606175,32.62251897320872]},{"name":"Jordan","center":[36.40759246375308,31.429537018220138]},{"name":"Syria","center":[37.86085269187117,34.861004700182555]},{"name":"Iran","center":[53.585123998889536,32.13860085087114]},{"name":"Turkmenistan","center":[60.875379126249754,38.81364385808361]},{"name":"Uzbekistan","center":[64.97896705995197,41.73847647027865]},{"name":"Kazakhstan","center":[67.94921032728622,47.451967814425565]},{"name":"Nepal","center":[85.08368313423526,28.03219133510349]},{"name":"Bangladesh","center":[90.42403322340769,24.0046349344297]},{"name":"Myanmar","center":[96.81996924547377,21.600442946851537]},{"name":"Bhutan","center":[90.734164798968,27.361425856337554]},{"name":"Thailand","center":[101.47984154228733,15.59184180673759]},{"name":"Mali","center":[-2.936361220564549,18.269969650610015]},{"name":"Niger","center":[7.633779737932566,16.93550182762016]},{"name":"Nigeria","center":[8.295399167279985,9.706165619797176]},{"name":"Gabon","center":[11.943566045641122,-0.19906325558232982]},{"name":"Angola","center":[17.174233282246266,-12.220753784558916]},{"name":"Namibia","center":[17.566236953839905,-21.629956727617408]},{"name":"Botswana","center":[24.434423271052147,-20.936432420401232]},{"name":"South Africa","center":[24.505750723435185,-29.021392739175987]},{"name":"Zimbabwe","center":[29.06048534117227,-17.990873171571543]},{"name":"Zambia","center":[27.056446421889746,-12.666558809668222]},{"name":"Mozambique","center":[34.42381567510142,-17.34180193598211]},{"name":"Madagascar","center":[47.109493894202295,-19.336433319481554]},{"name":"Malawi","center":[34.077121896093615,-13.711834428725268]},{"name":"eSwatini","center":[31.445733277882773,-26.355923313027215]},{"name":"Somalia","center":[45.867681653056536,4.730707309230842]},{"name":"S. Sudan","center":[30.602126177237302,7.685223561595638]},{"name":"Kenya","center":[38.29344641890443,0.9562945402680327]},{"name":"Uganda","center":[32.579613312742225,0.976914637789278]},{"name":"Somaliland","center":[46.87193224342345,10.253067500749651]},{"name":"Eritrea","center":[39.05026766669216,15.15880869662164]},{"name":"Djibouti","center":[42.45666370852447,12.07734785126439]},{"name":"Sri Lanka","center":[80.76867750653872,7.657316551234141]},{"name":"Mongolia","center":[103.65079088139545,46.551742808213845]},{"name":"Kyrgyzstan","center":[74.54715917223167,41.82052344331744]},{"name":"North Korea","center":[126.59923947871123,40.125597598151664]},{"name":"Japan","center":[138.0984996344708,36.26012394116875]},{"name":"South Korea","center":[128.11681556554822,36.983174878029786]},{"name":"Cameroon","center":[13.049133286064388,6.077042173659704]},{"name":"Côte d'Ivoire","center":[-5.3418840462042905,7.915855356412705]},{"name":"Morocco","center":[-8.600884355587686,30.43127634470372]},{"name":"Congo","center":[15.881024278910907,-0.17275496738494733]},{"name":"Guinea","center":[-10.80963108692215,10.759652105572252]},{"name":"Senegal","center":[-15.119085423757038,14.964532389646132]},{"name":"Benin","center":[2.118732611049909,9.92331578404547]},{"name":"W. Sahara","center":[-12.851735600696953,23.89398215248221]},{"name":"Burkina Faso","center":[-1.365502945498443,12.345614700083484]},{"name":"Rwanda","center":[29.897827868681187,-1.8579375802237477]},{"name":"Eq. Guinea","center":[10.383849133796794,1.9456357620638938]},{"name":"Burundi","center":[29.742519129527206,-3.2111387501276836]},{"name":"Sierra Leone","center":[-11.692340480952042,8.872183338556377]},{"name":"Liberia","center":[-9.459625802745926,6.714190685022257]},{"name":"Togo","center":[1.2908059705044654,8.76502912754503]},{"name":"Guinea-Bissau","center":[-14.987880307293118,11.895392897934403]},{"name":"Gambia","center":[-15.227348240945409,13.633632952286082]},{"name":"Tunisia","center":[9.580686169777442,33.89714760041551]},{"name":"Italy","center":[13.417101007130448,42.37527211327682]},{"name":"Azerbaijan","center":[47.56306356733524,40.30919370511534]},{"name":"Georgia","center":[44.29869079477238,42.08537977418384]},{"name":"Romania","center":[25.30789673670783,46.175331400282964]},{"name":"Belarus","center":[28.158966284493083,53.96931324333122]},{"name":"Greenland","center":[-38.84275137110486,73.86056633988471]},{"name":"Germany","center":[10.604174095528181,50.63184117098415]},{"name":"Greece","center":[22.052772340842225,39.61677051866654]},{"name":"Armenia","center":[44.593636847884646,40.47571832660651]},{"name":"Tajikistan","center":[70.65550030535674,39.02078652855969]},{"name":"Latvia","center":[25.62692301245292,56.72758663045939]},{"name":"Estonia","center":[25.520822461088255,58.48469164782234]},{"name":"Lithuania","center":[23.83294308443147,55.786528568226565]},{"name":"Haiti","center":[-72.30814235062157,19.242338291394233]},{"name":"Bahamas","center":[-77.95899104789085,24.830480044281376]},{"name":"Trinidad and Tobago","center":[-61.2643875973443,10.626827825874699]},{"name":"Bulgaria","center":[25.394317368849197,42.543247370856996]},{"name":"Denmark","center":[9.406794460839567,56.486515302726744]},{"name":"Serbia","center":[20.15660391289339,44.378809861782116]},{"name":"Hungary","center":[18.854434211886286,47.336587085545155]},{"name":"Czechia","center":[15.939716110677196,49.82031924587873]},{"name":"Macedonia","center":[21.713176900156647,41.74386242952517]},{"name":"Albania","center":[19.814930539683147,41.295067681002394]},{"name":"Austria","center":[14.171060088815821,47.474325302238924]},{"name":"Netherlands","center":[5.27924770328248,52.38789096277578]},{"name":"Switzerland","center":[8.01018917384573,46.95882856076562]},{"name":"Belgium","center":[4.695762532241822,50.79343158828387]},{"name":"Bosnia and Herz.","center":[17.382756614350708,44.43180091714874]},{"name":"Moldova","center":[28.906032916158694,47.225508296908814]},{"name":"Slovakia","center":[19.201908819153584,48.6037086393279]},{"name":"Croatia","center":[16.840986727667726,45.925107831169036]},{"name":"Slovenia","center":[14.955846788348286,46.163340424986544]},{"name":"Kosovo","center":[20.771354466495758,42.64000551553397]},{"name":"Montenegro","center":[19.178934121860774,43.05440634858748]},{"name":"Luxembourg","center":[5.645591990036005,49.91870050816771]},{"name":"Israel","center":[34.99655477098343,31.769772888609737]},{"name":"Cyprus","center":[33.08727204904391,34.857895952550365]},{"name":"Lebanon","center":[35.84296973209073,33.96903930105601]},{"name":"Palestine","center":[35.32808317293147,32.06765532729324]},{"name":"Cambodia","center":[104.49985577695853,12.964841583886525]},{"name":"N. Cyprus","center":[33.81382014238606,35.479653001488394]},{"name":"Malaysia","center":[102.32785473980451,4.5091883469652085]},{"name":"Indonesia","center":[101.8004618362005,-0.411853434578213]},{"name":"Laos","center":[102.83661579588336,19.444316034353758]},{"name":"Vietnam","center":[105.62952822648408,20.721608943441918]},{"name":"Papua New Guinea","center":[143.58671107696375,-5.458817292187553]},{"name":"New Zealand","center":[172.96632744193658,-41.91015972547873]},{"name":"Antarctica","center":[64.973932224384,-86.0187484343511]},{"name":"Philippines","center":[120.67235865905069,15.702428278745298]},{"name":"Taiwan","center":[120.84736747019046,23.828115618058124]},{"name":"Brunei","center":[115.12828945164591,4.831842973496584]},{"name":"Timor-Leste","center":[126.14049596975887,-8.951684175690332]},{"name":"New Caledonia","center":[165.20364364650874,-21.10954826196775]},{"name":"Fiji","center":[177.8589522576259,-17.765960439606204]},{"name":"Vanuatu","center":[167.0180348680037,-15.379112872080281]},{"name":"Solomon Is.","center":[160.20986954975112,-9.608674024297745]},{"name":"Falkland Is.","center":[-59.56924416736293,-51.6444860010277]}]


export default {
  props: {},
  data: () => ({
    // travelMode: 'to', // from, to, both
    latestDate: 'Feb 1, 2021',
    zoom: 1,
    travelRestrictions: [],
    travelTableHeaders: [
    ],
    countryCharacteristicFilters: [
      { display: 'Beaches / Relaxation', name: 'Beaches / Relaxation', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Nature / Hiking / Lakes', name: 'Nature / Hiking / Lakes', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Adventure', name: 'Adventure', value: 'unknown', yesColor: 'green', noColor: 'red' },
      // { display: 'Culture', name: 'Culture', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Remote Work / Wi-Fi Access', name: 'Connectivity Ability', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Foodie Destination', name: 'Foodie Destination', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Warm in Dec - March', name: 'Warm in Dec - March', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Warm in June - Sep', name: 'Warm in June - Sep', value: 'unknown', yesColor: 'green', noColor: 'red' },
    ],
    travelTableHeadersAll: [
      // { text: '', value: 'regionStatusSortIx', class: "pa-0" },
      { text: 'Country', value: 'state' },
      { text: 'Region', value: 'region' },
      // { text: 'Status', value: 'status' },
      { text: 'PCR Test', value: 'details.pcrTest' },
      { text: 'PCR Test Hours', value: 'details.pcrTestHours' },
      { text: 'Quarantine', value: 'details.quarantine' },
      { text: 'Quarantine Days', value: 'details.quarantineDays' },
      // ,pcrTest,pcrTestHours,quarantine,quarantineDays
      { text: 'Self Isolation Required', value: 'details.selfIsolationRequired' },
      // { text: 'Description', value: 'details.description', cellClass: 'description' },
      { text: '', value: 'data-table-expand' },
    ],
    travelTableHeadersUS: [
      { text: '', value: 'status' },
      { text: 'Country', value: 'state' },
      { text: 'Region', value: 'region' },
      // { text: 'Can US Travel?', value: 'details.canUSTravel', align: 'center' },
      { text: 'Tourism', value: 'details.tourism', align: 'center' },
      { text: 'Business Travel', value: 'details.businessTravel', align: 'center' },
      { text: 'Negative Covid Test required', value: 'details.negativePcrRequired', align: 'center' },
      { text: 'Quarantine required', value: 'details.quarantineRequired', align: 'center' },
      // { text: 'COVID Test required', value: 'details.covidTestRequired', align: 'center' },
      { text: 'Description', value: 'data-table-expand' },
    ],
    travelRestrictionFilters: [
    ],
    travelRestrictionFiltersAll: [
      { display: 'Self Isolation NOT Required', name: 'selfIsolationRequired', value: 'unknown', yesColor: 'red', noColor: 'green', filter: (item, filterValue) => item.details && item.details.selfIsolationRequired != filterValue },
      { display: 'PCR Test Required', name: 'pcrTest', value: 'unknown', yesColor: 'red', noColor: 'green', filter: (item, filterValue) => item.details && item.details.pcrTest != filterValue  },
    ],
    travelRestrictionFiltersUS: [
      // { display: 'Can US Travel?', name: 'canUSTravel', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Quarantine required', name: 'quarantineRequired', value: 'unknown', yesColor: 'red', noColor: 'green' },
      { display: 'Tourism', name: 'tourism', value: 'unknown', yesColor: 'green', noColor: 'red' },
      { display: 'Negative Covid Test required', name: 'negativePcrRequired', value: 'unknown', yesColor: 'red', noColor: 'green' },
      { display: 'Business Travel', name: 'businessTravel', value: 'unknown', yesColor: 'green', noColor: 'red' },
      // { display: 'Negative PCR required', name: 'negativePcrRequired', value: 'unknown', yesColor: 'red', noColor: 'green' },
    ],
    travelSearch: '',
    loading: true,
    notScrolled: true,
    showHint: true,
    searchFrom: null,
    searchTo: null,
    allLocations: [],
    level: "state", // 'state' or 'county'
    mode: "travel",
    relativeToState: true,
    fromCountry: getCookie("travel.currentCountry") || "United States of America",
    toCountry: null,
    currentLocation: getCookie("travel.currentLocation") || null,
    // currentCountyId: null,
    // modes: [
    //   "casesState",
    //   "deathsState",
    //   "activeState",
    //   "cases",
    //   "deaths",
    //   "active",
    //   "casesChange"
    // ],
    ip: null,
    profilePanel: null,
    profile: {
      showState: false,
      showCounty: false,
      showTestSites: false,
      showClinicalTrials: false,
    }
  }),
  computed: {
    travelMode() {
      if (this.searchTo && this.searchFrom) {
        return 'both'
      } else if (!this.searchTo && this.searchFrom) {
        return 'from'
      }  else if (this.searchTo && !this.searchFrom) {
        return 'to'
      }  else if (!this.searchTo && !this.searchFrom) {
        return ''
      } 
    },
    filteredTravelRestrictions() {
      let filtered = this.travelRestrictions.filter(r => r.level != 'origin')
      if (this.travelSearch) {
        filtered = filtered.filter(d => d.state.toLowerCase().includes(this.travelSearch.toLowerCase()))
      }
      this.travelRestrictionFilters.forEach(f => {
        if (f.value != 'unknown') {
          if (f.filter) {
            filtered = filtered.filter(r => f.filter(r, f.value))
          } else {
            filtered = filtered.filter(r => r.details && r.details[f.name] == f.value)
          }
        }
      })

      this.countryCharacteristicFilters.forEach(f => {
        if (f.value != 'unknown') {
          // let tourismData = mainData.touristDestinations.find(td => this.getCountryName(td.Country, 'code') == this.getCountryName(stateName, 'code'))

          filtered = filtered.filter(r => r.details && r.details[f.name] == f.value)
        }
      })
      return filtered
    },
    filteredTravelRestrictionsByRegion() {
      let regionOrders = [
        'North America',
        'Europe',
        'Asia',
        'Oceania',
        'South America',
        'Africa',
      ]

      let grouped = _.groupBy(this.filteredTravelRestrictions, 'region')
      grouped = _.map(grouped, (arr, ix) => ({
        region: ix == 'undefined' ? 'Other': ix,
        countries: _.sortBy(arr, d => d.state.toLowerCase()),
      }))
      // Sort by region
      grouped = _.sortBy(grouped, g => {
        let sortIndex = regionOrders.indexOf(g.region)
        if (sortIndex == -1) {
          return Number.POSITIVE_INFINITY
        }
        return sortIndex
      })

      return grouped
    },
  },
  watch: {
    mode() {
      return this.modeChanged()
    },
    level() {
      return this.modeChanged()
    },
    relativeToState() {
      return this.modeChanged()
    },
    searchFrom() {
      this.fromCountry = ""
      if (!this.searchFrom) {
        return
      } else if (this.searchFrom.level == 0) { // world
        this.reset()
      } else if (this.searchFrom.level == 1) { // country
        this.fromCountry = this.searchFrom.value
        this.zoomToState(this.searchFrom.value)
      }
    },
    searchTo() {
      this.toCountry = ""
      if (!this.searchTo) {
        return
      } else if (this.searchTo.level == 0) { // world
        this.reset()
      } else if (this.searchTo.level == 1) { // country
        this.toCountry = this.searchTo.value
        this.zoomToState(this.searchTo.value)
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {

    window.renderMap = this.renderMap
    window._d3 = d3
    console.log("created")

    window.instance = this
    
    this.setPath(0.9, 0.6, 1, -75, -40)

    this.init().then(() => {
      setTimeout(() => {
        console.log("loaded")
        let dateTime = Date.now()
        let days = moment().diff('2019-12-31', 'days')
        document.querySelector("#myRange").max = days
        document.querySelector("#myRange").value = days
        document.querySelector("#myRange-top").max = days
        document.querySelector("#myRange-top").value = days
        let proj = d3.geoOrthographic()
            .translate([465, 270])
            // .rotate([100, 40])
            .rotate([90, -23.5])
            .scale(390, 390)
        let path = d3.geoPath()
          .projection(proj)
        window.proj = proj
        window.path = path
        this.renderMap(path)
      setTimeout(() => {
        console.log((Date.now() - dateTime)/1)
        dateTime = Date.now()
        this.setDayData(days)
        if (this.mode == "travel") {
          this.colorTravelMap()
        }
        console.log((Date.now() - dateTime)/1)
      setTimeout(() => {
        dateTime = Date.now()
        this.initCombosAndActions()
        console.log((Date.now() - dateTime)/1)
        dateTime = Date.now()
        console.log("done")
        this.loading = false
        
        d3.select(".map-frame svg")
          .transition()
          .duration(1000)
          .style("opacity", 1)
        d3.select(".map-frame .hint")
          .transition()
          .duration(1000)
          .style("opacity", 1)
        d3.select(".map-frame-wrapper .loading-map")
          .style("display", "none")
      },1)
      },1)
      },1)
    })
  },
  methods: {
    setPath(scaleX, translateScaleX, translateScaleY, rotateX, rotateY) {
      scaleX = scaleX || 1
      // scaleY = scaleY || 1
      translateScaleX = translateScaleX || 1
      translateScaleY = translateScaleY || 1.4
      rotateX = rotateX || -100
      rotateY = rotateY || -20
      path = d3.geoPath().projection(d3.geoOrthographic()
        .scale(width * scaleX)
        .translate([width * translateScaleX, height * translateScaleY])
        .rotate([rotateX, rotateY])
        // .clipAngle(180 - 1e-4)
        // .clipExtent([[0, 0], [width, height]])
        .precision(0.2))
    },
    handleScroll (event) {
      let target = document.getElementById("reopeningStatusChart")
      if (!target || !target.offsetTop) return
      
      if (this.notScrolled && window.pageYOffset > target.offsetTop + 20) {
        this.notScrolled = false
        console.log("passed!")
      }

      console.log(event)

    },
    modeChanged() {
      let legendText = ""
      
      if (this.relativeToState && this.level == 'county') {
        if (this.mode == "total") {
          legendText = "Relative no. of county cases across state"
        } else if (this.mode == "active") {
          legendText = "Relative no. of active county cases across state"
        } else if (this.mode == "deaths") {
          legendText = "Relative no. of county deaths across state"
        } else if (this.mode == "trend") {
          legendText = "Active cases trend"
        }
      } else {
        if (this.mode == "total") {
          legendText = "Total cases"
        } else if (this.mode == "active") {
          legendText = "Active cases"
        } else if (this.mode == "deaths") {
          legendText = "Total deaths"
        } else if (this.mode == "trend") {
          legendText = "Active cases trend"
        }
      }

      d3.select("#legend #header")
        .text(legendText)
        .call(this.wrap, 180)

      if (this.mode == "travel") {
        this.colorTravelMap()
      } else {
        this.resetColorTravelMap()
        let current = document.querySelector("#myRange").value
        this.setDayData(current)
      }
    },
    // TODO: (REFACTOR) make mapping from source
    getCountryName(country, sourceName) {

      if (sourceName != 'code'
        && sourceName != 'ss'
        && sourceName != 'usTravel'
        && sourceName != 'atlas') {
        return country
      }
      let newName = countryMappings
        .filter(d => 
          d.code == country
          || d.who == country
          || d.usTravel == country
          || d.ss == country
          || d.atlas == country
        )
        .map(d => d[sourceName])[0]

      return newName || country
    },
    colorTravelMap() {
      
      d3.select("g#travelLegend").style("display", "block")
      d3.select("g#casesLegend").style("display", "none")
   
      if (this.fromCountry == "United States of America") {
        this.travelTableHeaders = this.travelTableHeadersUS
        this.travelRestrictionFilters = this.travelRestrictionFiltersUS
      } else {
        this.travelTableHeaders = this.travelTableHeadersAll
        this.travelRestrictionFilters = this.travelRestrictionFiltersAll
      }

      let travelRestrictions = mainData.states.map(d => {
        let level = 'unknown';
        let levelDisplay;
        let details;
        let region;
        let country = d.properties.name
        let restriction;
        if (country == this.fromCountry || country == this.toCountry) {
          level = 'origin'
          levelDisplay = 'Origin'
          
        } else if (this.fromCountry == "United States of America") {
          // Display US restrictions

          let usTravelCountry = this.getCountryName(country, 'usTravel')
          let countryCode = this.getCountryName(country, 'code')

          restriction = mainData.usTravelRestrictions.find(r => r.Country == usTravelCountry)
          region = countryRegions
            .filter(d => d.countryCode == countryCode)
            .map(d => d.region)[0]
    

          if (restriction) {
            details = {
              canUSTravel: restriction["Can US Travel?"],
              tourism: restriction["Tourism"],
              businessTravel: restriction["Business Travel"],
              negativePcrRequired: restriction["Negative PCR required"],
              quarantineRequired: restriction["Quarantine Requirement"],
              covidTestRequired: restriction["COVID Test Requirement"],
            }
          }

          if (restriction && restriction["Can US Travel?"] == "No") {
            level = 'closed'
          } else if (restriction 
            && restriction["Can US Travel?"] == "Yes"
            && restriction["Tourism"] == "Yes"
            && restriction["Business Travel"] == "Yes"
            && restriction["Negative PCR required"] == "No"
            && restriction["Quarantine Requirement"] == "No"
            && restriction["COVID Test Requirement"] == "No"
            ) {
            level = 'open'
          } else if (restriction) {
            level = 'restricted'
          }
          
        } else {
          // Display country (other than US) restrictions

          let fromCode = this.getCountryName(this.fromCountry, 'code')
          let toCode = this.getCountryName(this.toCountry, 'code')
          let countryCode = this.getCountryName(country, 'code')

          if (this.fromCountry && !this.toCountry) {
            restriction = mainData.allTravelRestrictions.find(r => r.originCode == fromCode 
              && r.code == countryCode)
          } else if (!this.fromCountry && this.toCountry) {
            restriction = mainData.allTravelRestrictions.find(r => r.originCode == countryCode 
              && r.code == toCode)
            console.log({countryCode, toCode, restriction})
          } else if (this.fromCountry && this.toCountry) {
            restriction = mainData.allTravelRestrictions.find(r => r.originCode == fromCode 
              && r.code == toCode && r.code == countryCode)
          }

          region = countryRegions
            .filter(d => d.countryCode == countryCode)
            .map(d => d.region)[0]
        

          if (restriction) {
            details = {
              status: restriction.restrictionStatus,
              pcrTest: restriction.pcrTest,
              pcrTestHours: restriction.pcrTestHours,
              quarantine: restriction.quarantine,
              quarantineDays: restriction.quarantineDays,
              selfIsolationRequired: restriction.restrictionSelfIsolation,
              description: restriction.restrictionDescription.replace(/\\n/g, '<br>'),
            }
            if (details.selfIsolationRequired == "NO") {
              details.selfIsolationRequired = "No"
            } else if (details.selfIsolationRequired == "YES") {
              details.selfIsolationRequired = "Yes"
            } else if (details.selfIsolationRequired == "UNKNOWN_STATUS") {
              details.selfIsolationRequired = "Unknown"
            } else if (details.selfIsolationRequired == "PARTIAL") {
              details.selfIsolationRequired = "Partial"
            } else if (details.selfIsolationRequired == "null") {
              details.selfIsolationRequired = ""
            }
            
            if (details.status == "OPEN") {
              level = 'open'
            } else if (details.status == "CLOSED") {
              level = 'closed'
            } else if (details.status == "PARTIALLY_OPEN") {
              level = 'restricted'
            } else if (details.status == "UNKNOWN"
              || details.status == "null") {
              level = 'unknown'
            }

            if (details.description == "null") {
              details.description = ""
            }
          }

        }

        let tourismData = mainData.touristDestinations.find(td => this.getCountryName(td.Country, 'code') == this.getCountryName(country, 'code'))
        if (tourismData) {
          details = details || {}
          let fields = this.countryCharacteristicFilters.map(d => d.name)

          fields.forEach(field => {
            // let statusColor = tourismData[field] == "X" ? 'Yes' : 'No'
            details[field] = tourismData[field] == "X" ? 'Yes' : 'No'
          })
        }

        levelDisplay = { 'open': 'Open', 'restricted': 'Restricted', 'closed': 'Closed', 'unknown': 'Unknown' }[level]
        return { 
          state: d.properties.name,
          level,
          levelDisplay,
          details,
          region
        }
      })
      // Add sort index to support custom region + status ordering
      let regionOrders = [
        'North America',
        'Europe',
        'Asia',
        'Oceania',
        'South America',
        'Africa',
      ]
      let levelOrder = [
        'open',
        'restricted',
        'closed',
        'unknown',
      ]
      travelRestrictions.forEach(r => {
        r.showDescription = false

        let regionIx = regionOrders.indexOf(r.region)
        if (regionIx == -1) regionIx = regionOrders.length
        
        let levelIx = levelOrder.indexOf(r.level)
        if (levelIx == -1) levelIx = levelOrder.length

        r.regionStatusSortIx = `${levelIx}-${regionIx}-${r.state}`
      })
      this.travelRestrictions = _.sortBy(travelRestrictions, ['regionStatusSortIx']),

      console.log(this.travelRestrictions)

      mapStates
        .transition()
        .duration(100)
        .attr("class", d => {
          // console.log(d)
          // // return window.newCenters.find(nc => nc.name == d.properties.name) ? 'open' : 'closed'
          let restriction = this.travelRestrictions.find(x => x.state == d.properties.name)
          if (!restriction) return "unknown"

          return restriction.level
        })
      
      let statesWithPlanes = mainData.states.filter(d => {
        let restriction = this.travelRestrictions.find(x => x.state == d.properties.name)
        return restriction && restriction.level == 'open'
      })
      d3.select(".map-frame g#planes").remove()
      const svg = d3.select(".map-frame g#country")
        .append("g")
        .attr("id", "planes")
      let paths = svg
        .selectAll("path")
        .data(statesWithPlanes)
        .enter()
        .append("path")
        .attr("fill", "none") 
        .attr("stroke", '#2200ff77')
        .attr("stroke-width", 2)
        .attr("stroke-linecap", "round")
        .attr("stroke-dasharray", "4 7")

      this.drawPlanePath()
      this.animatePlanes()
      
        // .attr("d", this.drawPlanePath)
        // .attr("d", function (d) {
        //   // return d;
        //   let points = planePath(point(stateData), point(d))
        //   let c = points;
        //   c = c.map(d => window.proj(d))
        //   c = curve(c)
        //   return c
        // })
         
      
    },
    resetColorTravelMap() {

      mapStates
        .transition()
        .duration(100)
        .attr("class", "")
      d3.select("g#travelLegend").style("display", "none")
      d3.select("g#casesLegend").style("display", "block")
    },
    createShowToolTip: function(tooltip, baseElement) {
      return function(html) {
        let chartRect = d3
          .select(baseElement)
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }
    },

    createHideTooltip: function(tooltip) {
      return function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }
    },

    renderMap(path) {
      console.log("drawing map")
      let that = this

      // Remove prevouis map if any
      d3.selectAll(".map-frame svg").remove()
      d3.selectAll(".tooltip").remove()

      // Create svg
      let viewBoxStr = `${viewBox.minX} ${viewBox.minY} ${viewBox.width} ${viewBox.height}`
      const mainSvg = d3
        .select(".map-frame")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", viewBoxStr)
        .style("opacity", 0)
        .style("width", "100%")
        .style("transform", "translate3d(0, 0, 0)")

      const svg = mainSvg.append("g").attr("id", "country")

      svg
        .append("circle")
        .attr("class", "globe")
        .attr("cx", 465)
        .attr("cy", 270)
        .attr("r", 390)
        .style("fill", "#003da091")

      svg
        .attr("transform", "translate(0,0)")
        .style("overflow", "visible")
        .style("width", "100%")
        .style("height", "auto")

      var gpos0, o0, draggingix; 
      function dragstarted(){

        let globe = d3.select(".map-frame svg g#country").node()
        console.log(this)
        gpos0 = window.proj.invert(d3.mouse(globe));
        o0 = window.proj.rotate();
        draggingix = 0

      }

      function dragged(){
        draggingix++
        if (draggingix % 4 == 0) {
          console.log("dragged")
        } else {
          // console.log("dragged skipped")
          return
        }

        let globe = d3.select(".map-frame svg g#country").node()
        console.log(this)
        var gpos1 = window.proj.invert(d3.mouse(globe));

        o0 = window.proj.rotate();

        var o1 = eulerAngles(gpos0, gpos1, o0);
        console.log({ o1, gpos0, gpos1, o0 })

        // Avoid gamma or roll rotation
        o1[2] = 0

        // Scale rotation to zoom factor
        o1[0] = o0[0] + (o1[0] - o0[0])/that.zoom
        o1[1] = o0[1] + (o1[1] - o0[1])/that.zoom
        console.log({ o1, gpos0, gpos1, o0 })

        window.proj.rotate(o1);

        mainSvg.selectAll(".point")
            .datum({type: "Point", coordinates: gpos1});
        mainSvg
          .select("g#states")
          .selectAll("path").attr("d", window.path);
        
        that.drawPlanePath()
      }

      function dragended(){
        mainSvg.selectAll(".point").remove();
      }

      mainSvg.call(d3.drag()
        .on("start", dragstarted)
        .on("drag", dragged)
        .on("end", dragended));
      mainSvg
        // .call(dragMap)
        .call(
          zoom
            .scaleExtent([1, 10])
            .on("zoom", () => {
              this.zoom = d3.event.transform.k
              svg
                .attr("transform", d3.event.transform)
                .attr("stroke-width", 1 / d3.event.transform.k)
            })
            // .on("end", () => {
            //   let transform = d3.event.transform
            //   this.drawTestSites(transform.x, transform.y, transform.k)
            //   // d3.selectAll("g#clinicalTrials circle")
            //   //   .transition()
            //   //   .duration(250)
            //   //   .attr("r", `${2 / transform.k}px`)
            // })
        )
        .on("dblclick.zoom", null)

      // Create legend
      const legend = mainSvg
        .append("g")
        .attr("id", "legend")
        .attr("transform", "translate(690,333)scale(0.8)")
      legend
        .append("rect")
        .attr("id", "frame")
        .attr("rx", 4)
        .attr("ry", 4)
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 225)
        .attr("height", 200)
        .attr("fill", "#dddc")
        .attr("stroke", "#ccc")

      legend
        .append("text")
        .attr("id", "legendTitle")
        .attr("x", 210 / 2)
        .attr("y", 20 + 2)
        .text("Travel")
        // .style("fill", "#333")
        .attr("alignment-baseline", "middle")
        .style("font-size", "16px")
        .style("font-weight", "700")
        .style("text-anchor", "middle")

      // TODO: delete test and clinical sites references

      // var legendTestSites = legend.append("g").attr("id", "legendTestSites")
      // legendTestSites
      //   .append("circle")
      //   .attr("cx", 20)
      //   .attr("cy", 30 + 20)
      //   .attr("r", 6)
      //   .style("fill", testSitesDotColor)
      // legendTestSites
      //   .append("text")
      //   .attr("x", 30)
      //   .attr("y", 30 + 20 + 2)
      //   .text("Test Sites")
      //   .style("fill", "hsl(212, 85%, 45%)")
      //   .style("font-size", "15px")
      //   .attr("alignment-baseline", "middle")
      // legendTestSites
      //   .style("cursor", "pointer")
      //   .on("click", this.toggleTestSites)

      // var legendClinicalTrials = legend
      //   .append("g")
      //   .attr("id", "legendClinicalTrials")
      // legendClinicalTrials
      //   .append("circle")
      //   .attr("cx", 20)
      //   .attr("cy", 30 + 20 + 22)
      //   .attr("r", 6)
      //   .style("fill", clinicalTrialsDotColor)
      // legendClinicalTrials
      //   .append("text")
      //   .attr("x", 30)
      //   .attr("y", 30 + 20 + 22 + 2)
      //   .text("Clinical Trials")
      //   .style("fill", "hsl(212, 85%, 45%)")
      //   .style("font-size", "15px")
      //   .attr("alignment-baseline", "middle")
      // legendClinicalTrials
      //   .style("cursor", "pointer")
      //   .on("click", this.toggleClinicalTrials)

      // Create legend for Travel
      let createLegend = (element, id, label, y, color, onClick) => {
        var lx = element
          .append("g")
          .attr("id", id)
        lx
          .append("circle")
          .attr("cx", 20)
          .attr("cy", y)
          .attr("r", 6)
          .style("fill", color)
        lx
          .append("rect")
          .attr("x", 20 - 6)
          .attr("y", y - 6)
          .attr("width", 13)
          .attr("height", 13)
          .style("stroke", "white")
          .style("fill", color)
        lx
          .append("text")
          .attr("x", 30)
          .attr("y", y + 2)
          .text(label)
          .style("font-size", "15px")
          .attr("alignment-baseline", "middle")
        lx
          .style("cursor", "pointer")
          .on("click", onClick)
      }
      let travelLegend = legend
        .append("g")
        .attr("id", "travelLegend")
      let separation = 30
      createLegend(travelLegend, 'travelLegend-origin', 'Origin', 50, '#2aa8db', function() { })
      createLegend(travelLegend, 'travelLegend-open', 'Open', 50 + separation, '#44d378', function() { })
      createLegend(travelLegend, 'travelLegend-restricted', 'Restricted', 50 + separation * 2, '#c5c443', function() { })
      createLegend(travelLegend, 'travelLegend-closed', 'Closed', 50 + separation * 3, '#c54343', function() { })
      createLegend(travelLegend, 'travelLegend-unknown', 'Unknown', 50 + separation * 4, '#b6b6b6', function() { })

      // Create legend for cases
      let casesLegend = legend
        .append("g")
        .attr("id", "casesLegend")
      var colors = [
        this.color2(0),
        this.color2(0.04),
        this.color2(0.16),
        this.color2(0.36),
        this.color2(0.64),
        this.color2(1)
      ]
      var grad = casesLegend
        .append("defs")
        .append("linearGradient")
        .attr("id", "grad")
        .attr("x1", "0%")
        .attr("x2", "100%")
        .attr("y1", "0%")
        .attr("y2", "0%")

      grad
        .selectAll("stop")
        .data(colors)
        .enter()
        .append("stop")
        .style("stop-color", function(d) {
          return d
        })
        .attr("offset", function(d, i) {
          return 100 * (i / (colors.length - 1)) + "%"
        })

      casesLegend
        .append("rect")
        .attr("x", 14)
        .attr("y", 30 + 70 - 40)
        .attr("width", 210 - 14 * 2)
        .attr("height", 15)
        .style("fill", "url(#grad)")
        .attr("transform", "translate(0,70)")
      casesLegend
        .append("text")
        .attr("id", "header")
        .attr("x", 210 / 2)
        .attr("y", 30 + 70 + 50)
        .attr("alignment-baseline", "middle")
        .style("font-size", "15px")
        .style("text-anchor", "middle")
        .text("Relative no. of county cases across state")
        .call(this.wrap, 180)
      casesLegend
        .append("text")
        .attr("id", "lowCases")
        .attr("x", 14)
        .attr("y", 30 + 97 + 30 - 40)
        .text("Low cases")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
        .style("text-anchor", "start")
      casesLegend
        .append("text")
        .attr("id", "highCases")
        .attr("x", 210 - 14)
        .attr("y", 30 + 97 + 30 - 40)
        .text("High cases")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
        .style("text-anchor", "end")

      let reopeningPanel = legend
        .append("g")
        .attr("id", "reopening")
        .style("display", "none")
        .attr("transform", "translate(0,247)")
      reopeningPanel
        .append("line")
        .attr("x1", 0)
        .attr("y1", "-20")
        .attr("x2", 210)
        .attr("y2", "-20")
        .attr("stroke", "#ccc")
      reopeningPanel
        .append("text")
        .attr("x", 210 / 2)
        .attr("y", 0)
        .attr("alignment-baseline", "middle")
        .style("font-size", "15px")
        .style("font-weight", "700")
        .style("text-anchor", "middle")
        .text("Reasons to go to this country")
        .call(this.wrap, 180)

      // Create controls to move map
      const controls = mainSvg
        .append("g")
        .attr("id", "controls")
        .attr("transform", "translate(130,400)scale(1)")
      controls
        .append("circle")
        .attr("cx", 0)
        .attr("cy", 0)
        .attr("r", 80)
        .attr('stroke-width', 2)
        .style("opacity", "0.7")
      controls
        .append("g")
        .attr('class', 'button')
        .append("circle")
        .attr('class', 'button-back')
        .attr("cx", -70)
        .attr("cy", 75)
        .attr("r", 10)
        .on("click", () => {
        })
      controls
        .append("g")
        .attr('class', 'button')
        .append("circle")
        .attr('class', 'button-back')
        .attr("cx", 70)
        .attr("cy", 75)
        .attr("r", 10)
        .on("click", () => {
          const mainSvg = d3.select(".map-frame svg")
          console.log("this.zoom")
          mainSvg
            .call(
              zoom
                .scaleExtent([1, 10])
                .on("zoom", () => {
                  this.zoom = d3.event.transform.k - 2
                  console.log("this.zoom: 2")
                  console.log(this.zoom)
                  svg
                    .attr("transform", d3.event.transform)
                    .attr("stroke-width", 1 / d3.event.transform.k)
                })
            )
        })
      controls
        .append("g")
        .attr('class', 'button')
        .append("circle")
        .attr('class', 'button-back')
        .attr("cx", 0)
        .attr("cy", 0)
        .attr("r", 21)
        .on("click", () => {

          if (!this.currentLocation) {
            return
          }
          // Rotate globe to clicked location
          this.rotateGlobe(true, ...this.currentLocation)
          
          // Reset zoom
          const mainSvg = d3.select(".map-frame svg")
          let width = viewBox.width
          let height = viewBox.height
          mainSvg
            .transition()
            .duration(750)
            .call(
              zoom.transform,
              d3.zoomIdentity,
              d3.zoomTransform(mainSvg.node()).invert([width / 2, height / 2])
            )

        })
        // .style("fill", "#00000042")
        // .attr('stroke', '#9d97ff42')
        // .attr('stroke-width', 2)
        // .style("opacity", "0.7")
      var arcGenerator = d3.arc()
        .innerRadius(30)
        .outerRadius(65)
        .padAngle(.09)
        .padRadius(100)
        .cornerRadius(2)

      // var arcData = [
      //   { startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75, rotateX: -10, rotateY: 0},
      //   { startAngle: Math.PI * 0.75, endAngle: Math.PI * 1.25, rotateX: 0, rotateY: 10},
      //   { startAngle: Math.PI * 1.25, endAngle: Math.PI * 1.75, rotateX: 10, rotateY: 0},
      //   { startAngle: Math.PI * -0.25, endAngle: Math.PI * 0.25, rotateX: 0, rotateY: -10},
      // ]

      var arcData = [
        { startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75, rotate: 0, rotateX: -10, rotateY: 0},
        { startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75, rotate: 90, rotateX: 0, rotateY: 10},
        { startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75, rotate: 180, rotateX: 10, rotateY: 0},
        { startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75, rotate: 270, rotateX: 0, rotateY: -10},
      ]

      var arrowGenerator = d3.arc()
        .padAngle(.4)
        .padRadius(100)
        .cornerRadius(2)
      var arrowData = { innerRadius: 20, outerRadius: 35, startAngle: Math.PI * 0.25, endAngle: Math.PI * 0.75 }

      let buttons = controls
        .selectAll('g.button.side-button')
        .data(arcData)
        .enter()
        .append("g")
        .attr("class", "button side-button")
        .attr("transform", d => `rotate(${d.rotate})`)
        // .style("opacity", "0.5")
        // .on("mouseover", function () {
        //   console.log(this)
        //   d3.select(this).style('opacity', 1)
        // })
        // .on("mouseout", function () {
        //   d3.select(this).style('opacity', 0.5)
        // })
        .on("click", function (d) {

          // Rotate globe just a bit
          let x = window.proj.rotate()
          x[0] += d.rotateX
          x[1] += d.rotateY
          window.proj.rotate(x);
          mainSvg
            .select("g#states")
            .selectAll("path").attr("d", window.path);
          that.drawPlanePath()
        })
      buttons
        .append('path')
        .attr('class', 'button-back')
        .attr('d', arcGenerator)
        // .attr('stroke', '#9d97ff')
        // .attr('stroke-width', 2)
        // .attr('fill', '#2626ff77')
        // .style('cursor', 'pointer')
      
      buttons
        .append('path')
        .attr('class', 'arrow')
        .attr('d', arrowGenerator(arrowData))
        .attr("transform", `translate(75,0)scale(-1,1)`)
        // .attr('fill', 'white')

      // Define the div for the tooltip
      var tooltip = d3
        .select(".map-frame")
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0)
      var tooltipLabel = d3
        .select(".map-frame")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)


      let showTooltip = this.createShowToolTip(tooltip, ".map-frame")
      let showTooltipLabel = this.createShowToolTip(tooltipLabel, ".map-frame")
      let hideTooltip = this.createHideTooltip(tooltip)
      let hideTooltipLabel = this.createHideTooltip(tooltipLabel)


      mapStates = svg
        .append("g")
        .attr("id", "states")
        .selectAll("path")
        .data(mainData.states)
        .enter()
        .append("path")
      mapStates
        .attr("fill", "#0000")
        .attr("stroke", "#fff")
        .attr("d", path)
        .on("click", this.stateClicked)
        .on("mouseover", function(d) {
          let state = d.properties.name || d.properties.admin
          let countryCode = that.getCountryName(state, 'code')

          if (false) {
          // if (that.mode == "travel") {
            if (!that.fromCountry) {
              that.colorTravelMap(state, d)
            } else if (state != that.fromCountry) {

              // Show restriction description on popover
              // TODO: fix to country mappings
              let restriction = that.travelRestrictions.find(x => x.state == state)
              restriction = restriction ? restriction.levelDisplay : ''
              showTooltipLabel(`<b>From ${that.fromCountry} to ${state}</b>`
                + `<br> ${restriction}`)
              hideTooltip()
            }
          } else {
            d3.select(this)
              .attr("stroke", stateStroke)
              .raise()

            // Display Total Cases
            let days = document.querySelector("#myRange").value
            let date = moment("2020-01-01")
              .add(days - 1, "days")
              .format("YYYY-MM-DD")
            let stateSummary = mainData.getStateMinMax().filter(
              d => d.code === countryCode && d.date <= date
            )
            stateSummary = _.orderBy(stateSummary, ["date"], ["desc"])[0]
            let cases = stateSummary ? stateSummary.cases || 0 : 0
            let activeCases = stateSummary ? stateSummary.activeCases || 0 : 0
            let deaths = stateSummary ? stateSummary.deaths || 0 : 0

            showTooltipLabel(`<b>${state}</b>`
              + `<br>${format(activeCases)} active cases`
              + `<br>${format(cases)} total cases`
              + `<br>${format(deaths)} deaths`)
            hideTooltip()
          }
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("stroke", "#fff")
            .lower()
          hideTooltip()
          hideTooltipLabel()
        })

      svg
        .append("g")
        .attr("id", "testSites")
        .attr("fill", testSitesDotColor)
      svg
        .append("g")
        .attr("id", "clinicalTrials")
        .attr("fill", clinicalTrialsDotColor)
      this.drawTestSites()

      return svg.node()
    },

    drawTestSites: function(translateX, translateY, scale) {
      let testSitesCoordinates = mainData.testSites2
      let clinicalTrialCoordinates = mainData.clinicalTrialCoordinates

      if (
        (translateX === 0 || translateX) &&
        (translateY === 0 || translateY) &&
        (scale === 0 || scale)
      ) {
        let x1 = -translateX / scale
        let x2 = (-translateX + viewBox.width) / scale
        let y1 = -translateY / scale
        let y2 = (-translateY + viewBox.height) / scale

        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[0] >= x1
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[0] <= x2
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[1] >= y1
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[1] <= y2
        )
      }
      scale = scale || 1

      if (scale < 2) {
        testSitesCoordinates = []
        clinicalTrialCoordinates = []
      }

      // Initialize tooltips
      var tooltip = d3.select(".map-frame .tooltip")
      var tooltipLabel = d3.select(".map-frame .tooltip-label")

      let showTooltip = this.createShowToolTip(tooltip, ".map-frame")
      let showTooltipLabel = this.createShowToolTip(tooltipLabel, ".map-frame")
      let hideTooltip = this.createHideTooltip(tooltip)
      let hideTooltipLabel = this.createHideTooltip(tooltipLabel)

      // Draw test sites
      const svg = d3.select(".map-frame g#country")
      mapTestSites = svg
        .select("g#testSites")
        .selectAll("circle")
        .data(testSitesCoordinates, d => d.OBJECTID)
        .attr("r", `${2 / scale}px`)
      mapTestSites
        .enter()
        .append("circle")
        .style("opacity", 0)
        // .attr("r", 0)
        .attr("r", `${2 / scale}px`)
        .attr("cx", d => d.coordinates[0])
        .attr("cy", d => d.coordinates[1])
        // .attr("r", `${2/scale}px`)
        // .attr("r", "1.5px")
        .on("mouseover", d => {
          showTooltipLabel(testSiteTooltipHtml(d))
          hideTooltip()
        })
        .on("mouseout", d => {
          hideTooltip()
          hideTooltipLabel()
        })
        .transition()
        .duration(750)
        .style("opacity", 1)

      mapTestSites
        .exit()
        .transition()
        .duration(750)
        .style("opacity", 0)
        .remove()
        
      // TODO: filter to optimize
      // Draw clinical trial locations
      svg.select("g#clinicalTrials").selectAll("circle").remove()
      mapClinicalTrials = svg.select("g#clinicalTrials")
        .selectAll("circle")
        .data(clinicalTrialCoordinates)
        .enter()
        .append("circle")
      mapClinicalTrials
        .attr("cx", d => d.coordinates[0])
        .attr("cy", d => d.coordinates[1])
        .attr("r", `${2 / scale}px`)
        .on("mouseover", d => {
          showTooltip(clinicalTooltipHtml(d))
          hideTooltipLabel()
        })
        .on("mouseout", d => {
          hideTooltip()
        })

    },
    
    toLowerTrimmed(str) {
      if (!str || !str.toLowerCase) {
        return str
      }

      return str.toLowerCase().trim()
    },
    timeParse: d3.timeParse("%Y-%m-%d"),

    setToDay: async function(day) {
      this.logAction(`WorldTravelNavigator, View Day (${day})`)

      document.querySelector("#myRange").value = day

      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
        d3.select(".play-btn .material-icons").text("play_arrow")
        await new Promise(r => setTimeout(r, 100))
      }

      this.setDayData(day)
    },

    getCasesOfDay: function(casesData, date) {
      let data = casesData

      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))
      let groupedByState = this.groupBy(data, "state")
      for (let ix in groupedByState) {
        let arr = groupedByState[ix]
        let maxActiveCasesState = Math.max(0, ...arr.map(d => +d.activeCases))
        let maxCasesState = Math.max(0, ...arr.map(d => +d.cases))
        let maxDeathsState = Math.max(0, ...arr.map(d => +d.deaths))

        arr.forEach(d => {
          d.activeCasesRelativeToState =
            maxActiveCasesState == 0 ? 0 : +d.activeCases / maxActiveCasesState
          d.activeCasesRelativeToCountry =
            maxActiveCasesCountry == 0
              ? 0
              : +d.activeCases / maxActiveCasesCountry

          d.maxCasesState = maxCasesState
          d.casesRelativeToState =
            maxCasesState == 0 ? 0 : +d.cases / maxCasesState
          d.casesRelativeToCountry =
            maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry

          d.maxDeathsState = maxDeathsState
          d.deathsRelativeToState =
            maxDeathsState == 0 ? 0 : +d.deaths / maxDeathsState
          d.deathsRelativeToCountry =
            maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
        })
      }

      data = data.map(d => ({
        location: d.location,
        state: d.state,
        // cases: [0, +d.cases],
        info: {
          activeCasesRelativeToState: +d.activeCasesRelativeToState,
          activeCasesRelativeToCountry: +d.activeCasesRelativeToCountry,

          cases: +d.cases,
          casesRelativeToState: +d.casesRelativeToState,
          casesRelativeToCountry: +d.casesRelativeToCountry,
          newCases: +d.newCases,
          difCasesPct: +d.difCasesPct,
          difCases: +d.difCases,
          deaths: +d.deaths,
          deathsRelativeToState: +d.deathsRelativeToState,
          deathsRelativeToCountry: +d.deathsRelativeToCountry,
          newDeaths: +d.newDeaths,
          difDeathsPct: +d.difDeathsPct,
          difDeaths: +d.difDeaths,
          activeCases: +d.activeCases
        }
      }))
      let records = new Map(
        Array.from(data, ({ location, info }) => [location, info])
      )

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        byCounty: records
      }
    },

    getStateCases: function(data, date) {
      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))

      data.forEach(d => {
        d.activeCasesRelativeToCountry =
          maxActiveCasesCountry == 0
            ? 0
            : +d.activeCases / maxActiveCasesCountry
        d.casesRelativeToCountry =
          maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry
        d.deathsRelativeToCountry =
          maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
      })

      let records = new Map(Array.from(data, d => [d.code, d]))

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        byState: records
      }
    },


    setRelativeStateLabels() {
      if (!this.fromCountry || !this.relativeToState) return

      let countryCode = this.getCountryName(this.fromCountry, 'code')
      
      let days = document.querySelector("#myRange").value
      let date = moment("2020-01-01")
        .add(days - 1, "days")
        .format("YYYY-MM-DD")
      let minMaxCases = mainData.getStateMinMax().filter(
        d => d.code === countryCode && d.date <= date
      )
      minMaxCases = _.orderBy(minMaxCases, ["date"], ["desc"])[0]
      if (minMaxCases) {
        let highCases
        if (this.mode == "total") {
          highCases = minMaxCases.maxCases
        } else if (this.mode == "active") {
          highCases = minMaxCases.maxActiveCases
        } else if (this.mode == "deaths") {
          highCases = minMaxCases.maxDeaths
        } else if (this.mode == "trend") {
        }
        if (highCases) {
          d3.select("#lowCases").text(`${format(0)}`)
          d3.select("#highCases").text(`${format(highCases)}`)
        }
      }
    },
    setDayData: function(days) {
      if (!mainData.casesData) return
      
      let date = moment("2020-01-01").add(days - 1, "days")
      var desiredDate = date.format("YYYY-MM-DD")

      d3.select("#date").text(date.format("MMM D, YYYY"))
      // console.log(desiredDate)

      let cases = this.getCasesOfDay(mainData.casesData, desiredDate)
      let stateCases = this.getStateCases(mainData.getStateMinMax(), desiredDate)

      let field = "casesRelativeToState"
      let colorFn = this.color2
      let lowText = null
      let highText = null

      if (this.relativeToState && this.level == 'county') {
        if (this.mode == "total") {
          colorFn = this.colorCases
          field = "casesRelativeToState"
        } else if (this.mode == "active") {
          colorFn = this.colorActiveCases
          field = "activeCasesRelativeToState"
        } else if (this.mode == "deaths") {
          colorFn = this.colorDeaths
          field = "deathsRelativeToState"
        } else if (this.mode == "trend" || this.mode == "travel") {
          colorFn = this.colorChange
          field = "difCasesPct"
        }
      } else {
        if (this.mode == "total") {
          colorFn = this.colorCases
          field = "casesRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxCasesCountry)
        } else if (this.mode == "active") {
          colorFn = this.colorActiveCases
          field = "activeCasesRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxDeathsCountry)
        } else if (this.mode == "deaths") {
          colorFn = this.colorDeaths
          field = "deathsRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxActiveCasesCountry)
        } else if (this.mode == "trend" || this.mode == "travel") {
          colorFn = this.colorChange
          field = "difCasesPct"
        }
      }


      if (this.level == 'county' && !this.relativeToState) {
        if (this.mode == "total") {
          lowText = '0'
          highText = format(cases.maxCasesCountry)
        } else if (this.mode == "active") {
          lowText = '0'
          highText = format(cases.maxActiveCasesCountry)
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = format(cases.maxDeathsCountry)
        } else if (this.mode == "trend") {
        }
      } else if (this.level == 'county' && this.relativeToState) {
        if (this.fromCountry) {
          // If zoomed
          this.setRelativeStateLabels()
        } else if (this.mode == "total") {
          lowText = '0'
          highText = 'High cases'
        } else if (this.mode == "active") {
          lowText = '0'
          highText = 'High cases'
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = 'High deaths'
        } else if (this.mode == "trend") {
        }
      } else if (this.level == 'state') {
        if (this.mode == "total") {
          lowText = '0'
          highText = format(stateCases.maxCasesCountry)
        } else if (this.mode == "active") {
          lowText = '0'
          highText = format(stateCases.maxActiveCasesCountry)
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = format(stateCases.maxDeathsCountry)
        } else if (this.mode == "trend") {
        }
      }

      var colors = [
        colorFn(0),
        colorFn(0.04),
        colorFn(0.16),
        colorFn(0.36),
        colorFn(0.64),
        colorFn(1)
      ]
      if (this.mode == "trend" || this.mode == "travel") {
        colors = [
          colorFn(-1),
          colorFn(-0.5),
          colorFn(0.0),
          colorFn(0.5),
          colorFn(1)
        ]
        lowText = "Decreasing"
        highText = "Increasing"
      }

      if (lowText) {
        d3.select("#lowCases").text(lowText)
      }
      if (highText) {
        d3.select("#highCases").text(highText)
      }
      
      var grad = d3.select(".map-frame svg #grad")

      grad.selectAll("stop").remove()
      grad
        .selectAll("stop")
        .data(colors)
        .enter()
        .append("stop")
        .style("stop-color", function(d) {
          return d
        })
        .attr("offset", function(d, i) {
          return 100 * (i / (colors.length - 1)) + "%"
        })

      var colorCounty = id => {
        let record = cases.byCounty.get(id) || {}
        if ((this.mode == "trend" || this.mode == "travel") && record.activeCases < 100) {
          return colorFn(0)
        }
        return colorFn(record[field] || 0)
      }
      var colorState = id => {
        let code = this.getCountryName(id, 'code')
        let record = stateCases.byState.get(code) || {}
        if ((this.mode == "trend" || this.mode == "travel") && record.activeCases < 100) {
          return colorFn(0)
        }
        return colorFn(record[field] || 0)
      }

      var mapTestSitesVisibility =
        days > 60 && testSitesShown ? "block" : "none"
      var mapClinicalVisibility =
        days > 60 && clinicalTrialsShown ? "block" : "none"
      d3.select("g#testSites").attr("display", mapTestSitesVisibility)
      mapClinicalTrials.attr("display", mapClinicalVisibility)

      if (this.level == "county") {
        // mapCounties
        //   .transition()
        //   .duration(100)
        //   .attr("fill", d => colorCounty(d.properties.location_id))
        // mapStates
        //   .transition()
        //   .duration(100)
        //   .attr("fill", "#0000")
      } else if (this.level == "state") {
        mapStates
          .transition()
          .duration(100)
          .attr("fill", d => {
            return colorState(d.properties.name || d.properties.admin)
          })
      }
    },

    resizeToPath: function(d) {
      // // let dateTime = Date.now()
      // // console.log((Date.now() - dateTime)/1)
      // let svg = d3.select("g#country")

      // let width = viewBox.width
      // let height = viewBox.height

      // // if (d3.select(".background").node() === this) return reset()

      // // console.log((Date.now() - dateTime)/1)

      // var bounds = path.bounds(d),
      //   dx = bounds[1][0] - bounds[0][0],
      //   dy = bounds[1][1] - bounds[0][1],
      //   x = (bounds[0][0] + bounds[1][0]) / 2,
      //   y = (bounds[0][1] + bounds[1][1]) / 2,
      //   scale = 0.9 / Math.max(dx / width, dy / height),
      //   translate = [-scale * x + width / 2, -scale * y + height / 2]

      // const mainSvg = d3.select(".map-frame svg")
      // mainSvg
      //   .transition()
      //   // .ease('easeLinear')
      //   .duration(750)
      //   .call(
      //     zoom.transform,
      //     d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale),
      //     // d3.mouse(svg.node())
      //     null
      //   )
    },


    zoomToState: function(name) {
      let d = mainData.states.find(s => s.properties.name === name || s.properties.admin == name)
      let paths = d3
        .select("g#states")
        .selectAll("path")
        .nodes()
      let index = mainData.states.indexOf(d)

      this.stateClicked(d, index, paths)
    },

    stateClicked: function(d, index, paths) {
     
      console.log("stateClicked")
      let stateName = d.properties.name || d.properties.admin
      // this.fromCountry = stateName
        // console.log(d3.select(".map-frame"))

      // TODO: temp code
      if (!window.newCenters) window.newCenters = []
      let currentCenter = window.newCenters.find(d => d.name == stateName)
      if (!currentCenter) {
        currentCenter = {}
        currentCenter.name = stateName
        window.newCenters.push(currentCenter)
      }

      // currentCenter.center = window.proj.invert(d3.mouse(d3.select(".map-frame svg").node()))
      // console.log("window.newCenters")
      // console.log(window.newCenters)


      setCookie("travel.currentLocation", this.currentLocation)
      setCookie("travel.currentCountry", this.fromCountry)

      this.currentCounty = null
      this.logAction(`WorldTravelNavigator, CountryClicked, ${stateName}`)

      
      let currentLocation = currentCenter.center
      // let currentLocation = window.proj.invert(d3.mouse(d3.select(".map-frame svg").node()));
      currentLocation = [-currentLocation[0],-currentLocation[1]]
      this.currentLocation = currentLocation

      // this.resizeToPath(d)
      if (this.mode == "travel") {
        this.colorTravelMap(stateName, d)
        this.rotateGlobe(true, ...currentLocation)
        // TODO: pass callback to rotate globe
        setTimeout(this.animatePlanes, 2000)
        
      } else {
        this.resizeToPath(d)
        this.rotateGlobe(true, ...currentLocation)
      }


      this.showBar(
        `Click here to be notified when reopening mandates change on ${stateName}.`,
        `Scroll down to see state profile: cases, reopenings and closings`
      )

      // this.setBreadcrumb("state", stateName)

      let dateTime = Date.now()
      this.resizeToPath(d)

      this.setRelativeStateLabels()
      d3.select("#legendTitle").text(`${stateName}`)

      // Resize Legend
      const legend = d3
        .select("#legend")
        .transition()
        .duration(750)
        .attr("transform", "translate(690,20)scale(0.8)")
      d3.select("#legend #frame")
        .transition()
        .duration(750)
        .attr("height", 200 + 313 / 0.8)
      d3.select("#legend #reopening").style("display", "block")

      let reopenings = []
      let tourismData = mainData.touristDestinations.find(td => this.getCountryName(td.Country, 'code') == this.getCountryName(stateName, 'code'))
      // let fields = ['BeachesRelaxation', 'NatureHikingLakes', 'Adventure', 'Culture', 'ConnectivityAbility ', 'WarmClimateDec', 'CoolClimateDec']
      // let fields = this.countryCharacteristicFilters.map(d => d.name)
      if (tourismData) {
        this.countryCharacteristicFilters.forEach(field => {
          let statusColor = tourismData[field.name] == "X" ? green : gray
          reopenings.push({ display: field.display,  statusColor })
        })
        // reopenings.push({ display: 'Warm Climate (Dec - March)',  statusColor: tourismData.warmClimate == 'X' ? green : red })
        // reopenings.push({ display: 'Cold Climate (Dec - March)',  statusColor: tourismData.coldClimate == 'X' ? green : red })
      }
      d3.select("#legend #reopening")
        .selectAll("g")
        .remove()
      let reopeningRows = d3
        .select("#legend #reopening")
        .selectAll("g")
        .data(reopenings)
        .enter()
        .append("g")
      reopeningRows
        .append("circle")
        .attr("cx", 20)
        .attr("cy", (d, ix) => 70 + 30 * ix)
        .attr("r", 6)
        .style("fill", d => d.statusColor)
      reopeningRows
        .append("text")
        .attr("x", 30)
        .attr("y", (d, ix) => 70 + 30 * ix + 2)
        .html(d => d.display)
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")

      // let tsNum = testSites.filter(s => this.toLowerTrimmed(s.State) == this.toLowerTrimmed(stateName)).length
      let tsNum = mainData.testSites2.filter(
        s => this.toLowerTrimmed(s.stateName) == this.toLowerTrimmed(stateName)
      ).length
      d3.select("#legendTestSites")
        .select("text")
        .text(`Test Sites (${tsNum})`)
      let ctNum = mainData.clinicalTrials.filter(s => s.State == stateName).length
      d3.select("#legendClinicalTrials")
        .select("text")
        .text(`Clinical Trials (${ctNum})`)

      this.profilePanel = 0
      setTimeout(() => this.displayStateProfile(stateName))

      // permit choosing county
      if (this.mode != "travel") {
        d3.select("#resetBtn").style("display", "block")
        d3.select("#zoomOutBtn").style("display", "inline-block")
      }
      this.showHint = false
    },

    displayStateProfile: function(state) {
      let profile = d3.select(".state-profile")
      profile.style("display", "block")
      profile.select(".name").text(state)

      // Display Total Cases
      let countryCode = this.getCountryName(state, 'code')
      let days = document.querySelector("#myRange").value
      let date = moment("2020-01-01")
        .add(days - 1, "days")
        .format("YYYY-MM-DD")
      let stateSummary = mainData.getStateMinMax().filter(
        d => d.code === countryCode && d.date <= date
      )
      stateSummary = _.orderBy(stateSummary, ["date"], ["desc"])[0]
      if (stateSummary) {
        profile.select(".cases-icon").style("background", this.color2(1))
        profile.select(".cases").text(`${format(stateSummary.total)} cases`)
      } else {
        profile.select(".cases").text(`NA cases`)
      }

      this.updateStateCasesCharts(
        this.fromCountry || state, 
        this.toCountry || state)
      // this.updateStateCasesCharts(this.fromCountry, this.toCountry)
      this.updateReopeningStatusChart(state)

      let stateReopeningData = this.getStateReopeningData(state)

      let that = this
      $("[id^=field-]").text(function() {
        let id = $(this).attr("id")
        id = id.substring(id.indexOf("-") + 1)
        let value = stateReopeningData[id]

        if (value == "N/A") {
          $(this).text("-")
        } else if (value) {
          if (id.endsWith("Occupacy") && +value <= 1 && +value >= 0) {
            value = `${Math.round(value * 100)}%`
          }
          $(this).text(value)

          // Add class for permitted, recommended, ...
          let highlightedValues = [
            "prohibited",
            "permitted",
            "required",
            "recommended",
            "not-required",
            "not-permitted",
            "yes",
            "no"
          ]
          let classVal = that.toLowerTrimmed(value).replace(/ /g, "-")
          highlightedValues.forEach(val =>
            $(this).removeClass("highlight-" + val)
          )
          if (highlightedValues.indexOf(classVal) != -1) {
            $(this).addClass("highlight-" + classVal)
          } else if (
            that.toLowerTrimmed(value).indexOf("recommended") != -1 &&
            value.length <= 60
          ) {
            $(this).addClass("highlight-recommended")
          } else if (
            that.toLowerTrimmed(value).indexOf("required") != -1 &&
            value.length <= 60
          ) {
            $(this).addClass("highlight-required")
          }
        } else {
          $(this).text("")
        }
      })

      this.toLowerTrimmed(stateReopeningData["gatheringOpen"]) ==
      "not permitted"
        ? $("#special-gatheringOpen").show()
        : $("#special-gatheringOpen").hide()
      this.toLowerTrimmed(stateReopeningData["medicalOpen"]) == "not permitted"
        ? $("#special-medicalOpen").show()
        : $("#special-medicalOpen").hide()
      this.toLowerTrimmed(stateReopeningData["schoolsOpen"]) == "closed"
        ? $("#special-schoolsOpen").show()
        : $("#special-schoolsOpen").hide()
      this.toLowerTrimmed(stateReopeningData["childcareOpen"]) == "closed"
        ? $("#special-childcareOpen").show()
        : $("#special-childcareOpen").hide()

      // TODO: support multiple classes
      // $("a[class^=link-]")
      let linkElements = $("a[class^=link-]").filter(function() {
        return $(this)
          .attr("class")
          .split(/\s+/)
          .some(c => c.startsWith("link-"))
      })
      linkElements.text(function() {
        let field = $(this)
          .attr("class")
          .split(/\s+/)
          .find(c => c.startsWith("link-"))
        field = field.substring(field.indexOf("-") + 1)
        if (stateReopeningData[field]) {
          $(this).attr("href", stateReopeningData[field])
        } else {
          $(this).attr("href", "")
        }
      })

      $("[id^=openClose-]").text(function() {
        let id = $(this).attr("id")
        id = id.substring(id.indexOf("-") + 1)
        let status = stateReopeningData[id] || "Unknown"
        status = status.toLowerCase()
        $(this).removeClass("open")
        $(this).removeClass("closed")
        if (["open", "closed"].indexOf(status) != -1) {
          $(this).addClass(status)
        }
      })

      // Hide / show sections
      $(".fieldHideable").each(function() {
        let fields = $(this)
          .find("[id^=field-]")
          .map(function() {
            return $(this).text()
          })
          .get()
          .filter(t => !!t && t != "-")
        let openClose = $(this)
          .find("[id^=openClose-]")
          .map(function() {
            return $(this).hasClass("open") || $(this).hasClass("closed")
          })
          .get()
          .filter(t => !!t)
        let links = $(this)
          .find("a[class^=link-]")
          .map(function() {
            return $(this).attr("href")
          })
          .get()
          .filter(t => !!t)
        if (fields.length || openClose.length || links.length) {
          $(this).show()
        } else {
          $(this).hide()
        }
      })

      // Display
      this.profile.showProfile = true
      this.profile.showState = true
      this.profile.showCounty = false
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = false
      // d3.select(".accordion").style("display", "block")
      // d3.select(".county-profile").style("display", "none")
      // d3.select(".test-site-profile").style("display", "none")
      // d3.select(".trial-site-profile").style("display", "none")

      // Collapse
      // $(".accordion #collapseState").collapse("show")
    },

    updateStateCasesCharts: function(stateName1, stateName2) {
      let data1 = this.getDailyCasesData(stateName1)
      let data2 = this.getDailyCasesData(stateName2)
      
      let max = Math.max(d3.max(data1, d=> d.newCases), d3.max(data2, d=> d.newCases))

      this.updateStateCasesChart("#stateCasesChart1", stateName1, data1, max)
      this.updateStateCasesChart("#stateCasesChart2", stateName2, data2, max)
    },

    getDailyCasesData(stateName) {
      let casesData = mainData.casesData.filter(d => d.state == stateName)
      let groupedByDate = _.groupBy(
        casesData,
        "date"
      )

      let casesDates = casesData
        .map(d => d.date)
        .sort()
      let stopDate = moment(casesDates[casesDates.length - 1])
      var dateArray = []
      var currentDate = moment("2020-02-26")
      while (currentDate.isSameOrBefore(stopDate)) {
        dateArray.push(currentDate.format("YYYY-MM-DD"))
        currentDate = currentDate.add(1, "days")
      }

      let casesByDate = _.map(dateArray, date => {
        let arr = groupedByDate[date] || []
        return {
          date: date,
          cases: arr.map(d => +d.cases).reduce(sum, 0),
          deaths: arr.map(d => +d.cases).reduce(sum, 0)
        }
      })
      casesByDate = _.orderBy(casesByDate, ["date"], ["asc"]).filter(
        d => d.date >= "2020-02-26"
      )
      let pastCases = 0
      let pastDeaths = 0
      let pastNCases = []
      let dayAverage = 7
      let minCases = 0
      let firstIxOverMin = -1

      casesByDate.forEach((d, ix) => {
        if (firstIxOverMin === -1 && +d.cases >= minCases) {
          firstIxOverMin = ix
        }
        d.newCases = d.cases - pastCases
        d.newDeaths = d.deaths - pastDeaths

        pastNCases.push(d.newCases)
        pastNCases = pastNCases.splice(
          Math.max(0, pastNCases.length - dayAverage),
          dayAverage
        )
        d.average = pastNCases.reduce(sum, 0) / pastNCases.length

        pastCases = d.cases
        pastDeaths = d.deaths
      })
      casesByDate.splice(0, firstIxOverMin)

      // Show only last three months
      let since = moment().subtract(3, 'months').format("YYYY-MM-DD")
      casesByDate = casesByDate.filter(d => d.date >= since)

      let data = casesByDate.map(d => ({
        date: this.timeParse(d.date),
        newCases: d.newCases,
        average: d.average
      }))

      return data
    },

    updateStateCasesChart: function(elementId, stateName, data, max) {
      // Filter and transform data

      let comparedData = []
      // let comparedData = processCases(mainData.nytcasesData.filter(d => d.state == 'New Jersey'))

      var margin = { top: 20, right: 20, bottom: 30, left: 90 },
        width = 850 - margin.left - margin.right,
        height = 200 - margin.top - margin.bottom

      // Set the ranges
      var x = d3
        .scaleBand()
        .range([0, width])
        .paddingInner(0.1)
        .paddingOuter(1)
      var y = d3.scaleLinear().range([height, 0])

      // Scale the range of the data in the domains
      x.domain(data.map(d => d.date))
      y.domain([
        0,
        max
      ])

      // Create svg
      d3.select(elementId + " svg").remove()
      var svg = d3
        .select(elementId)
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Define tooltip
      d3.select(elementId + " .tooltip-label")
      var tooltip = d3
        .select(elementId)
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select(elementId)
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        .tickFormat(d3.timeFormat("%b %d"))
        .ticks(d3.timeDay.every(3))
        .tickSizeOuter([100])
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(0,-3)rotate(315)")
        // .attr("transform", "translate(0,-3px)rotate(315)")
        .style("text-anchor", "end")

      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y).ticks(2))
      svg.append("text")
        .attr("x", -32)
        .attr("y", 5)
        .style("font-size", "9px")
        .attr("alignment-baseline", "right")
        .text(formatNoDecimal(max))
      // svg.append("g").call(d3.axisLeft().scale(y).ticks(2))

      // Add bar cases
      svg
        .append("g")
        .selectAll(".bar")
        .data(comparedData)
        .enter()
        .append("rect")
        .attr("fill", casesComparedColor)
        .attr("class", "bar")
        .style("opacity", 0.5)
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases*2)
        })
        .attr("height", function(d) {
          return height - y(d.newCases*2)
        })
        .on("mouseover", function(d) {
          // d3.select(this).attr("fill", casesComparedColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          // d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })

      // Add bar cases
      svg
        .append("g")
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", casesColor)
        .attr("class", "bar")
        .style("opacity", 0.75)
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases)
        })
        .attr("height", function(d) {
          return height - y(d.newCases)
        })
        .on("mouseover", function(d) {
          d3.select(this).attr("fill", casesColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })


      // Add line average
      var line = d3
        .line()
        .x(function(d, i) {
          return x(d.date)
        })
        .y(function(d) {
          return y(d.average)
        })
        .curve(d3.curveMonotoneX) // apply smoothing to the line
      let lineG = svg.append("g")
      lineG
        .append("path")
        .datum(data)
        .attr("class", "line")
        .attr("fill", "none")
        .attr("stroke", lineColor)
        .attr("stroke-width", "3")
        .attr("d", line)

      // Add dots on average
      lineG
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("fill", lineColor)
        .attr("cx", function(d, i) {
          return x(d.date)
        })
        .attr("cy", function(d) {
          return y(d.average)
        })
        .attr("r", 3)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("fill", dotColorHover)
            .raise()
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${formatNoDecimal(
              d.average
            )} cases (7-day average)`
          )
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("fill", lineColor)
            .raise()
          hideTooltip()
        })
    },

    // toggleTestSites: function() {
    //   testSitesShown = !testSitesShown
    //   var display = testSitesShown ? "block" : "none"
    //   var opacity = testSitesShown ? "1" : "0.5"
    //   d3.select("g#testSites").attr("display", display)
    //   d3.select("#legendTestSites").style("opacity", opacity)
    //   d3.select("#toggleTestSites").classed("on", testSitesShown)
    //   d3.select("#resetBtn").style("display", "block")
    // },

    // toggleClinicalTrials: function() {
    //   clinicalTrialsShown = !clinicalTrialsShown
    //   var display = clinicalTrialsShown ? "block" : "none"
    //   var opacity = clinicalTrialsShown ? "1" : "0.5"
    //   mapClinicalTrials.attr("display", display)
    //   d3.select("#legendClinicalTrials").style("opacity", opacity)
    //   d3.select("#toggleClinicalTrials").classed("on", clinicalTrialsShown)
    //   d3.select("#resetBtn").style("display", "block")
    // },

    // setBreadcrumb: function(part, name) {
    //   if (part == "state") {
    //     d3.select("#bc-state a")
    //       .attr("href", `javascript:zoomToState('${name}')`)
    //       .text(name)
    //     d3.select(".bc #bc-map").style("display", "block")
    //     d3.select(".bc #bc-state").style("display", "block")
    //     d3.select(".bc #bc-county").style("display", "none")
    //   }
    //   if (part == "county") {
    //     d3.select("#bc-state a").text("")
    //     d3.select(".bc .county").remove()
    //     let stateName = ""
    //     if (name.indexOf(",")) {
    //       stateName = name.split(",")[1].trim()
    //       name = name.split(",")[0].trim()
    //       d3.select("#bc-state a")
    //         .attr("href", `javascript:zoomToState('${stateName}')`)
    //         .text(stateName)
    //     }
    //     d3.select("#bc-county a").text(name)
    //     d3.select(".bc #bc-map").style("display", "block")
    //     d3.select(".bc #bc-state").style("display", "block")
    //     d3.select(".bc #bc-county").style("display", "block")
    //   }

    //   if (part == "map") {
    //     d3.select(".bc #bc-map").style("display", "none")
    //     d3.select(".bc #bc-state").style("display", "none")
    //     d3.select(".bc #bc-county").style("display", "none")
    //   }
    // },

    animatemap: function() {
      this.logAction("WorldTravelNavigator, AnimateMap")

      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
        d3.select(".play-btn .material-icons").text("play_arrow")
        return
      }

      d3.select(".play-btn .material-icons").text("pause")

      let min = 21 // Start Jan-21
      let current = document.querySelector("#myRange").value
      current = Math.max(current, min)
      let max = moment().diff('2019-12-31', 'days')
      if (current == max) {
        current = min
      }

      let that = this
      function tick() {
        document.querySelector("#myRange").value = current
        that.setDayData(current)

        if (current < max) {
          current++
          timeoutId = setTimeout(tick, 50)
        } else {
          d3.select(".play-btn .material-icons").text("play_arrow")
          clearTimeout(timeoutId)
          timeoutId = null
        }
      }

      tick()
    },

    // Groups array by a property
    // Usage: groupBy(['one', 'two', 'three'], 'length')
    // Result: {3: ["one", "two"], 5: ["three"]}
    groupBy: function(xs, key) {
      return xs.reduce(function(rv, x) {
        ;(rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
      }, {})
    },

    scrollMeTo(selector) {
      var element = $(selector).get(0);
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },

    showBar(message, message2) {
      // if (this.notScrolled && message2) {
      //   this.$emit('showProfileHint', message2)
      // }
      // else 
      if (message) {
        this.$emit('showProfileHint', message)
      }
    },

    initCombosAndActions: function() {
      this.logAction("WorldTravelNavigator, Visit")


      let stateNames = _.uniq(mainData.casesData.map(d => d.state))
      stateNames.sort()

      d3.select("#stateCombo")
        .selectAll("option.state")
        .data(stateNames)
        .enter()
        .append("option")
        .attr("class", "state")
        .text(d => d)

      let that = this
      $(".profiles").on("click", ".test-sites-toggles .criteria-toggle", function(event) {
        console.log("criteria-toggle")
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected")
        } else {
          $(this).addClass("selected")
        }

        that.updateTestSitesTable()
      })

      $(".profiles").on("click", "#testSitesTable .criteria-toggle-header", function(
        event
      ) {
        let criteriaToggleName = "." + $(this).data("criteria-toggle")
        if ($(criteriaToggleName).hasClass("selected")) {
          $(criteriaToggleName).removeClass("selected")
        } else {
          $(criteriaToggleName).addClass("selected")
        }

        that.updateTestSitesTable()
      })
      
      $(".profiles").on("click", ".criteria-trials-toggles .criteria-toggle", function(event) {
        console.log("criteria-toggle")
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected")
        } else {
          $(this).addClass("selected")
        }

        that.updateClinicalTrialsTable()
      })

      $(".profiles").on("click", "#clinicalTrialsTable .criteria-toggle-header", function(
        event
      ) {
        let criteriaToggleName = "." + $(this).data("criteria-toggle")
        if ($(criteriaToggleName).hasClass("selected")) {
          $(criteriaToggleName).removeClass("selected")
        } else {
          $(criteriaToggleName).addClass("selected")
        }

        that.updateClinicalTrialsTable()
      })

    },


    mobileCheck: function() {
      let check = false
      ;(function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },

    getOS: function() {
      var osName = "Unknown OS"
      if (navigator.userAgent.indexOf("Win") != -1) osName = "Windows"
      if (navigator.userAgent.indexOf("Mac") != -1) osName = "Macintosh"
      if (navigator.userAgent.indexOf("Linux") != -1) osName = "Linux"
      if (navigator.userAgent.indexOf("Android") != -1) osName = "Android"
      if (navigator.userAgent.indexOf("like Mac") != -1) osName = "iOS"

      return osName
    },

    getBrowserDetails: function() {
      // https://stackoverflow.com/a/11219680
      // var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent
      var browserName = navigator.appName
      var fullVersion = "" + parseFloat(navigator.appVersion)
      var majorVersion = parseInt(navigator.appVersion, 10)
      var nameOffset, verOffset, ix

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera"
        fullVersion = nAgt.substring(verOffset + 6)
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8)
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer"
        fullVersion = nAgt.substring(verOffset + 5)
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome"
        fullVersion = nAgt.substring(verOffset + 7)
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari"
        fullVersion = nAgt.substring(verOffset + 7)
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8)
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox"
        fullVersion = nAgt.substring(verOffset + 8)
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset)
        fullVersion = nAgt.substring(verOffset + 1)
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix)
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix)

      majorVersion = parseInt("" + fullVersion, 10)
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion)
        majorVersion = parseInt(navigator.appVersion, 10)
      }

      return {
        browserName,
        fullVersion,
        majorVersion,
        appName: navigator.appName,
        userAgent: navigator.userAgent
      }
    },

    logAction: function(section) {
      console.log(section)

      let browserDetails = this.getBrowserDetails()

      let details = {
        section,
        iPAddress: this.ip,
        platform: this.getOS(),
        browser: browserDetails.browserName,
        browserVersion: browserDetails.fullVersion,
        userAgent: browserDetails.userAgent,
        isMobile: this.mobileCheck(),
        url: "www.millionpatientscured.com"
      }
      fetch(
        "https://testsites.millionpatientscured.com:5000/api/siteActionLog",
        {
          // fetch('http://localhost:5000/api/siteActionLog', {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(details)
        }
      )
        .then(() => {
          console.log("success logging")
        })
        .catch(function(error) {
          console.error("error logging")
          console.error(error)
        })
    },

    init: async function() {


      let promises = []
      let topology = null
      let stateTopology = null


      this.ip = "unknown"
      d3.json("https://api.ipify.org?format=json").then(
        res => (this.ip = res.ip)
      )

      promises.push(
        d3
          .json(
            "https://gist.githubusercontent.com/mbostock/df1b792d76fcb748056ff94b912e4bb8/raw/b1da4894cfb1e56a24129c27b39aa957d7f0c165/topology.json"
          )
          .then(res => (topology = res.topology))
      )
      promises.push(
        d3
          .json("countries-110m.json")
          .then(res => (stateTopology = res))
      )
      promises.push(
        d3
          .json("clinical-trials.json")
          .then(res => (mainData.clinicalTrials = res.clinicalTrials))
      )
      promises.push(
        d3.csv("testing-locations.csv").then(res => (mainData.testSites2 = res))
      )
      
      promises.push(
        d3.csv("int-travel-restrictions-us.csv")
          .then(res => (mainData.usTravelRestrictions = res))
      )
      promises.push(
        d3.csv("int-travel-restrictions-all.csv")
          .then(res => (mainData.allTravelRestrictions = res))
      )
      promises.push(
        d3.csv("tourist-destinations.csv")
          .then(res => (mainData.touristDestinations = res))
      )

      let reopeningDataJson = "reopening-data-africa.json?v=10"
      promises.push(
        d3.json(reopeningDataJson).then(res => (mainData.reopeningData = res))
      )
      
      promises.push(
        d3
          .csv(
            "WHO-COVID-19-global-data.csv"
          )
          .then(res => {
            let data = res
            data = data.map(d => ({
              date: d["Date_reported"], 
              region: d[" WHO_region"], // TODO: take out region for memory performance
              // county: d["Country"], 
              // county: "Country",
              code: d["Country_code"],
              state: d["Country"],
              cases: d["Cumulative_cases"],
              deaths: d["Cumulative_deaths"]
              	//  Country_code	 Country	 WHO_region	 New_cases	 	 New_deaths	 

            }))
            mainData.casesData = data
          })
      )
      promises.push(
        d3.json("town-keys.json")
          .then(res => mainData.townKeys = res)
      )
      await Promise.all(promises)
      // this.loading = false
      let dateTime = Date.now()

    
      stateTopology.bbox = [
        31.287342740802387,
        9.642076412917277,
        866.5765425854045,
        496.7312983451869
      ]

      let africaCountries = ["Angola", "Burundi", "Benin", "Burkina Faso", "Botswana", "Central African Republic", "Ivory Coast", "Cameroon", "Democratic Republic of the Congo", "Republic of Congo", "Comoros", "Cape Verde", "Djibouti", "Algeria", "Egypt", "Eritrea", "Ethiopia", "Gabon", "Ghana", "Guinea", "Gambia", "Guinea Bissau", "Equatorial Guinea", "Kenya", "Liberia", "Libya", "Lesotho", "Morocco", "Madagascar", "Mali", "Mozambique", "Mauritania", "Malawi", "Namibia", "Niger", "Nigeria", "Rwanda", "Western Sahara", "Sudan", "South Sudan", "Senegal", "Sierra Leone", "Somaliland", "Somalia", "Sao Tome and Principe", "Swaziland", "Chad", "Togo", "Tunisia", "United Republic of Tanzania", "Uganda", "South Africa", "Zambia", "Zimbabwe"]
      africaCountries.push(...["Dem. Rep. Congo", "W. Sahara", "Côte d'Ivoire", "Tanzania", "Guinea-Bissau", "Lesotho", "S. Sudan", "Central African Rep.", "Congo", "eSwatini", "Eq. Guinea"])


      mainData.states = topojson.feature(
        stateTopology,
        stateTopology.objects.countries
      ).features
      
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()

      this.allLocations = _.chain(mainData.states)
        .map(d => ({
          value: d.properties.name,
          key: d.properties.name,
          level: 1,
        }))
        .sortBy('value')
        .value()
      
      // this.latestDate = moment(mainData.reopeningData.lastUpdated).format('MMM D, YYYY')
      // Pre-process test sites
      mainData.testSites2 = mainData.testSites2
        .map(d => {
          let kindOfTest = d["Kind of test"] || ""
          d.antibodyTest = kindOfTest.toLowerCase().indexOf("antibody") != -1 ? "Yes" : "No"
          d.coordinates = projection([+d.x, +d.y])
          d.stateName =
            stateCodes
              .filter(sc => sc.code == d["State or Territory"])
              .map(sc => sc.name)[0] || d["State or Territory"]
          return d
        })
        .filter(d => d.coordinates && d.coordinates[0] && d.coordinates[1])
        // .slice(0, 12000)
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()

      mainData.clinicalTrialCoordinates = mainData.clinicalTrials
        .map(d => {
          if (!d.Coordinates) return d
          let lastComma = d.Coordinates.lastIndexOf(",")
          if (lastComma === -1) return d
          d.coordinates = d.Coordinates.substring(0, lastComma)
            .split(",")
            .map(
              c =>
                +c
                  .trim()
                  .replace("@", "")
                  .replace("]", "")
                  .replace("[", "")
            )
          return d
        })
        .filter(d => d.coordinates && d.coordinates.length === 2)
        .map(d => {
          d.coordinates = projection(d.coordinates)
          return d
        })
        .filter(d => d.coordinates && d.coordinates[0] && d.coordinates[1])
        // .slice(0, 12000)
      
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      // Pre-process mainData.casesData
      let fromTo = [
        {
          from: { county: "New York City", state: "New York" },
          to: [
            "Queens County, New York",
            "Kings County, New York",
            "Richmond County, New York",
            "Bronx County, New York",
            "New York County, New York"
          ]
        }
      ]
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      let townKeys = []
    

      console.log((Date.now() - dateTime)/1)
      console.log("county full name")
      dateTime = Date.now()


      // add county full name in each record
      mainData.casesData.forEach(d => {
        d.fullName = `${d.county}{areaName}, ${d.state}`
      })
   

      console.log((Date.now() - dateTime)/1)
      console.log("Calculate active cases")
      dateTime = Date.now()
      let dt
      let time11 = 0
      let time12 = 0
      let time13 = 0
      let time2 = 0
      let time3 = 0
      let time4 = 0
      let time5 = 0
      let time6 = 0
      
      // Calculate active cases
      // Calculate 7day active dif
      let getAvg = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        const avg = sum / nums.length || 0
        return avg
      }
      let getSum = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        return sum
      }
      let calc = (() => {
        let b
        let x = {
          sum: 0,
          doubleSum: 0,
          pastSum: 0,
          avg: 0,
          // pastAvg: 0,
          
          init(base) {
            b = base,
            values = []
            x.sum = 0
            x.doubleSum = 0
            x.pastSum = 0
            x.avg = 0
            // x.pastAvg = 0
          },
          add(v) {
            values.push(v)
            x.sum += v
            x.doubleSum += v
            if (values.length > b) {
              x.sum -= values[values.length - 1 - b]
              if (values.length > 2*b) {
                x.doubleSum -= values[values.length - 1 - 2*b]
              }
              // x.pastAvg = (x.doubleSum - x.sum)/Math.min(b, values.length - b)
            }
            x.avg = x.sum/Math.min(b, values.length)
            x.pastSum = x.doubleSum - x.sum
          },
        }
        let values = []

        return x
      })
      // calc.init(7)
      // calc.add(4)
      // calc.sum
      // calc.avg
      // calc.doubleSum
      let calcCases = calc()
      let calcDeaths = calc()
      _.each(this.groupBy(mainData.casesData, "fullName"), (arr, county) => {
        let casesByDate = _.orderBy(arr, ["date"], ["asc"])
        let pastCases = 0
        let pastDeaths = 0
        // let pastNCases = []
        // let pastNDeaths = []
        let dayAverage = 7
        calcCases.init(7)
        calcDeaths.init(7)
        casesByDate.forEach(d => {
          // dt = Date.now()
          d.newCases = d.cases - pastCases
          // time11 += Date.now() - dt
          // dt = Date.now()
          d.newDeaths = d.deaths - pastDeaths
          // time12 += Date.now() - dt
          // dt = Date.now()

          // d.activeCases = getSum(pastNCases.slice(-dayAverage * 2))
          // if (d.activeCases != calcCases.doubleSum()) debugg
          d.activeCases = calcCases.doubleSum

          // time13 += Date.now() - dt
          // dt = Date.now()

          // pastNCases.push(+d.newCases)
          // pastNDeaths.push(+d.newDeaths)

          // d.averageCases = getAvg(pastNCases.slice(-dayAverage))
          // if (d.averageCases != calcCases.avg) debugger
          d.averageCases = calcCases.avg
          // d.averageDeaths = getAvg(pastNDeaths.slice(-dayAverage))
          // if (d.averageDeaths != calcDeaths.avg) debugger
          d.averageDeaths = calcDeaths.avg

          calcCases.add(+d.newCases)
          calcDeaths.add(+d.newDeaths)

          // time2 += Date.now() - dt
          // dt = Date.now()
          
          // d.newCasesPeriod = getSum(pastNCases.slice(-dayAverage))
          // if (d.newCasesPeriod != calcCases.sum) debugger
          d.newCasesPeriod = calcCases.sum
          // let newCasesPastPeriod = getSum(
          //   pastNCases.slice(-dayAverage * 2, pastNCases.length - dayAverage)
          // )
          // if (newCasesPastPeriod != calcCases.pastSum) debugger
          let newCasesPastPeriod = calcCases.pastSum
          d.difCases = d.newCasesPeriod - newCasesPastPeriod
          d.difCasesPct = d.difCases / newCasesPastPeriod

          // time3 += Date.now() - dt
          // dt = Date.now()
          
          // d.newDeathsPeriod = getSum(pastNDeaths.slice(-dayAverage))
          // if (d.newDeathsPeriod != calcDeaths.sum) debugger
          d.newDeathsPeriod = calcDeaths.sum
          // let newDeathsPastPeriod = getSum(
          //   pastNDeaths.slice(-dayAverage * 2, pastNDeaths.length - dayAverage)
          // )
          // if (newDeathsPastPeriod != calcDeaths.pastSum) debugger
          let newDeathsPastPeriod = calcDeaths.pastSum
          d.difDeaths = d.newDeathsPeriod - newDeathsPastPeriod
          d.difDeathsPct = d.difDeaths / newDeathsPastPeriod



          // time4 += Date.now() - dt
          // dt = Date.now()
          
          // pastNCases = pastNCases.slice(-dayAverage * 2)
          // pastNDeaths = pastNDeaths.slice(-dayAverage * 2)

          pastCases = d.cases
          pastDeaths = d.deaths

          // time5 += Date.now() - dt
        })
      })
     
      console.log({time11, time12, time13, time2, time3, time4, time5})
      console.log((Date.now() - dateTime)/1)
      console.log("getStateMinMax()")
      dateTime = Date.now()


      mainData.stateMinMaxFn = () =>
        _.map(
          this.groupBy(mainData.casesData, "code"),
          (arr, code) =>
            _.map(this.groupBy(arr, "date"), (cases, date) => {
              let info = {
                code: code,
                date: date,
                activeCases: cases.map(d => +d.activeCases).reduce(sum, 0),
                cases: cases.map(d => +d.cases).reduce(sum, 0),
                deaths: cases.map(d => +d.deaths).reduce(sum, 0),
                newCases: cases.map(d => +d.newCases).reduce(sum, 0),
                newDeaths: cases.map(d => +d.newDeaths).reduce(sum, 0),
                averageCases: cases.map(d => +d.averageCases).reduce(sum, 0),
                averageDeaths: cases.map(d => +d.averageDeaths).reduce(sum, 0),
                newCasesPeriod: cases.map(d => +d.newCasesPeriod).reduce(sum, 0),
                newDeathsPeriod: cases.map(d => +d.newDeathsPeriod).reduce(sum, 0),
                difCases: cases.map(d => +d.difCases).reduce(sum, 0),
                difDeaths: cases.map(d => +d.difDeaths).reduce(sum, 0),
                minCases: Math.min(0, ...cases.map(d => +d.cases)),
                maxCases: Math.max(0, ...cases.map(d => +d.cases)),
                minDeaths: Math.min(0, ...cases.map(d => +d.deaths)),
                maxDeaths: Math.max(0, ...cases.map(d => +d.deaths)),
                minActiveCases: Math.min(0, ...cases.map(d => +d.activeCases)),
                maxActiveCases: Math.max(0, ...cases.map(d => +d.activeCases)),
                total: cases.map(d => +d.cases).reduce(sum, 0)
              }
              info.difCasesPct = info.difCases / (info.newCasesPeriod - info.difCases)
              info.difDeathsPct = info.difDeaths / (info.newDeathsPeriod - info.difDeaths)
              return info
            })
        ).flat()

      console.log((Date.now() - dateTime)/1)
      console.log("groupedByCounty")
      dateTime = Date.now()

      console.log((Date.now() - dateTime)/1)
      // console.log({time1, time2, time3})
      dateTime = Date.now()

      // this.loading = false

    },

    updateCountyCasesChart: function(countyFullName, locationId) {
      // Filter and transform data
      let casesByDate = _.map(
        _.groupBy(
          mainData.casesData.filter(d => d.location === locationId),
          "date"
        ),
        (arr, date) => ({
          date: date,
          cases: arr.map(d => +d.cases).reduce(sum, 0),
          deaths: arr.map(d => +d.cases).reduce(sum, 0)
        })
      )
      casesByDate = _.orderBy(casesByDate, ["date"], ["asc"])
      let pastCases = 0
      let pastDeaths = 0
      let pastNCases = []
      let dayAverage = 7
      let minCases = 20
      let firstIxOverMin = 0
      casesByDate.forEach((d, ix) => {
        if (firstIxOverMin === 0 && +d.cases >= minCases) {
          firstIxOverMin = ix
        }
        d.newCases = d.cases - pastCases
        d.newDeaths = d.deaths - pastDeaths

        pastNCases.push(d.newCases)
        pastNCases = pastNCases.splice(
          Math.max(0, pastNCases.length - dayAverage),
          dayAverage
        )
        d.average = pastNCases.reduce(sum, 0) / pastNCases.length

        pastCases = d.cases
        pastDeaths = d.deaths
      })
      casesByDate.splice(0, firstIxOverMin)

      let data = casesByDate.map(d => ({
        date: this.timeParse(d.date),
        newCases: d.newCases,
        average: d.average
      }))

      var margin = { top: 20, right: 20, bottom: 30, left: 40 },
        width = 850 - margin.left - margin.right,
        height = 200 - margin.top - margin.bottom

      // Set the ranges
      var x = d3
        .scaleBand()
        .rangeRound([0, width], 0.05)
        .padding(0.1)
      var y = d3.scaleLinear().range([height, 0])

      // Scale the range of the data in the domains
      x.domain(
        data.map(function(d) {
          return d.date
        })
      )
      y.domain([
        0,
        d3.max(data, function(d) {
          return d.newCases
        })
      ])

      // Create svg
      d3.select("#countyCasesChart svg").remove()
      var svg = d3
        .select("#countyCasesChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Define tooltip
      d3.select("#countyCasesChart .tooltip-label")
      var tooltip = d3
        .select("#countyCasesChart")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select("#countyCasesChart")
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        .tickFormat(d3.timeFormat("%b %d"))
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(0,-3)rotate(315)")
        // .attr("transform", "translate(0,-3px)rotate(315)")
        .style("text-anchor", "end")

      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y))

      // Add bar cases
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", casesColor)
        .attr("class", "bar")
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases)
        })
        .attr("height", function(d) {
          return height - y(d.newCases)
        })
        .on("mouseover", function(d) {
          d3.select(this).attr("fill", casesColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })

      // Add line average
      var line = d3
        .line()
        .x(function(d, i) {
          return x(d.date)
        })
        .y(function(d) {
          return y(d.average)
        })
        .curve(d3.curveMonotoneX) // apply smoothing to the line
      let lineG = svg.append("g")
      lineG
        .append("path")
        .datum(data)
        .attr("class", "line")
        .attr("fill", "none")
        .attr("stroke", lineColor)
        .attr("stroke-width", "3")
        .attr("d", line)

      // Add dots on average
      lineG
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("fill", lineColor)
        .attr("cx", function(d, i) {
          return x(d.date)
        })
        .attr("cy", function(d) {
          return y(d.average)
        })
        .attr("r", 3)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("fill", dotColorHover)
            .raise()
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${formatNoDecimal(
              d.average
            )} cases (7-day average)`
          )
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("fill", lineColor)
            .raise()
          hideTooltip()
        })
    },

    getStateReopeningData: function(stateName) {
      // Filter and transform data
      let stateReopeningRecords = mainData.reopeningData.openings.filter(
        d => d.state.trim() === stateName
      )

      let stateReopeningData = stateReopeningRecords.reduce((a, b) => {
        let c = _.clone(a)
        _.each(
          b,
          (val, field) => (c[field] = val === 0 || !!val ? val : c[field])
        )
        return c
      }, {})

      return stateReopeningData
    },

    updateReopeningStatusChart: function(stateName) {
      let stateReopeningData = this.getStateReopeningData(stateName)

      let data = [
        {
          category: "Travel",
          status: "closed",
          dateStart: stateReopeningData.travelShutdown,
          dateEnd: stateReopeningData.travelOpen
        },
        {
          category: "Travel",
          status: "open",
          dateStart: stateReopeningData.travelOpen,
          statusColor: stateReopeningData.travelButtonColor
        },
        {
          category: "People",
          status: "closed",
          dateStart: stateReopeningData.peopleShutdown,
          dateEnd: stateReopeningData.peopleOpen
        },
        {
          category: "People",
          status: "open",
          dateStart: stateReopeningData.peopleOpen,
          statusColor: stateReopeningData.peopleButtonColor
        },
        {
          category: "Gathering",
          status: "closed",
          dateStart: stateReopeningData.gatheringShutdown,
          dateEnd: stateReopeningData.gatheringOpen
        },
        {
          category: "Gathering",
          status: "open",
          dateStart: stateReopeningData.gatheringOpen,
          statusColor: stateReopeningData.gatheringButtonColor
        },
        {
          category: "Medical",
          status: "closed",
          dateStart: stateReopeningData.medicalShutdown,
          dateEnd: stateReopeningData.medicalOpen
        },
        {
          category: "Medical",
          status: "open",
          dateStart: stateReopeningData.medicalOpen,
          statusColor: stateReopeningData.medicalButtonColor
        },
        {
          category: "Schools",
          status: "closed",
          dateStart: stateReopeningData.schoolsShutdown,
          dateEnd: stateReopeningData.schoolsOpen
        },
        {
          category: "Schools",
          status: "open",
          dateStart: stateReopeningData.schoolsOpen,
          statusColor: stateReopeningData.schoolsButtonColor
        },
        {
          category: "Childcare",
          status: "closed",
          dateStart: stateReopeningData.childcareShutdown,
          dateEnd: stateReopeningData.childcareOpen
        },
        {
          category: "Childcare",
          status: "open",
          dateStart: stateReopeningData.childcareOpen,
          statusColor: stateReopeningData.childcareButtonColor
        },
        {
          category: "Public",
          status: "closed",
          dateStart: stateReopeningData.publicShutdown,
          dateEnd: stateReopeningData.publicOpen
        },
        {
          category: "Public",
          status: "open",
          dateStart: stateReopeningData.publicOpen,
          statusColor: stateReopeningData.publicButtonColor
        },
        {
          category: "Retail",
          status: "closed",
          dateStart: stateReopeningData.retailShutdown,
          dateEnd: stateReopeningData.retailOpen
        },
        {
          category: "Retail",
          status: "open",
          dateStart: stateReopeningData.retailOpen,
          statusColor: stateReopeningData.retailButtonColor
        },
        {
          category: "Restaurants",
          status: "closed",
          dateStart: stateReopeningData.restaurantsShutdown,
          dateEnd: stateReopeningData.restaurantsOpen
        },
        {
          category: "Restaurants",
          status: "open",
          dateStart: stateReopeningData.restaurantsOpen,
          statusColor: stateReopeningData.restaurantsButtonColor
        },
        {
          category: "Entertainment",
          status: "closed",
          dateStart: stateReopeningData.entretainmentShutdown,
          dateEnd: stateReopeningData.entretainmentOpen
        },
        {
          category: "Entertainment",
          status: "open",
          dateStart: stateReopeningData.entretainmentOpen,
          statusColor: stateReopeningData.entretainmentButtonColor
        },
        {
          category: "Bars",
          status: "closed",
          dateStart: stateReopeningData.barsShutdown,
          dateEnd: stateReopeningData.barsOpen
        },
        {
          category: "Bars",
          status: "open",
          dateStart: stateReopeningData.barsOpen,
          statusColor: stateReopeningData.barsButtonColor
        },
        {
          category: "Gyms",
          status: "closed",
          dateStart: stateReopeningData.gymsShutdown,
          dateEnd: stateReopeningData.gymsOpen
        },
        {
          category: "Gyms",
          status: "open",
          dateStart: stateReopeningData.gymsOpen,
          statusColor: stateReopeningData.gymsButtonColor
        },
        {
          category: "Close-Contact Biz",
          status: "closed",
          dateStart: stateReopeningData.closeContactBizShutdown,
          dateEnd: stateReopeningData.closeContactBizOpen
        },
        {
          category: "Close-Contact Biz",
          status: "open",
          dateStart: stateReopeningData.closeContactBizOpen,
          statusColor: stateReopeningData.closeContactBizButtonColor
        },
        {
          category: "Worship",
          status: "closed",
          dateStart: stateReopeningData.worshipShutdown,
          dateEnd: stateReopeningData.worshipOpen
        },
        {
          category: "Worship",
          status: "open",
          dateStart: stateReopeningData.worshipOpen,
          statusColor: stateReopeningData.worshipButtonColor
        }
      ]


      let dataFields = [
        {
          category: "Travel",
          status: "closed",
          dateStart: "travelShutdown",
          dateEnd: "travelOpen",
          statusColor: "travelButtonColor",
        },
        {
          category: "People",
          status: "closed",
          dateStart: "peopleShutdown",
          dateEnd: "peopleOpen",
          statusColor: "peopleButtonColor",
        },
        {
          category: "Gathering",
          status: "closed",
          dateStart: "gatheringShutdown",
          dateEnd: "gatheringOpen",
          statusColor: "gatheringButtonColor",
        },
        {
          category: "Medical",
          status: "closed",
          dateStart: "medicalShutdown",
          dateEnd: "medicalOpen",
          statusColor: "medicalButtonColor",
        },
        {
          category: "Schools",
          status: "closed",
          dateStart: "schoolsShutdown",
          dateEnd: "schoolsOpen",
          statusColor: "schoolsButtonColor",
        },
        {
          category: "Childcare",
          status: "closed",
          dateStart: "childcareShutdown",
          dateEnd: "childcareOpen",
          statusColor: "childcareButtonColor",
        },
        {
          category: "Public",
          status: "closed",
          dateStart: "publicShutdown",
          dateEnd: "publicOpen",
          statusColor: "publicButtonColor",
        },
        {
          category: "Retail",
          status: "closed",
          dateStart: "retailShutdown",
          dateEnd: "retailOpen",
          statusColor: "retailButtonColor",
        },
        {
          category: "Restaurants",
          status: "closed",
          dateStart: "restaurantsShutdown",
          dateEnd: "restaurantsOpen",
          statusColor: "restaurantsButtonColor",
        },
        {
          category: "Entertainment",
          status: "closed",
          dateStart: "entretainmentShutdown",
          dateEnd: "entretainmentOpen",
          statusColor: "entretainmentButtonColor",
        },
        {
          category: "Bars",
          status: "closed",
          dateStart: "barsShutdown",
          dateEnd: "barsOpen",
          statusColor: "barsButtonColor",
        },
        {
          category: "Gyms",
          status: "closed",
          dateStart: "gymsShutdown",
          dateEnd: "gymsOpen",
          statusColor: "gymsButtonColor",
        },
        {
          category: "Close-Contact Biz",
          status: "closed",
          dateStart: "closeContactBizShutdown",
          dateEnd: "closeContactBizOpen",
          statusColor: "closeContactBizButtonColor",
        },
        {
          category: "Worship",
          status: "closed",
          dateStart: "worshipShutdown",
          dateEnd: "worshipOpen",
          statusColor: "worshipButtonColor",
        },
      ]

      let stateReopeningRecords = mainData.reopeningData.openings.filter(
        d => d.state.trim() === stateName
      )
      let bars = []
      let newBar = {}
      dataFields.forEach(fields => {
        newBar = {}

        stateReopeningRecords.forEach(record => {
          let vaildDateStart = this.timeParse(record[fields.dateStart]) || null
          let validDateEnd = this.timeParse(record[fields.dateEnd]) || null

          if (!newBar.dateStart && vaildDateStart) {
            newBar.status = "closed"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateStart] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          } else if (vaildDateStart) {
            newBar.dateEnd = record[fields.dateStart] || null

            newBar = {}
            newBar.status = "closed"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateStart] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          }

          if (validDateEnd) {
            newBar.dateEnd = record[fields.dateEnd] || null

            
            newBar = {}
            newBar.status = "open"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateEnd] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          }

        })
      })
      data = bars



      data = data.filter(
        d => d.dateStart && moment(d.dateStart).isSameOrAfter("2020-01-01")
      )
      data.forEach(d => {
        d.dateStart = this.timeParse(d.dateStart)
        d.dateEnd = this.timeParse(d.dateEnd)
        if (d.dateStart && !d.dateEnd) {
          if (moment(d.dateStart).isAfter(moment())) {
            d.dateEnd = d.dateStart
          } else {
            d.dateEnd = new Date()
          }
        }
        d.color =
          d.status == "open"
            ? d.statusColor.toLowerCase() == "green"
              ? green
              : yellow
            : d.status == "closed"
            ? red
            : yellow
      })
      let categories = _.uniq(data.map(d => d.category)).reverse()

      var margin = { top: 20, right: 20, bottom: 30, left: 90 },
        width = 850 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom

      // Create svg
      d3.select("#reopeningStatusChart svg").remove()
      var svg = d3
        .select("#reopeningStatusChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Set the ranges
      // var x = d3.scaleBand()
      //   .rangeRound([0, width], .05)
      //   .padding(0.1)
      // var y = d3.scaleLinear()
      //         .range([height, 0])

      var x = d3.scaleTime().range([0, width])
      // .padding(0.1)
      var y = d3.scaleBand().rangeRound([height, 0], 0.05)

      // Scale the range of the data in the domains
      let minDate = this.timeParse("2020-02-25")
      let maxDate = this.timeParse(
        moment()
          .add(2, "days")
          .format("YYYY-MM-DD")
      )
      x.domain([minDate, maxDate])
      y.domain(categories)

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        // .tickFormat(d3.timeFormat("%b"))
        .tickFormat(d3.timeFormat("%b %d"))
        .ticks(d3.timeMonth.every(1))
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "start")

      // Add the y Axis
      let yAxis = d3.axisLeft(y)
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .selectAll("text")
        .style("text-anchor", "end")
      // .attr("transform", "translate(20,0)")

      // Add bar cases
      let barWidth = 5
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", d => d.color)
        .attr("class", "bar")
        .attr("x", function(d) {
          return x(d.dateStart)
        })
        .attr("width", function(d) {
          return x(d.dateEnd) - x(d.dateStart)
        })
        .attr("y", function(d) {
          return y(d.category) + (y.bandwidth() - barWidth) / 2
        })
        .attr("height", `${barWidth}px`)

      // Add todays line
      svg
        .append("svg:line")
        .attr("class", "line")
        .attr("x1", x(new Date()))
        .attr("y1", y(0))
        .attr("x2", x(new Date()))
        .attr("y2", height)
        .style("stroke", "blue")
        .style("stroke-width", 2)
        .style("stroke-dasharray", "3, 3")

      // Define tooltip
      d3.select("#reopeningStatusChart .tooltip-label")
      var tooltip = d3
        .select("#reopeningStatusChart")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select("#reopeningStatusChart")
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      let stopSymbol = {
        filter: d => d.status.toLowerCase() == "closed",
        statusDisplay: "Closed",
        data: [
          { x: 8.878, y: 0 },
          { x: 21.213, y: 0 },
          { x: 30.0, y: 8.878 },
          { x: 30.0, y: 21.213 },
          { x: 21.213, y: 30.0 },
          { x: 8.878, y: 30.0 },
          { x: 0, y: 21.213 },
          { x: 0, y: 8.878 }
        ],
        color: red,
        hoverColor: red,
        curveFn: d3.curveLinear
      }

      let warningSymbol = {
        filter: d =>
          d.status.toLowerCase() == "open" &&
          d.statusColor.toLowerCase() != "green",
        statusDisplay: "Open with restrictions",
        data: [
          { x: 15, y: 3 },
          { x: 30, y: 28.98 },
          { x: 0, y: 28.98 }
        ],
        color: yellow,
        hoverColor: yellow,
        curveFn: d3.curveLinear
      }

      let okSymbol = {
        filter: d =>
          d.status.toLowerCase() == "open" &&
          d.statusColor.toLowerCase() == "green",
        statusDisplay: "Open",
        data: [
          { x: 10, y: 0 },
          { x: 20, y: 0 },
          { x: 30, y: 10 },
          { x: 30, y: 20 },
          { x: 20, y: 30 },
          { x: 10, y: 30 },
          { x: 0, y: 20 },
          { x: 0, y: 10 },
          { x: 10, y: 0 }
        ],
        color: green,
        hoverColor: green,
        curveFn: d3.curveMonotoneX
      }

      let drawSymbols = function(instructions) {
        var lineFn = d3
          .line()
          .x(function(d, i) {
            return d.x
          })
          .y(function(d) {
            return d.y
          })
          .curve(instructions.curveFn)

        // Add dots on average
        let scale = 0.5
        svg
          .selectAll(".dot")
          .data(data.filter(instructions.filter))

          .enter()
          .append("path")
          .attr("transform", d => {
            return (
              "translate(" +
              (x(d.dateStart) - (30 * scale) / 2) +
              "," +
              (y(d.category) +
                (y.bandwidth() - barWidth) / 2 -
                (30 * scale) / 2 +
                barWidth / 2) +
              ")scale(0.5)"
            )
          })
          .on("mouseover", function(d) {
            d3.select(this).attr("fill", instructions.hoverColor)
            showTooltip(
              `<b>${d3.timeFormat("%b %d")(d.dateStart)}</b><br>${
                instructions.statusDisplay
              }`
            )
          })
          .on("mouseout", function(d) {
            d3.select(this).attr("fill", instructions.color)
            hideTooltip()
          })
          // .datum(instructions.data)
          .attr("fill", instructions.color)
          .attr("stroke", "none")
          .attr("d", lineFn(instructions.data))
        //   .append("circle")
        // .attr("class", "dot")
        // .attr("fill", lineColor)
        // .attr("cx", function(d, i) { return x(d.dateStart) })
        // .attr("cy", function(d) { return y(d.category) + ((y.bandwidth() - barWidth) / 2) })
        // .attr("r", 3)
      }

      drawSymbols(stopSymbol)
      drawSymbols(warningSymbol)
      drawSymbols(okSymbol)
    },


    // updateTestSitesTable: function() {
    //   let profile = d3.select(".county-profile")

    //   let criteriaInfo = [
    //     // { toggleSelector: '.mustFallUnderGuidelines', filter: site => site.MustFallUnderGuidelines === false },
    //     // { toggleSelector: '.mustBeRiskPatient', filter: site => site.MustBeRiskPatient === false },
    //     {
    //       toggleSelector: ".prescriptionRequired",
    //       filter: site => site["Referral Required"] === "No",
    //     },
    //     {
    //       toggleSelector: ".needAppointment",
    //       filter: site => site["Appointment Only"] === "No",
    //     },
    //     {
    //       toggleSelector: ".antibodyTest",
    //       filter: site => site["antibodyTest"] === "Yes",
    //     }
    //     // { toggleSelector: '.mustBePatient', filter: site => site.MustBePatient === false },
    //   ]

    //   // Filter by criteria
    //   let criteriaFilters = criteriaInfo.filter(info =>
    //     $(info.toggleSelector).hasClass("selected")
    //   )
    //   let sites = mainData.countyTestSites
    //   criteriaFilters.forEach(info => {
    //     sites = sites.filter(s => info.filter(s))
    //   })

    //   let shownTestSiteColumns = [
    //     {
    //       label: "Name",
    //       name: "Name",
    //       html: d =>
    //         `<i class="test-site-icon material-icons">lens</i>&nbsp;&nbsp;<span class='site-name'>${d["Name of Facility"]}</span>`
    //     },
    //     {
    //       class: "toggle-header",
    //       label:
    //         "<i class='material-icons criteria-toggle-header' data-criteria-toggle='prescriptionRequired'>list_alt</i>",
    //       name: "Referral Required"
    //     },
    //     {
    //       class: "toggle-header",
    //       label:
    //         "<i class='material-icons criteria-toggle-header' data-criteria-toggle='needAppointment'>event_available</i>",
    //       name: "Appointment Only"
    //     },
    //     {
    //       class: "toggle-header",
    //       label:
    //         "<i class='material-icons criteria-toggle-header' data-criteria-toggle='antibodyTest'>science</i>",
    //       name: "antibodyTest"
    //     },
    //     { label: "Contact", name: "Phone" }
    //   ]
    //   let onlyShownForTestSite = d => {
    //     let values = _.map(shownTestSiteColumns, col => ({
    //       html: col.html ? col.html(d) : d[col.name],
    //       class: col.class
    //     }))
    //     return values
    //   }

    //   profile
    //     .select("#testSitesTable")
    //     .selectAll("tr")
    //     .remove()
    //   profile
    //     .select("#testSitesTable")
    //     .append("tr")
    //     .attr("class", "header")
    //     .selectAll("th")
    //     .data(shownTestSiteColumns)
    //     .enter()
    //     .append("th")
    //     .attr("class", d => d.class)
    //     .html(d => d.label)
    //   let trTestSite = profile
    //     .select("#testSitesTable")
    //     .selectAll("tr.site")
    //     .data(sites)
    //     .enter()
    //     .append("tr")
    //     .on("click", d => {
    //       this.profilePanel = 2
    //       setTimeout(() => this.displayTestSiteProfile(d))
    //     })
    //   trTestSite.attr("class", "site")
    //   trTestSite
    //     .selectAll("td")
    //     .data((d, i) => onlyShownForTestSite(d))
    //     .enter()
    //     .append("td")
    //     .attr("class", d => d.class)
    //     .html(d => d.html)
    // },

    // updateClinicalTrialsTable: function() {
    //   let profile = d3.select(".county-profile")

    //   let criteriaInfo = [
    //     {
    //       toggleSelector: ".mustBeCovidPositive",
    //       filter: site => site["COVID-positive"] === "Yes",
    //     },
    //     {
    //       toggleSelector: ".hasCompensation",
    //       filter: site => site["Compensation (USD)"] && site["Compensation (USD)"] != "Unavailable",
    //     },
    //   ]
   

    //   // Filter by criteria
    //   let criteriaFilters = criteriaInfo.filter(info =>
    //     $(info.toggleSelector).hasClass("selected")
    //   )
    //   let sites = mainData.countyTrialSites
    //   criteriaFilters.forEach(info => {
    //     sites = sites.filter(s => info.filter(s))
    //   })

  
    //   let shownTrialSiteColumns = [
    //     {
    //       label: "Name",
    //       name: "Trial Name",
    //       html: d =>
    //         `<i class="trial-site-icon material-icons">lens</i>&nbsp;&nbsp;<span class='site-name'>${d["Trial Name"]}</span>`
    //     },
    //     { label: "City", name: "City" },
    //     {
    //       class: "toggle-header",
    //       label:
    //         "<i class='material-icons criteria-toggle-header' data-criteria-toggle='mustBeCovidPositive'>coronavirus</i>",
    //       name: "COVID-positive"
    //     },
    //     {
    //       class: "toggle-header",
    //       label:
    //         "<i class='material-icons criteria-toggle-header' data-criteria-toggle='hasCompensation'>attach_money</i>",
    //       name: "Compensation (USD)"
    //     },
    //   ]
    //   let onlyShownForTrialSite = d => {
    //     let shown = {}
    //     shownTrialSiteColumns.forEach(
    //       col => (shown[col.name] = col.html ? col.html(d) : d[col.name])
    //     )
    //     return shown
    //   }

 
    //   profile
    //     .select("#trialSitesTable")
    //     .selectAll("tr")
    //     .remove()
    //   profile
    //     .select("#trialSitesTable")
    //     .append("tr")
    //     .attr("class", "header")
    //     .selectAll("th")
    //     .data(shownTrialSiteColumns)
    //     .enter()
    //     .append("th")
    //     .html(d => d.label)
    //   let trTrialSite = profile
    //     .select("#trialSitesTable")
    //     .selectAll("tr.site")
    //     .data(sites)
    //     .enter()
    //     .append("tr")
    //   .on("click", d => {
    //     this.profilePanel = 3
    //     setTimeout(() => this.displayTrialSiteProfile(d))
    //   })

    //   trTrialSite.attr("class", "site")
    //   trTrialSite
    //     .selectAll("td")
    //     .data((d, i) => Object.values(onlyShownForTrialSite(d)))
    //     .enter()
    //     .append("td")
    //     .html(d => d)
    // },

    // displayTestSiteProfile: function(testSite) {
    //   let profile = d3
    //     .select(".test-site-profile .site-info")
    //     .html(testSiteProfileHtml(testSite))

    //   // Display
    //   this.profile.showTestSites = true
    //   this.profile.showClinicalTrials = false
    //   // d3.select(".test-site-profile").style("display", "block")
    //   // d3.select(".trial-site-profile").style("display", "none")

    //   // Collapse
    //   // $(".accordion #collapseTestSite").collapse("show")
    // },

    // displayTrialSiteProfile: function(trialSite) {
    //   let profile = d3
    //     .select(".trial-site-profile .site-info")
    //     .html(clinicalProfileHtml(trialSite))

    //   // Display
    //   this.profile.showTestSites = false
    //   this.profile.showClinicalTrials = true
    //   // d3.select(".test-site-profile").style("display", "none")
    //   // d3.select(".trial-site-profile").style("display", "block")

    //   // Collapse
    //   // $(".accordion #collapseTrialSite").collapse("show")
    // },

    fullReset() {
      // testSitesShown = false
      // clinicalTrialsShown = false
      // this.toggleTestSites()
      // this.toggleClinicalTrials()
      this.reset()

      this.level = "state"
      this.mode = "travel"
      this.relativeToState = false

      d3.select("#resetBtn").style("display", "none")
      this.showHint = true
    },
    resetRotation() {

      this.rotateGlobe(true)
    },
    animatePlanes() {

      function transition(plane, pathNode) {
        var l = pathNode.getTotalLength();
        plane.transition()
          .duration(5000)
          .attrTween("transform", delta(pathNode));
      }
      function delta(path) {
        var l = path.getTotalLength();
        return function(i) {
          return function(t) {
            var p = path.getPointAtLength(t * l);
            var t2 = Math.min(t + 0.05, 1);
            var p2 = path.getPointAtLength(t2 * l);

            var x = p2.x - p.x;
            var y = p2.y - p.y;
            var r = 90 - Math.atan2(-y, x) * 180 / Math.PI;

            var s = Math.min(Math.sin(Math.PI * t) * 0.7, 0.3);
            // return `translate(${p.x + 30},${p.y + 30}) rotate(` + r + `)`;
            return `translate(${p.x + 0},${p.y - 0}) scale(` + s + `) rotate(` + r + `)`;
            // return "translate(" + p.x + "," + p.y + ") rotate(" + r + ")";
            // var p = path.getPointAtLength(t * l);
            // return "translate(" + p.x + "," + p.y + ")";
          }
        }
      }

      d3.selectAll(".map-frame .plane").remove()

      let svg = d3.select(".map-frame g#planes")
      svg.selectAll("path")
        .nodes().forEach(pathNode => {

          let plane = svg.append("path")
            .attr("class", "plane")
            .attr("d", "m25.21488,3.93375c-0.44355,0 -0.84275,0.18332 -1.17933,0.51592c-0.33397,0.33267 -0.61055,0.80884 -0.84275,1.40377c-0.45922,1.18911 -0.74362,2.85964 -0.89755,4.86085c-0.15655,1.99729 -0.18263,4.32223 -0.11741,6.81118c-5.51835,2.26427 -16.7116,6.93857 -17.60916,7.98223c-1.19759,1.38937 -0.81143,2.98095 -0.32874,4.03902l18.39971,-3.74549c0.38616,4.88048 0.94192,9.7138 1.42461,13.50099c-1.80032,0.52703 -5.1609,1.56679 -5.85232,2.21255c-0.95496,0.88711 -0.95496,3.75718 -0.95496,3.75718l7.53,-0.61316c0.17743,1.23545 0.28701,1.95767 0.28701,1.95767l0.01304,0.06557l0.06002,0l0.13829,0l0.0574,0l0.01043,-0.06557c0,0 0.11218,-0.72222 0.28961,-1.95767l7.53164,0.61316c0,0 0,-2.87006 -0.95496,-3.75718c-0.69044,-0.64577 -4.05363,-1.68813 -5.85133,-2.21516c0.48009,-3.77545 1.03061,-8.58921 1.42198,-13.45404l18.18207,3.70115c0.48009,-1.05806 0.86881,-2.64965 -0.32617,-4.03902c-0.88969,-1.03062 -11.81147,-5.60054 -17.39409,-7.89352c0.06524,-2.52287 0.04175,-4.88024 -0.1148,-6.89989l0,-0.00476c-0.15655,-1.99844 -0.44094,-3.6683 -0.90277,-4.8561c-0.22699,-0.59493 -0.50356,-1.07111 -0.83754,-1.40377c-0.33658,-0.3326 -0.73578,-0.51592 -1.18194,-0.51592l0,0l-0.00001,0l0,0z");
            
          transition(plane, pathNode)
        })
    },
    drawPlanePath() {

      // Curve generator
      // var curve = d3.line().curve(d3.curveBasis)
      var curve = d3.line()
        .x(window.proj)
        .y(window.proj)

      // Get state center
      let failoverCenters = _.chain(mainData.states)
        .mapKeys(d => d.properties.name)
        .mapValues(d => {
          let coords = d.geometry.coordinates[0]
          while (coords.length && coords[0].length) coords = coords[0]
          return coords
        })
        .value()
      // if (!window.centers) window.centers = []
      // window.centers = failoverCenters.map((v, ix) => {
      //   window.centers[ix] || v
      // })
      // console.log({centers: window.centers})
      let point = (d) => {
        let state = d.properties.name
        // let coordinates = _.find(window.centers, (c, ix) => ix == state)
        let coordinates = _.chain(window.newCenters)
          .filter(d => d.name == state)
          .map(d => d.center)
          .value()[0]

        return coordinates || d.geometry.coordinates[0][0]
      }


      let state = this.fromCountry
      let stateData = mainData.states.find(d => d.properties.name == state)

      var lineThroughGlobe = function(d) {
        if (!d) return null
        return window.path({"type": "LineString", "coordinates": [(point(stateData)), (point(d))]});
      }

      // Draw plane paths
      d3.select(".map-frame svg")
        .select("g#planes")
        .selectAll("path").attr("d", lineThroughGlobe);
        

    },
    // TODO: remove
    drawPlanePath2() {

      // Curve generator
      var curve = d3.line().curve(d3.curveBasis)

      // Get state center
      let failoverCenters = _.chain(mainData.states)
        .mapKeys(d => d.properties.name)
        .mapValues(d => {
          let coords = d.geometry.coordinates[0]
          while (coords.length && coords[0].length) coords = coords[0]
          return coords
        })
        .value()
      // if (!window.centers) window.centers = []
      // window.centers = failoverCenters.map((v, ix) => {
      //   window.centers[ix] || v
      // })
      // console.log({centers: window.centers})
      let point = (d) => {
        let state = d.properties.name
        // let coordinates = _.find(window.centers, (c, ix) => ix == state)
        let coordinates = _.chain(window.newCenters)
          .filter(d => d.name == state)
          .map(d => d.center)
          .value()[0]

        return coordinates || d.geometry.coordinates[0][0]
      }

      
      // Add plane animation
      let planePath = (p1, p2) => {
        // return [p1, p2]
        let c = 20
        let dx = Math.abs(
          c * (
            (
              p2[1] - p1[1]
            ) /
            (
              Math.sqrt(
                Math.pow(p2[1] - p1[1],2)
                +
                Math.pow(p2[0] - p1[0],2)
              )
            )
          )
        );
        let dy = -Math.abs(
          c * (
            (
              p2[0] - p1[0]
            ) /
            (
              Math.sqrt(
                Math.pow(p2[1] - p1[1],2)
                +
                Math.pow(p2[0] - p1[0],2)
              )
            )
          )
        );
        // if (p1[0] > p2[0] && p1[1] > p2[1]) dx = -dx
        if (p1[0] < p2[0] && p1[1] > p2[1]) dx = -dx
        if (p1[0] > p2[0] && p1[1] < p2[1]) dx = -dx
        // if (p1[0] < p2[0] && p1[1] < p2[1]) dx = -dx
        let x = (p1[0] + p2[0]) / 2 + dx;
        let y = (p1[1] + p2[1]) / 2 + dy;
        let pm = [x,y]
        return [p1, pm, p2]
      }
      
        

      let state = this.fromCountry
      let stateData = mainData.states.find(d => d.properties.name == state)

      // Draw plane paths
      d3.select(".map-frame svg")
        .select("g#planes")
        .selectAll("path").attr("d", d => {
          if (!d) return;
          let points = planePath(point(stateData), point(d))
          let c = points;
          c = c.map(d => window.proj(d))
          c = curve(c)
          return c
        });
        

    },
    rotateGlobe(animate, x, y) {

      let rotateTo = (x, y) => {

        let rotation = window.proj.rotate()
        rotation[0] = x
        rotation[1] = y
        window.proj.rotate(rotation);
        
        // Redraw map
        d3.select(".map-frame svg")
          .select("g#states")
          .selectAll("path").attr("d", window.path)

        this.drawPlanePath()
      }

      x = x || 90
      y = y || -23.5

      if (!animate) {
        rotateTo(x, y)

      } else {
        // Animate rotation
        // TODO: Perform correct rotation when passing 24h longitude
        let steps = 8
        let ms = 400
        let current = window.proj.rotate()

        let xScale = scaleEaseQuadInOut([1,steps], [current[0], x])
        let yScale = scaleEaseQuadInOut([1,steps], [current[1], y])

        let i = 1
        let interval = setInterval(() => {
          console.log([xScale(i), yScale(i)])
          rotateTo(xScale(i), yScale(i))
          i++
          if (i == steps) {
            clearInterval(interval)
          }
        }, ms / steps)

      }
    },
    reset() {

      this.resetRotation()

      // this.currentCountyId = null
      this.fromCountry = "United States of America"
      this.search = ""

      d3.select("#zoomOutBtn").style("display", "none")
      d3.select("#legendTitle").text(`Legend`)


      d3.select("#legendTestSites").select("text").text(`Test Sites`)
      d3.select("#legendClinicalTrials").select("text").text(`Clinical Trials`)

      const legend = d3
        .select("#legend")
        .transition()
        .duration(750)
        .attr("transform", "translate(723,333)scale(0.8)")
      d3.select("#legend #frame")
        .transition()
        .duration(750)
        .attr("height", 200)
      d3.select("#legend #reopening").style("display", "none")

      // this.setBreadcrumb("map")
      let svg = d3.select("g#country")


      // Reset zoom
      const mainSvg = d3.select(".map-frame svg")
      let width = viewBox.width
      let height = viewBox.height
      mainSvg
        .transition()
        .duration(750)
        .call(
          zoom.transform,
          d3.zoomIdentity,
          d3.zoomTransform(mainSvg.node()).invert([width / 2, height / 2])
        )

      // resize dots
      d3.selectAll("g#testSites circle")
        .transition()
        .delay(100)
        .duration(750)
        .attr("r", `1.5px`)

      d3.selectAll("g#clinicalTrials circle")
        .transition()
        .delay(100)
        .duration(750)
        .attr("r", `1.5px`)

      // avoid choosing county
      d3.selectAll("g#states path").attr("fill", "#0000")

      // Display
      this.profilePanel = null
      this.profile.showProfile = false
      this.profile.showState = false
      this.profile.showCounty = false
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = false
    },

    wrap: function(text, width) {
      text.each(function() {
        let text = d3.select(this),
          words = text
            .text()
            .split(/\s+/)
            .reverse(),
          word,
          line = [],
          lineNumber = 0,
          lineHeight = 1.1, // ems
          x = text.attr("x"),
          y = text.attr("y"),
          dy = 1.1,
          tspan = text
            .text(null)
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", dy + "em")
        while ((word = words.pop())) {
          line.push(word)
          tspan.text(line.join(" "))
          if (tspan.node().getComputedTextLength() > width) {
            line.pop()
            tspan.text(line.join(" "))
            line = [word]
            tspan = text
              .append("tspan")
              .attr("x", x)
              .attr("y", y)
              .attr("dy", ++lineNumber * lineHeight + dy + "em")
              .text(word)
          }
        }
      })
    },

    color2: (function(d3) {
      const values = [1] // relative to state
      const max = Math.max(0, ...values)
      return d3
        .scaleSqrt()
        .domain([-max, 0, max])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateBlues(1 - t) : t => d3.interpolateReds(t)
        )
    })(d3),

    colorCases: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateBlues(1 - t) : t => d3.interpolateReds(t)
        )
    })(d3),

    colorActiveCases: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0
            ? t => d3.interpolateBlues(1 - t)
            : t => d3.interpolatePuRd(t)
        )
    })(d3),

    colorDeaths: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateReds(1 - t) : t => d3.interpolateBlues(t)
        )
    })(d3),

    colorChange: (function(d3) {
      let interpolateDanger = d3.interpolateRgbBasis([
        "rgb(255,255,255)",
        // "rgb(255,255,0)",
        "rgb(255,128,0)",
        "rgb(255,0,0)"
      ])
      return d3
        .scaleLinear()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0
            ? t => d3.interpolateGreens(1 - t)
            : // : t => d3.interpolateRgbBasis(["white", "yellow", "red"])(t))
              t => interpolateDanger(t)
        )
    })(d3)
  }
}
</script>

<style lang="scss">
// TODO: support scoped

.covid-map-travel {
  .checkbox-filter {
    i.material-icons {
      font-size: 24px !important;
    }
    label {
      font-weight: normal !important;
    }
  }
  // .show-description {
  //   cursor: pointer;
  //   // display: block;
  //   // width: 100%;
  //   // white-space: nowrap;
  //   // overflow: hidden;
  //   // text-overflow: ellipsis;
  // }
  // .hide-description {
  //   cursor: pointer;
  //   display: block;
  //   width: 100px;
  //   max-height: 23px;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }

@-webkit-keyframes uparrow {
  0% {
    -webkit-transform: translateY(0);
    opacity: 0.4;
  }
  100% {
    -webkit-transform: translateY(-0.4em);
    opacity: 0.9;
  }
}
@-webkit-keyframes downarrow {
  0% {
    -webkit-transform: translateY(0);
    opacity: 0.4;
  }
  100% {
    -webkit-transform: translateY(0.4em);
    opacity: 0.9;
  }
}

.toolbar .v-btn .v-btn__content {
  text-transform: none;
}

.no-br {
  white-space: nowrap;
}

.v-text-field.search-box {
  i.material-icons {
    color: grey;
    font-size: 24px;
  }
  label {
    font-weight: normal;
  }
}
.v-data-table .v-data-footer {
  i.material-icons {
    color: rgba(0, 0, 0, 0.54)
  }
}

.main.travel-restrictions {
  .origin {
    // color: #0088ff;
    color: #2aa8db;
  }
  .open {
    // color: #43c543;
    color: #44d378;
  }
  .closed {
    color: #c54343;
  }
  .restricted {
    color: #c5c443;
  }
  .unknown {
    color: #b6b6b6
  }
}
g#states {
  .origin {
    // fill: #0088ff;
    fill: #2aa8db;
  }
  .open {
    // fill: #43c543;
    fill: #36d16e;
  }
  .closed {
    fill: #c54343;
  }
  .restricted {
    fill: #c5c443;
  }
  .unknown {
    fill: #b6b6b6
  }
}
.plane {
  fill: #f0f7ff;
}

.container {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  text-align: center;
}
// .arrow {
//   border-color: transparent;
//   border-style: solid;
//   border-width: 0 2em;
//   display: block;
//   height: 0;
//   // position: absolute;

//   margin: 0;
//   opacity: 0.4;
//   text-indent: -9999px;
//   transform-origin: 50% 50%;
//   width: 0;
// }
.up {
  -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;
  border-bottom: 2em solid #00b6f1;
}
.down {
  -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;
  border-top: 2em solid #00b6f1;
}

#covid-map {
  color: #333;
}

// .last-updated {
//   color: #333;
//   font-size: 12px;
//   padding: 0 6px 3px;
//   text-align: right;
// }

.mode-toggle {
  background: none !important;
  .v-btn {
    width: 70px;
    min-width: 70px !important;
  }
  .v-btn__content {
    white-space: normal;
    width: 100%;
    text-align: center;
    line-height: 1;
  }
}
#app button.v-btn.v-btn--contained.theme--dark.v-size--default {
    border-color: white !important;
}
.bc li a:after {
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  border-left: 20px solid hsla(212, 85%, 35%, 1);
  top: 133%;
  left: 97%;
}
.bc li a:before {
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  margin-top: -30px;
  margin-left: 1px;
}

html.only-profile .site-toggles,
html.only-profile .map-frame,
html.only-profile .controls,
html.only-profile .bc-wrapper {
  display: none;
}
html:not(.only-profile) .combos {
  display: none;
}
html {
  font-family: "Roboto", sans-serif;
}
#bc-map .material-icons {
  position: absolute;
  font-size: 20px;
  line-height: 25px;
}
.map-frame .map-bottom {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 4;
}
.main-instructions { 
  color: white; 
}
.map-frame .zoom-out-btn {
  display: none;
  font-size: 12px;
  border: 1px solid hsl(212, 85%, 45%);
  color: hsl(212, 85%, 45%);
  background: #eeeeff;
  padding: 0px 3px;
  border-radius: 3px;
  text-decoration: none !important;
}

.map-frame .only-hint {
  position: absolute;
  z-index: 4;
  top: 170px;
  padding-left: 6px;
  color: #f7f7f7;
  margin-top: 2px;
  font-size: 23px;
  vertical-align: bottom;
  display: inline-block;
  line-height: 1.1;
  padding-bottom: 2px;
  width: 100%;
  display: block;
  text-align: center;
  text-shadow: -1px 3px 4px black;
  font-weight: 700;
}
.map-frame .zoom-out-btn i {
  vertical-align: middle;
}
.map-frame .hint {
  opacity: 0;
  padding-left: 6px;
  color: #f7f7f7;
  margin-top: 2px;
  font-size: 14px;
  vertical-align: bottom;
  display: inline-block;
  line-height: 1.1;
  padding-bottom: 2px;
}

.play-btn {
  font-size: 12px;
  /* border: 1px solid hsl(212, 85%, 45%); */
  border: 1px solid #ccccff;
  background: #eeeeff;
  /* border: 1px solid #ccc;
  background: #eee; */
  padding: 2px 9px;
  border-radius: 3px;
  text-decoration: none;
  display: flex;
  cursor: pointer;
}
.play-btn .material-icons {
  font-size: 21px;
  color: hsl(212, 85%, 45%);
}

.criteria-toggle {
  color: #99c6e0;
}
.criteria-toggle:hover {
  font-size: 14px;
  cursor: pointer;
  color: hsl(224, 89%, 51%);
}
.criteria-toggle.selected {
  text-decoration: line-through;
  color: #447adc;
}
.criteria-toggle.selected.antibodyTest,
.criteria-toggle.selected.mustBeCovidPositive,
.criteria-toggle.selected.hasCompensation {
  text-decoration: none;
  color: #447adc;
}
.group .criteria-toggle i.material-icons {
  font-size: 14px;
  color: #99c6e0;
}
.group .criteria-toggle:hover i.material-icons {
  font-size: 14px;
  color: hsl(224, 89%, 51%);
}

.more-info {
  vertical-align: middle;
  max-width: 19px;
  position: relative;
  left: -5px;
  display: inline-block;
}

.group .more-info i.material-icons {
  color: #265794;
  font-size: 18px;
}

.criteria-toggle.selected i.material-icons {
  color: #447adc;
}
.criteria-toggles {
  display: flex;
  width: 100%;
}
.criteria-toggles .group {
  flex-grow: 1;
}
.criteria-toggle-header {
  cursor: pointer;
  color: hsl(212, 85%, 45%);
}
.site-name {
  color: hsl(224, 89%, 51%);
}
.header .icon-box {
  display: inline-block;
}
.header .icon-box .icon i.material-icons,
.header .icon-box .icon span {
  font-size: 14px;
  vertical-align: middle;
  color: #6d6d6d;
}
.icon-box .icon i,
.icon-box .icon i.material-icons {
  font-size: 20px;
  color: #999;
}
.icon-box .icon span {
  display: inline-block;
  height: 21px;
  vertical-align: text-bottom;
  color: #636363;
}
.icon {
  min-width: 100px;
  display: inline-block;
  white-space: nowrap;
  padding: 0 8px;
  text-align: center;
}
.box {
  text-align: center;
}

.profiles {
  max-width: 980px;
  width: 100%;
  margin: 10px auto 20px auto;
}
.accordion {
  border-radius: 4px;
}
.accordion .card-body {
  padding-top: 20px;
  padding-bottom: 20px;
}
.accordion .card,
.accordion .card-body,
.accordion .card-header {
  border: none;
}
.accordion h2 {
  color: white;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  padding: 8px 12px;
  margin-top: 0;
}
.accordion .state-profile {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion .state-profile .card-header {
  min-height: 35px;
  background: hsla(212, 85%, 45%, 0.8);
}
.accordion .county-profile .card-header {
  min-height: 35px;
  background: hsla(212, 85%, 55%, 0.8);
}
.accordion .test-site-profile .card-header,
.accordion .trial-site-profile .card-header {
  min-height: 35px;
  background: hsla(212, 85%, 65%, 0.8);
}
.opening-status {
  position: relative;
}
.opening-status .date {
  position: absolute;
  top: -40px;
  left: -30px;
  background: #c8d5e0d1;
  border-radius: 3px;
  padding: 4px 8px;
  display: none;
  border: 1px solid #b5b5b5;
  white-space: nowrap;
  max-width: 300px;
}
.opening-status:hover .date {
  display: inline-block;
}
.opening-status i.green {
  color: #3bd23b;
}
.opening-status i.yellow {
  color: #d2c63b;
}
.opening-status i.red {
  color: #e03131;
}
.hidden-detail {
  color: #777;
  position: relative;
  overflow: hidden;
  display: block;
  height: 20px;
}
.hidden-detail:hover {
  overflow: visible;
}
.hidden-detail > span {
  position: absolute;
  padding: 0px 8px;
}
.hidden-detail > span i {
  font-size: 12px;
  vertical-align: middle;
}
.hidden-detail:hover > span {
  background: #ffffff;
  z-index: 1;
  color: #333;
}
.record td:first-child {
  min-width: 140px;
}
.record td + td + td {
  width: 100%;
}

.test-site-icon {
  color: #89c0d7;
  font-size: 10px;
}
.cases-icon {
  background: #888;
  width: 10px;
  height: 10px;
  display: inline-block;
}
.trial-site-icon {
  // color: #da87da;
  color: #73d473;
  font-size: 10px;
}
.site-toggles {
  max-width: 980px;
  margin: 0 auto;
  padding: 0;
  text-align: right;
  display: flex;
  position: relative;
}
.bc-wrapper {
  max-width: 980px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
}
#bc-map .material-icons {
  position: absolute;
  font-size: 19px;
}
.controls {
  max-width: 980px;
  width: 100%;
  margin: 0;
  background: #0042715e;
  // background: #00427138;
  border: none;
  border-radius: 0 0 0px 0px;
  color: white;
  position: relative;
}
.map-frame-wrapper {
  max-width: 980px;
  margin: 0 auto;
  width: 100%;
  position: relative;
}

.map-frame-wrapper .loading-map {
  color: white;
  width: 100%;
  position: absolute;
  top: 0;
  text-align: center;
  transform: translateY(-50%);
  top: 50%;
  // animation: blink 1s step-start 0s infinite;
}
.map-frame-wrapper .loading-map .flashing {
  animation: blink 2s ease-in-out infinite;
  // animation: blink 1s step-start 0s infinite;
}
@keyframes blink {
  0% { opacity: 1; }
  70% { opacity: 0; }
  100% { opacity: 1; }
}
.map-frame {
  padding-bottom: 60%;
  background: #104f829e;
  // background: #00427138;
  position: relative;
  width: 100%;
  overflow: hidden;
  border: 1px solid #cecece00;
  border-radius: 0;
}
// .map-frame .zoom-out-btn {
//   position: absolute;
//   bottom: 10px;
//   left: 10px;
//   display: none;
//   z-index: 10;

//   font-size: 12px;
//   border: 1px solid hsl(212, 85%, 45%);
//   color: hsl(212, 85%, 45%);
//   background: #eeeeff;
//   padding: 0px 3px;
//   border-radius: 3px;
//   text-decoration: none !important;
// }
.map-frame svg {
  position: absolute;
  width: 1000px;
  height: 1000px;
}
g#controls {
  circle {
    // fill: red !important;
    fill: #00000042;
    stroke: #9d97ff42;
  }
  .button-back {
    stroke: #ffffff77;
    stroke-width: 2;
    // fill: #2626ff77;
    fill: #2a62ee77;
  }
  .arrow {
    fill: #ffffff77;
  }
  .button {
    cursor: pointer;
  }

  &:hover {

    circle {
      fill: #000000aa;
      stroke: #9d97ffff;
    }
    .button-back {
      stroke: #ffffffaa;
      // fill: #2626ffcc;
      fill: #2a62eecc;
    }
    .arrow {
      fill: #ffffffaa;
    }
    .button:hover .button-back {
      stroke: #ffffff;
    }
    .button:hover .arrow {
      fill: #ffffff;
    }
  } 
}
.play-btn {
  font-size: 12px;
  /* border: 1px solid hsl(212, 85%, 45%); */
  border: none;
  background: #00000010;
  /* border: 1px solid #ccc;
  background: #eee; */
  padding: 2px 9px;
  border-radius: 3px;
  text-decoration: none;
  display: flex;
  cursor: pointer;
}
.play-btn .material-icons {
  font-size: 21px;
  color: hsl(212, 85%, 45%);
}
.play-btn:hover {
  color: white !important;
}

#reopeningStatusChart {
  overflow: hidden;
}

div.tooltip {
  position: absolute;
  width: 250px;
  padding: 10px;
  font: 12px sans-serif;
  background: white;
  border: 1px solid #3ab1ff;
  border-radius: 3px;
  pointer-events: none;
  z-index: 4;
}
div.tooltip label {
  font-weight: 700;
  margin-top: 7px;
}

.siteName {
  font-size: 1.3em;
  display: inline-block;
}
.location {
  display: inline-block;
  margin: 3px 0 10px 0;
}
.site-details {
  margin-top: 10px;
  width: 100%;
}
.site-details td,
.site-details th {
  padding: 5px;
  text-align: left;
}
table.stripped td,
table.stripped th {
  background: #f6f6f6;
}
table.stripped tr:nth-child(even) td,
table.stripped tr:nth-child(even) th {
  background: none;
}

.county-profile h2 {
  margin-bottom: 0;
}
.county-profile label {
  display: block;
  font-size: 0.85em;
}
.sites-table {
  font-size: 13px;
  width: 100%;
  margin: 15px 0;
}
.sites-table td,
.sites-table th {
  padding: 5px;
  text-align: left;
}
.sites-table .site {
  cursor: pointer;
}
.sites-table .site:hover td {
  background: #e8e8e8;
}

.ranges {
  position: relative;
  display: flex;
  padding: 0 5px 0 2px;
}
.ranges #myRange-top {
  position: absolute;
  opacity: 0;
}
.controls {
  display: flex;
}
.ranges {
  flex: 1 auto;
}
#date {
  font-size: 14px;
  padding: 2px 5px 2px 5px;
  width: 90px;
  display: block;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
}
.slider {
  width: 100%;
  cursor: pointer;
}

.bc {
  margin: 0;
  list-style: none;
  overflow: hidden;
  // font: 16px;
  padding: 0 !important;
  min-width: 900px;
}
.bc li {
  float: left;
}
.bc li a {
  color: white;
  text-decoration: none;
  padding: 8px 0 8px 55px;
  background: brown; /* fallback color */
  background: hsla(212, 85%, 35%, 1);
  position: relative;
  display: block;
  float: left;
}
.bc li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid hsla(212, 85%, 35%, 1);
  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 100%;
  z-index: 2;
}
.bc li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  margin-left: 1px;
  left: 100%;
  z-index: 1;
}
.bc li:first-child a {
  padding-left: 14px;
}
.bc li:nth-child(2) a {
  background: hsla(212, 85%, 45%, 1);
}
.bc li:nth-child(2) a:after {
  border-left-color: hsla(212, 85%, 45%, 1);
}
.bc li:nth-child(3) a {
  background: hsla(212, 85%, 55%, 1);
}
.bc li:nth-child(3) a:after {
  border-left-color: hsla(212, 85%, 55%, 1);
}
.bc li:nth-child(4) a {
  background: hsla(212, 85%, 65%, 1);
}
.bc li:nth-child(4) a:after {
  border-left-color: hsla(212, 85%, 65%, 1);
}
.bc li:nth-child(5) a {
  background: hsla(212, 85%, 75%, 1);
}
.bc li:nth-child(5) a:after {
  border-left-color: hsla(212, 85%, 75%, 1);
}
.bc li:last-child a {
  background: transparent !important;
  color: black;
  pointer-events: none;
  cursor: default;
}
.bc li:last-child a:after {
  border: 0;
}
.bc li a:hover {
  background: hsla(212, 85%, 25%, 1);
}
.bc li a:hover:after {
  border-left-color: hsla(212, 85%, 25%, 1) !important;
}

.reset-btn {
  font-size: 16px;
  text-decoration: none !important;
  display: none;
  background: #0a478e;
  color: white !important;
  padding: 8px 10px;
  border-radius: 0 0 0 0;
  white-space: nowrap;
}
.reset-btn:hover {
  background: #04366e;
}
.spacer {
  flex: 1 auto;
}
.toggle {
  margin-left: 3px;
  font-size: 12px;
  border: 1px solid #ccc;
  background: #eee;
  padding: 3px 7px;
  border-radius: 3px;
  text-decoration: none;
  color: #222;
  display: inline-block;
}
.toggle.on {
  background: #ccc;
}

h5.banner {
  background: #e8f3ff;
  padding: 4px 10px;
  margin: 0 -24px;
}
.banner.test-sites-banner {
  background: #7dbbd499;
  margin-bottom: 7px;
}
.banner.clinical-trials-banner {
  background: #73d47399;
  // background: #da87da99;
  margin-bottom: 7px;
}

#reopeningStatusChartWrapper {
  max-width: 850px;
  margin: 0 auto;
  width: 100%;
}
#reopeningStatusChart {
  padding-bottom: 35%;
  width: 100%;
}
#reopeningStatusChart > svg {
  position: absolute;
}

.stateCasesChartWrapper {
  max-width: 850px;
  margin: 0 auto;
  width: 100%;
}
.stateCasesChart {
  padding-bottom: 24%;
  width: 100%;
}
.stateCasesChart > svg {
  position: absolute;
}

#countyCasesChartWrapper {
  max-width: 850px;
  margin: 0 auto;
  width: 100%;
}
#countyCasesChart {
  padding-bottom: 24%;
  width: 100%;
}
#countyCasesChart > svg {
  position: absolute;
}

.stateCasesChart,
#countyCasesChart {
  overflow: hidden;
}

#reopeningStatusChart .x.axis .tick,
.stateCasesChart .tick,
#countyCasesChart .tick {
  visibility: hidden;
}
#reopeningStatusChart .x.axis .tick:nth-child(21n + 3) {
  visibility: visible;
}
.stateCasesChart .tick:nth-child(14n + 2),
#countyCasesChart .tick:nth-child(14n + 2) {
  visibility: visible;
}

.stateCasesChart,
#countyCasesChart {
  position: relative;
}
#reopeningStatusChart {
  position: relative;
}
.tooltip-label {
  position: absolute;
  min-width: 70px;
  padding: 4px;
  font: 10px sans-serif;
  background: white;
  border: 1px solid #3ab1ff;
  border-radius: 3px;
  pointer-events: none;
  line-height: 14px;
  z-index: 4;
}

.h1,h1{font-size:2.5rem}
.h2,h2{font-size:2rem}
.h3,h3{font-size:1.75rem}
.h4,h4{font-size:1.5rem}
.h5,h5{font-size:1.25rem}
.h6,h6{font-size:1rem}

.icon .material-icons {
  margin-right: 3px;
}

.group {
  font-size: 14px;
  padding-bottom: 8px;
}
.group h5 {
  background: #eaeaea;
  padding: 7px 12px;
  margin: 12px -24px 8px;
  font-size: 17px;
  line-height: 1;
}
.group h6 {
  padding: 0px 12px;
  margin: 0;
  display: inline-block;
}
.group label {
  font-weight: 700;
  margin-bottom: 4px;
}
.group .main {
  padding: 8px 0 4px;
  margin: 0 0 0 20px;
  min-height: 45px;
}
.group .box {
  border: 1px solid #bfe3ff;
  padding: 8px 16px 4px;
  border-radius: 3px;
  margin: 0 20px;
  font-size: 12px;
  background: #e2eef3;
}
.group .prohibited {
  border: 1px solid #e2e2cc;
  padding: 8px 16px 4px;
  border-radius: 3px;
  margin: 0 20px;
  font-size: 12px;
  background: #f3f3e2;
}
.group .prohibited .header {
  margin: 2px 0 12px 0;
  text-align: center;
  width: 100%;
  font-size: 1.2em;
  display: block;
}

.group table.requirements th,
.group table.requirements td {
  padding: 4px 8px;
}

.group table.requirements label {
  margin: 0;
}

.group table.requirements {
  text-align: center;
  font-size: 14px;
  margin: 5px auto 11px auto;
}

.group table.requirements tr:first-child {
  background: #f5f5f5;
}
.group table.requirements tr {
  border-bottom: 1px solid #e3e3e3;
}

.group table.requirements th:first-child {
  min-width: 250px;
}

.group .source {
  float: right;
  padding: 0;
  font-size: 10px;
  margin-top: 10px;
  margin-right: -11px;
  text-align: right;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
.group .closed .material-icons {
  color: #e20000;
}
.group .open .material-icons {
  color: #329c00;
}
.group i.material-icons {
  // font-size: 12px;
  color: red;
  // color: #b3b3b3;
}
.group .main .openClose {
  padding-left: 12px;
  width: 46%;
  display: inline-block;
}
.summary {
  padding: 10px 8px;
  margin: 10px 0;
  font-size: 0.9em;
  border: 1px solid #dadada;
  border-radius: 3px;
  background: whitesmoke;
}

#field-executiveSummary {
  white-space: pre-wrap;
}

.toggle-header {
  text-align: center;
  width: 1px;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}

.highlight-prohibited,
.highlight-not-permitted,
.highlight-required,
.highlight-yes {
  color: #e20000;
}
.highlight-not-required,
.highlight-permitted,
.highlight-no {
  color: #03009c;
}
.highlight-recommended {
  color: #70009c;
}

.requirements th .icon-box {
  font-weight: normal;
}

.search {
  width: 300px;
  input {
    min-width: 1px !important;
  }
  .v-input__slot, .v-input__control {
    min-height: 28px !important;
  }
  .v-select__slot label {
    top: 4px!important;
  }
}


@media only screen and (max-width: 600px) {
  .map-frame .only-hint {
    font-size: 18px;
    top: 74px;
  }
  .map-frame-wrapper .loading-map {
    font-size: 0.7em;
  }
  .mode-toggle {
    .v-btn {
      width: initial;
    }
    .v-btn__content {
      white-space: nowrap;
    }
  }
  .group .main {
    margin: 0 -14px;
  }

  .group table.requirements th:first-child {
    min-width: 150px;
    width: 150px;
  }

  .group .source {
    max-width: 150px;
  }

  .map-frame .hint {
    font-size: 10px;
  }
  .map-frame .info-source {
    max-width: 221px;
  }

  .criteria-toggles .group {
    width: 100%;
    padding-bottom: 2px;
  }
}
}

</style>
